(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3852"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3852"] = parcelRequire;
}
parcelRequire.register("2ax5i", function(module, exports) {
(function(window1, factory) {
    var lazySizes = factory(window1, window1.document, Date);
    window1.lazySizes = lazySizes;
    if (0, module.exports) module.exports = lazySizes;
})(typeof window != "undefined" ? window : {}, /**
 * import("./types/global")
 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
 */ function l(window1, document, Date1) {
    "use strict";
    /*jshint eqnull:true */ var lazysizes, /**
		 * @type { LazySizesConfigPartial }
		 */ lazySizesCfg;
    (function() {
        var prop;
        var lazySizesDefaults = {
            lazyClass: "lazyload",
            loadedClass: "lazyloaded",
            loadingClass: "lazyloading",
            preloadClass: "lazypreload",
            errorClass: "lazyerror",
            //strictClass: 'lazystrict',
            autosizesClass: "lazyautosizes",
            fastLoadedClass: "ls-is-cached",
            iframeLoadMode: 0,
            srcAttr: "data-src",
            srcsetAttr: "data-srcset",
            sizesAttr: "data-sizes",
            //preloadAfterLoad: false,
            minSize: 40,
            customMedia: {},
            init: true,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
            loadHidden: true,
            ricTimeout: 0,
            throttleDelay: 125
        };
        lazySizesCfg = window1.lazySizesConfig || window1.lazysizesConfig || {};
        for(prop in lazySizesDefaults)if (!(prop in lazySizesCfg)) lazySizesCfg[prop] = lazySizesDefaults[prop];
    })();
    if (!document || !document.getElementsByClassName) return {
        init: function() {},
        /**
			 * @type { LazySizesConfigPartial }
			 */ cfg: lazySizesCfg,
        /**
			 * @type { true }
			 */ noSupport: true
    };
    var docElem = document.documentElement;
    var supportPicture = window1.HTMLPictureElement;
    var _addEventListener = "addEventListener";
    var _getAttribute = "getAttribute";
    /**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */ var addEventListener = window1[_addEventListener].bind(window1);
    var setTimeout = window1.setTimeout;
    var requestAnimationFrame = window1.requestAnimationFrame || setTimeout;
    var requestIdleCallback = window1.requestIdleCallback;
    var regPicture = /^picture$/i;
    var loadEvents = [
        "load",
        "error",
        "lazyincluded",
        "_lazyloaded"
    ];
    var regClassCache = {};
    var forEach = Array.prototype.forEach;
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var hasClass = function(ele, cls) {
        if (!regClassCache[cls]) regClassCache[cls] = new RegExp("(\\s|^)" + cls + "(\\s|$)");
        return regClassCache[cls].test(ele[_getAttribute]("class") || "") && regClassCache[cls];
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var addClass = function(ele, cls) {
        if (!hasClass(ele, cls)) ele.setAttribute("class", (ele[_getAttribute]("class") || "").trim() + " " + cls);
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var removeClass = function(ele, cls) {
        var reg;
        if (reg = hasClass(ele, cls)) ele.setAttribute("class", (ele[_getAttribute]("class") || "").replace(reg, " "));
    };
    var addRemoveLoadEvents = function(dom, fn, add) {
        var action = add ? _addEventListener : "removeEventListener";
        if (add) addRemoveLoadEvents(dom, fn);
        loadEvents.forEach(function(evt) {
            dom[action](evt, fn);
        });
    };
    /**
	 * @param elem { Element }
	 * @param name { string }
	 * @param detail { any }
	 * @param noBubbles { boolean }
	 * @param noCancelable { boolean }
	 * @returns { CustomEvent }
	 */ var triggerEvent = function(elem, name, detail, noBubbles, noCancelable) {
        var event = document.createEvent("Event");
        if (!detail) detail = {};
        detail.instance = lazysizes;
        event.initEvent(name, !noBubbles, !noCancelable);
        event.detail = detail;
        elem.dispatchEvent(event);
        return event;
    };
    var updatePolyfill = function(el, full) {
        var polyfill;
        if (!supportPicture && (polyfill = window1.picturefill || lazySizesCfg.pf)) {
            if (full && full.src && !el[_getAttribute]("srcset")) el.setAttribute("srcset", full.src);
            polyfill({
                reevaluate: true,
                elements: [
                    el
                ]
            });
        } else if (full && full.src) el.src = full.src;
    };
    var getCSS = function(elem, style) {
        return (getComputedStyle(elem, null) || {})[style];
    };
    /**
	 *
	 * @param elem { Element }
	 * @param parent { Element }
	 * @param [width] {number}
	 * @returns {number}
	 */ var getWidth = function(elem, parent, width) {
        width = width || elem.offsetWidth;
        while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
            width = parent.offsetWidth;
            parent = parent.parentNode;
        }
        return width;
    };
    var rAF = function() {
        var running, waiting;
        var firstFns = [];
        var secondFns = [];
        var fns = firstFns;
        var run = function() {
            var runFns = fns;
            fns = firstFns.length ? secondFns : firstFns;
            running = true;
            waiting = false;
            while(runFns.length)runFns.shift()();
            running = false;
        };
        var rafBatch = function(fn, queue) {
            if (running && !queue) fn.apply(this, arguments);
            else {
                fns.push(fn);
                if (!waiting) {
                    waiting = true;
                    (document.hidden ? setTimeout : requestAnimationFrame)(run);
                }
            }
        };
        rafBatch._lsFlush = run;
        return rafBatch;
    }();
    var rAFIt = function(fn, simple) {
        return simple ? function() {
            rAF(fn);
        } : function() {
            var that = this;
            var args = arguments;
            rAF(function() {
                fn.apply(that, args);
            });
        };
    };
    var throttle = function(fn) {
        var running;
        var lastTime = 0;
        var gDelay = lazySizesCfg.throttleDelay;
        var rICTimeout = lazySizesCfg.ricTimeout;
        var run = function() {
            running = false;
            lastTime = Date1.now();
            fn();
        };
        var idleCallback = requestIdleCallback && rICTimeout > 49 ? function() {
            requestIdleCallback(run, {
                timeout: rICTimeout
            });
            if (rICTimeout !== lazySizesCfg.ricTimeout) rICTimeout = lazySizesCfg.ricTimeout;
        } : rAFIt(function() {
            setTimeout(run);
        }, true);
        return function(isPriority) {
            var delay;
            if (isPriority = isPriority === true) rICTimeout = 33;
            if (running) return;
            running = true;
            delay = gDelay - (Date1.now() - lastTime);
            if (delay < 0) delay = 0;
            if (isPriority || delay < 9) idleCallback();
            else setTimeout(idleCallback, delay);
        };
    };
    //based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
    var debounce = function(func) {
        var timeout, timestamp;
        var wait = 99;
        var run = function() {
            timeout = null;
            func();
        };
        var later = function() {
            var last = Date1.now() - timestamp;
            if (last < wait) setTimeout(later, wait - last);
            else (requestIdleCallback || run)(run);
        };
        return function() {
            timestamp = Date1.now();
            if (!timeout) timeout = setTimeout(later, wait);
        };
    };
    var loader = function() {
        var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;
        var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;
        var regImg = /^img$/i;
        var regIframe = /^iframe$/i;
        var supportScroll = "onscroll" in window1 && !/(gle|ing)bot/.test(navigator.userAgent);
        var shrinkExpand = 0;
        var currentExpand = 0;
        var isLoading = 0;
        var lowRuns = -1;
        var resetPreloading = function(e) {
            isLoading--;
            if (!e || isLoading < 0 || !e.target) isLoading = 0;
        };
        var isVisible = function(elem) {
            if (isBodyHidden == null) isBodyHidden = getCSS(document.body, "visibility") == "hidden";
            return isBodyHidden || !(getCSS(elem.parentNode, "visibility") == "hidden" && getCSS(elem, "visibility") == "hidden");
        };
        var isNestedVisible = function(elem, elemExpand) {
            var outerRect;
            var parent = elem;
            var visible = isVisible(elem);
            eLtop -= elemExpand;
            eLbottom += elemExpand;
            eLleft -= elemExpand;
            eLright += elemExpand;
            while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
                visible = (getCSS(parent, "opacity") || 1) > 0;
                if (visible && getCSS(parent, "overflow") != "visible") {
                    outerRect = parent.getBoundingClientRect();
                    visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1;
                }
            }
            return visible;
        };
        var checkElements = function() {
            var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal, defaultExpand, preloadExpand, hFac;
            var lazyloadElems = lazysizes.elements;
            if ((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {
                i = 0;
                lowRuns++;
                for(; i < eLlen; i++){
                    if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) continue;
                    if (!supportScroll || lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i])) {
                        unveilElement(lazyloadElems[i]);
                        continue;
                    }
                    if (!(elemExpandVal = lazyloadElems[i][_getAttribute]("data-expand")) || !(elemExpand = elemExpandVal * 1)) elemExpand = currentExpand;
                    if (!defaultExpand) {
                        defaultExpand = !lazySizesCfg.expand || lazySizesCfg.expand < 1 ? docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 : lazySizesCfg.expand;
                        lazysizes._defEx = defaultExpand;
                        preloadExpand = defaultExpand * lazySizesCfg.expFactor;
                        hFac = lazySizesCfg.hFac;
                        isBodyHidden = null;
                        if (currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden) {
                            currentExpand = preloadExpand;
                            lowRuns = 0;
                        } else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) currentExpand = defaultExpand;
                        else currentExpand = shrinkExpand;
                    }
                    if (beforeExpandVal !== elemExpand) {
                        eLvW = innerWidth + elemExpand * hFac;
                        elvH = innerHeight + elemExpand;
                        elemNegativeExpand = elemExpand * -1;
                        beforeExpandVal = elemExpand;
                    }
                    rect = lazyloadElems[i].getBoundingClientRect();
                    if ((eLbottom = rect.bottom) >= elemNegativeExpand && (eLtop = rect.top) <= elvH && (eLright = rect.right) >= elemNegativeExpand * hFac && (eLleft = rect.left) <= eLvW && (eLbottom || eLright || eLleft || eLtop) && (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) && (isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4) || isNestedVisible(lazyloadElems[i], elemExpand))) {
                        unveilElement(lazyloadElems[i]);
                        loadedSomething = true;
                        if (isLoading > 9) break;
                    } else if (!loadedSomething && isCompleted && !autoLoadElem && isLoading < 4 && lowRuns < 4 && loadMode > 2 && (preloadElems[0] || lazySizesCfg.preloadAfterLoad) && (preloadElems[0] || !elemExpandVal && (eLbottom || eLright || eLleft || eLtop || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != "auto"))) autoLoadElem = preloadElems[0] || lazyloadElems[i];
                }
                if (autoLoadElem && !loadedSomething) unveilElement(autoLoadElem);
            }
        };
        var throttledCheckElements = throttle(checkElements);
        var switchLoadingClass = function(e) {
            var elem = e.target;
            if (elem._lazyCache) {
                delete elem._lazyCache;
                return;
            }
            resetPreloading(e);
            addClass(elem, lazySizesCfg.loadedClass);
            removeClass(elem, lazySizesCfg.loadingClass);
            addRemoveLoadEvents(elem, rafSwitchLoadingClass);
            triggerEvent(elem, "lazyloaded");
        };
        var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
        var rafSwitchLoadingClass = function(e) {
            rafedSwitchLoadingClass({
                target: e.target
            });
        };
        var changeIframeSrc = function(elem, src) {
            var loadMode = elem.getAttribute("data-load-mode") || lazySizesCfg.iframeLoadMode;
            // loadMode can be also a string!
            if (loadMode == 0) elem.contentWindow.location.replace(src);
            else if (loadMode == 1) elem.src = src;
        };
        var handleSources = function(source) {
            var customMedia;
            var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);
            if (customMedia = lazySizesCfg.customMedia[source[_getAttribute]("data-media") || source[_getAttribute]("media")]) source.setAttribute("media", customMedia);
            if (sourceSrcset) source.setAttribute("srcset", sourceSrcset);
        };
        var lazyUnveil = rAFIt(function(elem, detail, isAuto, sizes, isImg) {
            var src, srcset, parent, isPicture, event, firesLoad;
            if (!(event = triggerEvent(elem, "lazybeforeunveil", detail)).defaultPrevented) {
                if (sizes) {
                    if (isAuto) addClass(elem, lazySizesCfg.autosizesClass);
                    else elem.setAttribute("sizes", sizes);
                }
                srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
                src = elem[_getAttribute](lazySizesCfg.srcAttr);
                if (isImg) {
                    parent = elem.parentNode;
                    isPicture = parent && regPicture.test(parent.nodeName || "");
                }
                firesLoad = detail.firesLoad || "src" in elem && (srcset || src || isPicture);
                event = {
                    target: elem
                };
                addClass(elem, lazySizesCfg.loadingClass);
                if (firesLoad) {
                    clearTimeout(resetPreloadingTimer);
                    resetPreloadingTimer = setTimeout(resetPreloading, 2500);
                    addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
                }
                if (isPicture) forEach.call(parent.getElementsByTagName("source"), handleSources);
                if (srcset) elem.setAttribute("srcset", srcset);
                else if (src && !isPicture) {
                    if (regIframe.test(elem.nodeName)) changeIframeSrc(elem, src);
                    else elem.src = src;
                }
                if (isImg && (srcset || isPicture)) updatePolyfill(elem, {
                    src: src
                });
            }
            if (elem._lazyRace) delete elem._lazyRace;
            removeClass(elem, lazySizesCfg.lazyClass);
            rAF(function() {
                // Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
                var isLoaded = elem.complete && elem.naturalWidth > 1;
                if (!firesLoad || isLoaded) {
                    if (isLoaded) addClass(elem, lazySizesCfg.fastLoadedClass);
                    switchLoadingClass(event);
                    elem._lazyCache = true;
                    setTimeout(function() {
                        if ("_lazyCache" in elem) delete elem._lazyCache;
                    }, 9);
                }
                if (elem.loading == "lazy") isLoading--;
            }, true);
        });
        /**
		 *
		 * @param elem { Element }
		 */ var unveilElement = function(elem) {
            if (elem._lazyRace) return;
            var detail;
            var isImg = regImg.test(elem.nodeName);
            //allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
            var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]("sizes"));
            var isAuto = sizes == "auto";
            if ((isAuto || !isCompleted) && isImg && (elem[_getAttribute]("src") || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)) return;
            detail = triggerEvent(elem, "lazyunveilread").detail;
            if (isAuto) autoSizer.updateElem(elem, true, elem.offsetWidth);
            elem._lazyRace = true;
            isLoading++;
            lazyUnveil(elem, detail, isAuto, sizes, isImg);
        };
        var afterScroll = debounce(function() {
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
        });
        var altLoadmodeScrollListner = function() {
            if (lazySizesCfg.loadMode == 3) lazySizesCfg.loadMode = 2;
            afterScroll();
        };
        var onload = function() {
            if (isCompleted) return;
            if (Date1.now() - started < 999) {
                setTimeout(onload, 999);
                return;
            }
            isCompleted = true;
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
            addEventListener("scroll", altLoadmodeScrollListner, true);
        };
        return {
            _: function() {
                started = Date1.now();
                lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
                preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + " " + lazySizesCfg.preloadClass);
                addEventListener("scroll", throttledCheckElements, true);
                addEventListener("resize", throttledCheckElements, true);
                addEventListener("pageshow", function(e) {
                    if (e.persisted) {
                        var loadingElements = document.querySelectorAll("." + lazySizesCfg.loadingClass);
                        if (loadingElements.length && loadingElements.forEach) requestAnimationFrame(function() {
                            loadingElements.forEach(function(img) {
                                if (img.complete) unveilElement(img);
                            });
                        });
                    }
                });
                if (window1.MutationObserver) new MutationObserver(throttledCheckElements).observe(docElem, {
                    childList: true,
                    subtree: true,
                    attributes: true
                });
                else {
                    docElem[_addEventListener]("DOMNodeInserted", throttledCheckElements, true);
                    docElem[_addEventListener]("DOMAttrModified", throttledCheckElements, true);
                    setInterval(throttledCheckElements, 999);
                }
                addEventListener("hashchange", throttledCheckElements, true);
                //, 'fullscreenchange'
                [
                    "focus",
                    "mouseover",
                    "click",
                    "load",
                    "transitionend",
                    "animationend"
                ].forEach(function(name) {
                    document[_addEventListener](name, throttledCheckElements, true);
                });
                if (/d$|^c/.test(document.readyState)) onload();
                else {
                    addEventListener("load", onload);
                    document[_addEventListener]("DOMContentLoaded", throttledCheckElements);
                    setTimeout(onload, 20000);
                }
                if (lazysizes.elements.length) {
                    checkElements();
                    rAF._lsFlush();
                } else throttledCheckElements();
            },
            checkElems: throttledCheckElements,
            unveil: unveilElement,
            _aLSL: altLoadmodeScrollListner
        };
    }();
    var autoSizer = function() {
        var autosizesElems;
        var sizeElement = rAFIt(function(elem, parent, event, width) {
            var sources, i, len;
            elem._lazysizesWidth = width;
            width += "px";
            elem.setAttribute("sizes", width);
            if (regPicture.test(parent.nodeName || "")) {
                sources = parent.getElementsByTagName("source");
                for(i = 0, len = sources.length; i < len; i++)sources[i].setAttribute("sizes", width);
            }
            if (!event.detail.dataAttr) updatePolyfill(elem, event.detail);
        });
        /**
		 *
		 * @param elem {Element}
		 * @param dataAttr
		 * @param [width] { number }
		 */ var getSizeElement = function(elem, dataAttr, width) {
            var event;
            var parent = elem.parentNode;
            if (parent) {
                width = getWidth(elem, parent, width);
                event = triggerEvent(elem, "lazybeforesizes", {
                    width: width,
                    dataAttr: !!dataAttr
                });
                if (!event.defaultPrevented) {
                    width = event.detail.width;
                    if (width && width !== elem._lazysizesWidth) sizeElement(elem, parent, event, width);
                }
            }
        };
        var updateElementsSizes = function() {
            var i;
            var len = autosizesElems.length;
            if (len) {
                i = 0;
                for(; i < len; i++)getSizeElement(autosizesElems[i]);
            }
        };
        var debouncedUpdateElementsSizes = debounce(updateElementsSizes);
        return {
            _: function() {
                autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
                addEventListener("resize", debouncedUpdateElementsSizes);
            },
            checkElems: debouncedUpdateElementsSizes,
            updateElem: getSizeElement
        };
    }();
    var init = function() {
        if (!init.i && document.getElementsByClassName) {
            init.i = true;
            autoSizer._();
            loader._();
        }
    };
    setTimeout(function() {
        if (lazySizesCfg.init) init();
    });
    lazysizes = {
        /**
		 * @type { LazySizesConfigPartial }
		 */ cfg: lazySizesCfg,
        autoSizer: autoSizer,
        loader: loader,
        init: init,
        uP: updatePolyfill,
        aC: addClass,
        rC: removeClass,
        hC: hasClass,
        fire: triggerEvent,
        gW: getWidth,
        rAF: rAF
    };
    return lazysizes;
});

});


parcelRequire("2ax5i");
var $7911ea402c229998$exports = {};

(function(window1, factory) {
    if (!window1) return;
    var globalInstall = function() {
        factory(window1.lazySizes);
        window1.removeEventListener("lazyunveilread", globalInstall, true);
    };
    factory = factory.bind(null, window1, window1.document);
    if (0, $7911ea402c229998$exports) factory((parcelRequire("2ax5i")));
    else if (typeof define == "function" && define.amd) define([
        "lazysizes"
    ], factory);
    else if (window1.lazySizes) globalInstall();
    else window1.addEventListener("lazyunveilread", globalInstall, true);
})(typeof window != "undefined" ? window : 0, function(window1, document, lazySizes) {
    "use strict";
    if (!window1.addEventListener) return;
    var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/;
    var regCssFit = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/;
    var regCssObject = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/;
    var regPicture = /^picture$/i;
    var cfg = lazySizes.cfg;
    var getCSS = function(elem) {
        return getComputedStyle(elem, null) || {};
    };
    var parentFit = {
        getParent: function(element, parentSel) {
            var parent = element;
            var parentNode = element.parentNode;
            if ((!parentSel || parentSel == "prev") && parentNode && regPicture.test(parentNode.nodeName || "")) parentNode = parentNode.parentNode;
            if (parentSel != "self") {
                if (parentSel == "prev") parent = element.previousElementSibling;
                else if (parentSel && (parentNode.closest || window1.jQuery)) parent = (parentNode.closest ? parentNode.closest(parentSel) : jQuery(parentNode).closest(parentSel)[0]) || parentNode;
                else parent = parentNode;
            }
            return parent;
        },
        getFit: function(element) {
            var tmpMatch, parentObj;
            var css = getCSS(element);
            var content = css.content || css.fontFamily;
            var obj = {
                fit: element._lazysizesParentFit || element.getAttribute("data-parent-fit")
            };
            if (!obj.fit && content && (tmpMatch = content.match(regCssFit))) obj.fit = tmpMatch[1];
            if (obj.fit) {
                parentObj = element._lazysizesParentContainer || element.getAttribute("data-parent-container");
                if (!parentObj && content && (tmpMatch = content.match(regCssObject))) parentObj = tmpMatch[1];
                obj.parent = parentFit.getParent(element, parentObj);
            } else obj.fit = css.objectFit;
            return obj;
        },
        getImageRatio: function(element) {
            var i, srcset, media, ratio, match, width, height;
            var parent = element.parentNode;
            var elements = parent && regPicture.test(parent.nodeName || "") ? parent.querySelectorAll("source, img") : [
                element
            ];
            for(i = 0; i < elements.length; i++){
                element = elements[i];
                srcset = element.getAttribute(cfg.srcsetAttr) || element.getAttribute("srcset") || element.getAttribute("data-pfsrcset") || element.getAttribute("data-risrcset") || "";
                media = element._lsMedia || element.getAttribute("media");
                media = cfg.customMedia[element.getAttribute("data-media") || media] || media;
                if (srcset && (!media || (window1.matchMedia && matchMedia(media) || {}).matches)) {
                    ratio = parseFloat(element.getAttribute("data-aspectratio"));
                    if (!ratio) {
                        match = srcset.match(regDescriptors);
                        if (match) {
                            if (match[2] == "w") {
                                width = match[1];
                                height = match[3];
                            } else {
                                width = match[3];
                                height = match[1];
                            }
                        } else {
                            width = element.getAttribute("width");
                            height = element.getAttribute("height");
                        }
                        ratio = width / height;
                    }
                    break;
                }
            }
            return ratio;
        },
        calculateSize: function(element, width) {
            var displayRatio, height, imageRatio, retWidth;
            var fitObj = this.getFit(element);
            var fit = fitObj.fit;
            var fitElem = fitObj.parent;
            if (fit != "width" && (fit != "contain" && fit != "cover" || !(imageRatio = this.getImageRatio(element)))) return width;
            if (fitElem) width = fitElem.clientWidth;
            else fitElem = element;
            retWidth = width;
            if (fit == "width") retWidth = width;
            else {
                height = fitElem.clientHeight;
                if ((displayRatio = width / height) && (fit == "cover" && displayRatio < imageRatio || fit == "contain" && displayRatio > imageRatio)) retWidth = width * (imageRatio / displayRatio);
            }
            return retWidth;
        }
    };
    lazySizes.parentFit = parentFit;
    document.addEventListener("lazybeforesizes", function(e) {
        if (e.defaultPrevented || e.detail.instance != lazySizes) return;
        var element = e.target;
        e.detail.width = parentFit.calculateSize(element, e.detail.width);
    });
});


function $4a662e3b1537df09$var$e(e, o) {
    for(const t in o){
        const n = o[t];
        e.addEventListener(t, n.listener || n, n.options || void 0);
    }
}
const $4a662e3b1537df09$var$o = "IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype, $4a662e3b1537df09$var$t = /baidu|(?:google|bing|yandex|duckduck)bot/i.test(navigator.userAgent), $4a662e3b1537df09$var$n = [
    "src",
    "poster"
];
function $4a662e3b1537df09$var$r(e, o) {
    for (const t of $4a662e3b1537df09$var$n)t in e.dataset && (e.setAttribute(t, e.dataset[t]), e.classList.contains(o) && e.classList.remove(o));
}
function $4a662e3b1537df09$var$s(e, o, t, n) {
    if ("VIDEO" == e.nodeName) {
        const t = Array.from(e.querySelectorAll("source"));
        for (const e of t)$4a662e3b1537df09$var$r(e, o);
        e.load();
    }
    $4a662e3b1537df09$var$r(e, o);
    const s = e.classList;
    s.contains(t) && (s.remove(t), s.add(n));
}
function $4a662e3b1537df09$export$80e34e3edbb862ab(n) {
    const r = n?.lazyClass || "lazy", i = n?.lazyBackgroundClass || "lazy-bg", c = n?.lazyBackgroundLoaded || "lazy-bg-loaded", a = n?.threshold || 200, l = n?.events || {}, d = n?.observeChanges || !1, f = n?.observeRootSelector || "body", u = n?.mutationObserverOptions || {
        childList: !0,
        subtree: !0
    }, b = `video.${r},.${i}`;
    let v = Array.from(document.querySelectorAll(b));
    for (const o of v)$4a662e3b1537df09$var$e(o, l);
    if (!0 === $4a662e3b1537df09$var$o && !1 === $4a662e3b1537df09$var$t) {
        var y = new IntersectionObserver((e)=>{
            for (const o of e)if (o.isIntersecting || o.intersectionRatio) {
                const { target: e  } = o;
                $4a662e3b1537df09$var$s(e, r, i, c), y.unobserve(e), v = v.filter((o)=>o != e), 0 === v.length && !1 === d && y.disconnect();
            }
        }, {
            rootMargin: `${a}px 0%`
        });
        for (const e of v)y.observe(e);
        d && new MutationObserver(()=>{
            const n = document.querySelectorAll(b);
            for (const r of n)!1 === v.includes(r) && (v.push(r), $4a662e3b1537df09$var$e(r, l), !0 === $4a662e3b1537df09$var$o && !1 === $4a662e3b1537df09$var$t && y.observe(r));
        }).observe(document.querySelector(f), u);
    } else if ($4a662e3b1537df09$var$t) for (const e of v)$4a662e3b1537df09$var$s(e, r, i, c);
}


class $9851c588d75ce610$var$Notification {
    constructor(element){
        this._notification = element;
    }
    show(text, variant) {
        this._notification.show(text, variant);
    }
}
var $9851c588d75ce610$export$2e2bcd8739ae039 = $9851c588d75ce610$var$Notification;


class $0958b1945ad703ab$var$BodyElement {
    constructor(){
        const notificationElement = document.querySelector("#GlobalNotification");
        if (notificationElement) this.notification = new (0, $9851c588d75ce610$export$2e2bcd8739ae039)(notificationElement);
        this.isScrolling = false;
        this.overlaySelector = `#BodyOverlay`;
        window.addEventListener("wheel", this._handleWindowScroll);
        this.overlayCalls = [];
    }
    _handleWindowScroll = ()=>{
        if (this._timeoutScrollId) {
            clearTimeout(this._timeoutScrollId);
            this.isScrolling = true;
        }
        this._timeoutScrollId = setTimeout(()=>{
            this.isScrolling = false;
        }, 300);
    };
    showOverlay(key, styles) {
        const defaultStyles = {
            zIndex: 3,
            backgroundColor: "var(--gsc-black-color-50)"
        };
        const bodyOverlay = document.querySelector(this.overlaySelector);
        if (!bodyOverlay) return;
        this.overlayCalls = [
            ...this.overlayCalls,
            {
                key: key,
                styles: styles
            }
        ];
        this.setBodyOverlayStyles({
            ...defaultStyles,
            ...styles
        });
        bodyOverlay.setAttribute("visible", "");
        this.setScrollLock();
    }
    hideOverlay(key) {
        const bodyOverlay = document.querySelector(this.overlaySelector);
        if (!bodyOverlay) return;
        const isVisible = bodyOverlay.hasAttribute("visible");
        if (!isVisible) return;
        this.overlayCalls = this.overlayCalls.filter((overlayCall)=>overlayCall.key !== key);
        const lastCall = this.overlayCalls[this.overlayCalls.length - 1];
        if (lastCall) this.setBodyOverlayStyles(lastCall.styles);
        else {
            bodyOverlay.removeAttribute("visible");
            bodyOverlay.setAttribute("style", "");
            this.unsetScrollLock();
        }
    }
    setScrollLock() {
        document.body.style.top = `-${window.scrollY || Math.abs(parseInt(document.body.style.top || "0"))}px`;
        document.body.setAttribute("scroll-y-off", "");
    }
    unsetScrollLock() {
        const scrollY = document.body.style.top;
        document.body.removeAttribute("scroll-y-off");
        document.body.style.top = "";
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }
    setBodyOverlayStyles(styles) {
        const bodyOverlay = document.querySelector(this.overlaySelector);
        if (!bodyOverlay) return;
        if (styles) {
            const styleKeyList = Object.keys(styles);
            styleKeyList.forEach((key)=>{
                bodyOverlay.style[key] = styles[key];
            });
        }
    }
}
const $0958b1945ad703ab$export$e1122b4c4bd5b838 = new $0958b1945ad703ab$var$BodyElement();


const $0f1057c27003f13c$export$a6ef6196533b655b = {
    SECTION_LOAD: "shopify:section:load",
    SECTION_UNLOAD: "shopify:section:unload",
    SECTION_SELECT: "shopify:section:select",
    SECTION_DESELECT: "shopify:section:deselect",
    SECTION_REORDER: "shopify:section:reorder",
    BLOCK_SELECT: "shopify:block:select",
    BLOCK_DESELECT: "shopify:block:deselect"
};
const $0f1057c27003f13c$export$3f0d637ce77a8721 = {
    ARROW_LEFT_STRING_KEY: "ArrowLeft",
    ARROW_RIGHT_STRING_KEY: "ArrowRight",
    ARROW_LEFT_NUMBER_KEY: 37,
    ARROW_RIGHT_NUMBER_KEY: 39,
    ENTER_STRING_KEY: "Enter",
    ENTER_NUMBER_KEY: 13,
    ESCAPE_STRING_KEY: "Escape",
    ESCAPE_NUMBER_KEY: 27
};



const $eceaf86a082c33f7$export$9a00dee1beb8f576 = (word)=>{
    const firstSymbol = word.slice(0, 1);
    const restWordPart = word.slice(1);
    return firstSymbol.toUpperCase() + restWordPart;
};
const $eceaf86a082c33f7$export$1391212d75b2ee65 = (delay)=>{
    return new Promise((resolve, reject)=>{
        setTimeout(resolve, delay);
    });
};
const $eceaf86a082c33f7$var$setEventListener = (element, typeEvent, handler, action)=>{
    if (!handler || !element || !typeEvent) return;
    const eventListenerSetter = `${action}EventListener`;
    element[eventListenerSetter](typeEvent, handler);
};
const $eceaf86a082c33f7$export$72de9d21dee7d369 = (element, typeEvent, handler)=>{
    $eceaf86a082c33f7$var$setEventListener(element, typeEvent, handler, "add");
};
const $eceaf86a082c33f7$export$ff0ecb8d3a93845b = (element, typeEvent, handler)=>{
    $eceaf86a082c33f7$var$setEventListener(element, typeEvent, handler, "remove");
};
const $eceaf86a082c33f7$export$b9291b92670abfe3 = new IntersectionObserver((entries, _)=>{
    entries.forEach((entry)=>{
        const isInViewport = entry.isIntersecting;
        const isParentHidden = entry.target.closest('[aria-hidden="true"], .hidden');
        entry.target.toggleAttribute("data-is-in-viewport", isInViewport && !isParentHidden);
    });
});
const $eceaf86a082c33f7$export$f2d94ec8507fd10b = ()=>{
    const targets = [
        "button",
        "[href]",
        "[data-focus-trap-target]",
        "a",
        "[tabindex]"
    ];
    return targets.map((target)=>`${target}:not([tabindex="-1"]):not([data-color-swatches-hidden-count]:empty)`).join(",");
};
const $eceaf86a082c33f7$export$402b71a6ab88771a = (customElement)=>{
    const customElementContainer = document.createElement("div");
    customElementContainer.classList.add("hidden");
    document.body.appendChild(customElementContainer);
    customElementContainer.appendChild(customElement);
    return customElementContainer;
};
const $eceaf86a082c33f7$export$6b8b061b59c6fc66 = (customElementContainer)=>{
    customElementContainer.remove();
};
const $eceaf86a082c33f7$export$95df08bae54cb4df = ()=>{
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
};
const $eceaf86a082c33f7$export$793b145c7f680179 = (key)=>{
    const isEnterNumberKey = key === (0, $0f1057c27003f13c$export$3f0d637ce77a8721).ENTER_NUMBER_KEY;
    const isEnterStringKey = key === (0, $0f1057c27003f13c$export$3f0d637ce77a8721).ENTER_STRING_KEY;
    const isEnterKey = isEnterNumberKey || isEnterStringKey;
    return isEnterKey;
};
const $eceaf86a082c33f7$export$e2fe3643cb517b19 = (key)=>{
    const isRightNumberKey = key === (0, $0f1057c27003f13c$export$3f0d637ce77a8721).ARROW_RIGHT_NUMBER_KEY;
    const isRightStringKey = key === (0, $0f1057c27003f13c$export$3f0d637ce77a8721).ARROW_RIGHT_STRING_KEY;
    const isRightKey = isRightNumberKey || isRightStringKey;
    return isRightKey;
};
const $eceaf86a082c33f7$export$703c582f38858004 = (key)=>{
    const isLeftNumberKey = key === (0, $0f1057c27003f13c$export$3f0d637ce77a8721).ARROW_LEFT_NUMBER_KEY;
    const isLeftStringKey = key === (0, $0f1057c27003f13c$export$3f0d637ce77a8721).ARROW_LEFT_STRING_KEY;
    const isLeftKey = isLeftNumberKey || isLeftStringKey;
    return isLeftKey;
};


class $0ae47dd44554f0e5$var$ShopifyEditor {
    constructor(){
        this._listeners = {};
    }
    subscribe(eventName, listener) {
        if (!this._listeners[eventName]) this._listeners[eventName] = [];
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(document, (0, $0f1057c27003f13c$export$a6ef6196533b655b)[eventName], listener);
        this._listeners[eventName].push(listener);
    }
    unsubscribe(eventName, removedListener) {
        if (!this._listeners[eventName]) return;
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(document, (0, $0f1057c27003f13c$export$a6ef6196533b655b)[eventName], removedListener);
        this._listeners[eventName] = this._listeners[eventName].filter((listener)=>listener !== removedListener);
    }
    destroy() {
        const events = Object.keys(this._listeners);
        events.forEach((event)=>{
            const listeners = this._listeners[event];
            listeners.forEach((listener)=>{
                this.unsubscribe(event, listener);
            });
        });
        this._listeners = {};
    }
}
var $0ae47dd44554f0e5$export$2e2bcd8739ae039 = $0ae47dd44554f0e5$var$ShopifyEditor;


const { Shopify: $56a37f05924a778e$var$Shopify  } = window;
class $56a37f05924a778e$var$BaseComponent extends HTMLElement {
    constructor(){
        super();
        this._editor = new (0, $0ae47dd44554f0e5$export$2e2bcd8739ae039)();
        this._isEditorMode = $56a37f05924a778e$var$Shopify.designMode;
        this._listeners = {};
    }
    subscribe(eventName, listener) {
        if (!this._listeners[eventName]) this._listeners[eventName] = [];
        this._listeners[eventName].push(listener);
    }
    unsubscribe(eventName, removedListener) {
        if (!this._listeners[eventName]) return;
        this._listeners[eventName] = this._listeners[eventName].filter((listener)=>listener !== removedListener);
    }
    emit(eventName, data) {
        if (!this._listeners[eventName]) return;
        this._listeners[eventName].forEach((listener)=>listener(data));
    }
}
var $56a37f05924a778e$export$2e2bcd8739ae039 = $56a37f05924a778e$var$BaseComponent;


class $0f9b1fcd199567c9$var$LoginComponent extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.forms = [
            ...this.querySelectorAll("[data-login-form]")
        ];
    }
    connectedCallback() {
        this.updateFocus();
        this.addEventListener("click", this._handleClick);
    }
    disconnectedCallback() {
        this.removeEventListener("click", this._handleClick);
    }
    _handleClick = (event)=>{
        const target = event.target;
        const isLoginFormButton = target.hasAttribute("data-login-form-button");
        if (isLoginFormButton) {
            const loginFormId = target.dataset.loginFormId || "";
            this.setFormVisibleById(loginFormId);
            this.updateFocus();
        }
    };
    setFormVisibleById(loginFormId) {
        this.forms.forEach((form)=>{
            const isTargetForm = form.getAttribute("data-login-form") === loginFormId;
            form.classList.toggle("hidden", !isTargetForm);
        });
    }
    updateFocus() {
        this.forms.forEach((form)=>{
            const isHidden = form.classList.contains("hidden");
            const emailInput = form.querySelector('[type="email"]');
            if (!isHidden && emailInput) emailInput.focus();
        });
    }
}
var $0f9b1fcd199567c9$export$2e2bcd8739ae039 = $0f9b1fcd199567c9$var$LoginComponent;


class $85cf8343cce054a2$var$BackToTopButton extends HTMLElement {
    constructor(){
        super();
        this.button = this.querySelector("[data-back-to-top-button]");
    }
    connectedCallback() {
        if (this.button) this.button.addEventListener("click", this._handleButtonClick);
        window.addEventListener("scroll", this._handleWindowScroll);
    }
    disconnectedCallback() {
        if (this.button) this.button.removeEventListener("click", this._handleButtonClick);
        window.removeEventListener("scroll", this._handleWindowScroll);
    }
    _handleWindowScroll = ()=>{
        this.updateButtonVisible();
    };
    _handleButtonClick = ()=>{
        this.scrollToTop();
    };
    updateButtonVisible() {
        if (!this.button) return;
        const isVisible = window.scrollY > window.innerHeight;
        this.button.toggleAttribute("visible", isVisible);
    }
    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
}
var $85cf8343cce054a2$export$2e2bcd8739ae039 = $85cf8343cce054a2$var$BackToTopButton;


class $9ee712e29f909c34$var$StickyCartButton extends HTMLElement {
    constructor(){
        super();
        this.button = this.querySelector("[data-cart-sticky-button]");
    }
    connectedCallback() {
        window.addEventListener("scroll", this._handleWindowScroll);
    }
    disconnectedCallback() {
        window.removeEventListener("scroll", this._handleWindowScroll);
    }
    _handleWindowScroll = ()=>{
        const headerSection = document.querySelector(".shopify-section.shopify-section-header");
        if (headerSection && this.button) {
            const headerSectionRect = headerSection.getBoundingClientRect();
            const isVisible = headerSectionRect.bottom + this.button.offsetHeight < 0;
            this.button.toggleAttribute("visible", isVisible);
        }
    };
}
var $9ee712e29f909c34$export$2e2bcd8739ae039 = $9ee712e29f909c34$var$StickyCartButton;




class $7dd54ea48ed33822$var$Quantity extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.inputSelector = `[data-quantity-input]`;
        this.input = this.querySelector(this.inputSelector);
        this._prevValue = this._value;
        this._stockValue = this.dataset.stock || "0";
    }
    connectedCallback() {
        this._updateButtonsDisabled();
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this.input, "keypress", this._handleKeydown);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this.input, "input", this._handleInput);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this.input, "blur", this._handleBlur);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this.input, "keypress", this._handleKeydown);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this.input, "input", this._handleInput);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this.input, "blur", this._handleBlur);
    }
    _handleBlur = (event)=>{
        if (this.input) {
            const target = event.target;
            const value = target.value || "0";
            this.input.value = value;
            this._updateButtonsDisabled();
            this._prevValue = value;
        }
    };
    _handleKeydown = (event)=>{
        if (this.input) {
            const isEnterKey = (0, $eceaf86a082c33f7$export$793b145c7f680179)(event.key || event.keyCode);
            if (isEnterKey) {
                event.preventDefault();
                this.input.blur();
            }
        }
    };
    _handleInput = (event)=>{
        if (this.input) {
            const target = event.target;
            const value = target.value;
            this.input.value = this._isMoreThanStock ? this._stockValue : value;
            this._updateButtonsDisabled();
            this._prevValue = value;
        }
    };
    inputChange(action) {
        if (this.input) {
            if (action === "minus") this.input.stepDown();
            else this.input.stepUp();
            if (+this._prevValue !== +this._value) this.input.dispatchEvent(new Event("change", {
                bubbles: true
            }));
            this._updateButtonsDisabled();
        }
    }
    _updateButtonsDisabled() {
        this._updateButtonDisabled("minus", this._isLessThanMin);
        this._updateButtonDisabled("plus", this._isMoreThanStock);
    }
    setDisable(isDisabled) {
        this._updateButtonDisabled("minus", isDisabled);
        this._updateButtonDisabled("plus", isDisabled);
    }
    _updateButtonDisabled(btnType, isDisabled) {
        const btn = this.querySelector(`quantity-btn[data-action="${btnType}"]`);
        if (btn) btn.toggleAttribute("disabled", isDisabled);
    }
    get _value() {
        if (!this.input) return "0";
        return this.input.value;
    }
    get _isLessThanMin() {
        if (!this.input) return false;
        return +this._value <= +this.input.min;
    }
    get _isMoreThanStock() {
        return +this._value >= +this._stockValue;
    }
}
var $7dd54ea48ed33822$export$2e2bcd8739ae039 = $7dd54ea48ed33822$var$Quantity;




class $affdda50ca21c279$var$QuantityBtn extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._quantity = this.closest("quantity-component");
    }
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "focus", this._handleButtonFocus);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "blur", this._handleButtonBlur);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "click", this._handleButtonClick);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "focus", this._handleButtonFocus);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "blur", this._handleButtonBlur);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "click", this._handleButtonClick);
    }
    _handleButtonClick = (event)=>{
        event.preventDefault();
        this.update();
    };
    _handleButtonFocus = ()=>{
        this.addEventListener("keydown", this._handleKeyDown);
    };
    _handleButtonBlur = ()=>{
        this.removeEventListener("keydown", this._handleKeyDown);
    };
    _handleKeyDown = (event)=>{
        const isEnterKey = (0, $eceaf86a082c33f7$export$793b145c7f680179)(event.key || event.keyCode);
        const target = event.target;
        if (isEnterKey && !target.hasAttribute("disabled")) {
            event.preventDefault();
            this.update();
        }
    };
    update() {
        const action = this.dataset.action;
        if (this._quantity && action) {
            this._quantity.inputChange(action);
            if (action === "minus") this._setDisabled();
        }
    }
    _setDisabled() {
        if (this._quantity && this._quantity.input) {
            const isDisabled = this._quantity.input.value === "1";
            this.toggleAttribute("disabled", isDisabled);
        }
    }
}
var $affdda50ca21c279$export$2e2bcd8739ae039 = $affdda50ca21c279$var$QuantityBtn;




class $3645ec850829a73e$var$LocalizationSelector extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.inputSelector = `[data-localization-input]`;
        this.formSelector = "form";
        this.input = this.querySelector(this.inputSelector);
        this.form = this.querySelector(this.formSelector);
    }
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "click", this._handleClick);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "click", this._handleClick);
    }
    _handleClick = (event)=>{
        event.preventDefault();
        const target = event.target;
        if (!target.hasAttribute(`data-localization-item`)) return;
        if (!this.input || !this.form || !target.dataset.value) return;
        this.input.value = target.dataset.value;
        this.form.submit();
    };
}
var $3645ec850829a73e$export$2e2bcd8739ae039 = $3645ec850829a73e$var$LocalizationSelector;



class $cde8b389b4aed8f8$var$NotificationComponent extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._closeBtnSelector = `[data-notification-close-button]`;
        this._alertSelector = `[data-notification-alert]`;
        this._alertTextSelector = `[data-notification-alert-text]`;
        this._closeBtn = this.querySelector(this._closeBtnSelector);
        this._alert = this.querySelector(this._alertSelector);
        this._alertText = this.querySelector(this._alertTextSelector);
    }
    connectedCallback() {
        if (this._closeBtn) this._closeBtn.addEventListener("click", this._handleCloseButtonClick);
    }
    disconnectedCallback() {
        if (this._closeBtn) this._closeBtn.removeEventListener("click", this._handleCloseButtonClick);
    }
    _handleCloseButtonClick = ()=>{
        this.hide();
    };
    show(errorText, variant) {
        this._setAlert(errorText, variant || "warning");
        if (this.showTimeoutId) clearTimeout(this.showTimeoutId);
        this._setVisible(true);
        this.showTimeoutId = setTimeout(()=>{
            this._setVisible(false);
        }, 3000);
    }
    hide() {
        this._setVisible(false);
    }
    _setVisible(isVisible) {
        this.toggleAttribute("open", isVisible);
    }
    _setAlert(errorText, variant) {
        if (this._alert && this._alertText) {
            this._alert.setAttribute("alert-type", variant);
            this._alertText.innerHTML = errorText;
        }
    }
}
var $cde8b389b4aed8f8$export$2e2bcd8739ae039 = $cde8b389b4aed8f8$var$NotificationComponent;


class $94718893e8f101ce$var$TabName {
    constructor(element){
        this.element = element;
    }
    update(selectedTabId) {
        const isSelected = selectedTabId === this.element.getAttribute("data-id");
        this.element.classList.toggle("selected", isSelected);
    }
}
var $94718893e8f101ce$export$2e2bcd8739ae039 = $94718893e8f101ce$var$TabName;




const $e6a5d8115fb64fe3$export$998191bfdf710c72 = (element)=>{
    if (element) element.classList.remove("hidden");
};
const $e6a5d8115fb64fe3$export$7669482c90f5c50f = (element)=>{
    if (element) element.classList.add("hidden");
};
const $e6a5d8115fb64fe3$export$d107df9a86338a09 = (element, property)=>{
    const styles = getComputedStyle(element);
    const value = styles[property];
    return value;
};
const $e6a5d8115fb64fe3$export$5faba83c1624a4ba = (element)=>{
    const transitionDuration = parseFloat($e6a5d8115fb64fe3$export$d107df9a86338a09(element, "transitionDuration")) * 1000;
    return transitionDuration;
};
const $e6a5d8115fb64fe3$export$b8efffc5da5ea806 = (element)=>{
    const transitionDelay = parseFloat($e6a5d8115fb64fe3$export$d107df9a86338a09(element, "transitionDelay")) * 1000;
    return transitionDelay;
};
const $e6a5d8115fb64fe3$export$d4e734980dda982f = (template)=>{
    return template.content.cloneNode(true);
};
const $e6a5d8115fb64fe3$export$8ea4fc17cec6f158 = (template)=>{
    return template.content.firstElementChild.cloneNode(true);
};
const $e6a5d8115fb64fe3$export$f99c757f0e3e3773 = (variable, value)=>{
    document.documentElement.style.setProperty(`--gsc-${variable}`, value);
};
const $e6a5d8115fb64fe3$export$771cf8a539cd846f = (element, isForward)=>{
    if (element) element.classList.toggle("forward-transition", isForward);
};
const $e6a5d8115fb64fe3$export$8a49393be2d55148 = (html)=>{
    return new DOMParser().parseFromString(html, "text/html");
};


class $462d590f11548f00$var$Tabs extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.containerSelector = `[data-tabs-container]`;
        this.templateSelector = `[data-tabs-elements-template]`;
        this.tabSelector = `tab-component`;
        this.tabNameSelector = `[data-tabs-name]`;
        this.container = this.querySelector(this.containerSelector);
        this.template = this.querySelector(this.templateSelector);
        this.templateContent = (0, $e6a5d8115fb64fe3$export$d4e734980dda982f)(this.template);
        this.tabNames = [
            ...this.querySelectorAll(this.tabNameSelector)
        ];
        this.tabMap = this.generateTabMap();
    }
    connectedCallback() {
        this.tabNames.forEach((tabName)=>{
            tabName.addEventListener("keydown", this._handleKeyDown);
            tabName.addEventListener("click", this._handleTabNameClick);
        });
    }
    disconnectedCallback() {
        this.tabNames.forEach((tabName)=>{
            tabName.removeEventListener("keydown", this._handleKeyDown);
            tabName.removeEventListener("click", this._handleTabNameClick);
        });
    }
    _handleTabNameClick = (event)=>{
        event.preventDefault();
        const target = event.target;
        if (target.dataset.id) this.selectTab(target.dataset.id);
    };
    _handleKeyDown = (event)=>{
        const target = event.target;
        if (!target.dataset.id) return;
        const isEnterKey = (0, $eceaf86a082c33f7$export$793b145c7f680179)(event.key || event.keyCode);
        if (isEnterKey) {
            event.preventDefault();
            this.selectTab(target.dataset.id);
        }
    };
    generateTabMap() {
        const tabs = [
            this.querySelector(this.tabSelector),
            ...this.templateContent.querySelectorAll(this.tabSelector)
        ];
        const tabMap = tabs.reduce((map, tab)=>{
            const tabId = tab.dataset.id;
            return tabId ? {
                ...map,
                [tabId]: tab
            } : map;
        }, {});
        return tabMap;
    }
    selectTab(tabId) {
        this._updateNameById(tabId);
        this._setTabById(tabId);
        this.emit("selectTab", tabId);
    }
    _unmountTab(tab) {
        tab.remove();
    }
    _mountTab(tab) {
        if (!this.container) return;
        this.container.appendChild(tab);
    }
    _updateNameById(tabId) {
        this.tabNames.forEach((tabName)=>{
            const tabNameComponent = new (0, $94718893e8f101ce$export$2e2bcd8739ae039)(tabName);
            tabNameComponent.update(tabId);
        });
    }
    _setTabById(tabId) {
        const nextTab = this.tabMap[tabId];
        const currentTab = this.tabMap[this.dataset.selectedTabId];
        if (!currentTab || !nextTab) return;
        this.showNextTab(nextTab);
        if (currentTab !== nextTab) this.hideCurrentTab(currentTab);
    }
    showNextTab(tab) {
        const id = tab.getAttribute("data-id");
        if (id) {
            this._mountTab(tab);
            tab.show();
            this.dataset.selectedTabId = id;
        }
    }
    hideCurrentTab(tab) {
        tab.hide().then(()=>{
            this._unmountTab(tab);
        });
    }
}
var $462d590f11548f00$export$2e2bcd8739ae039 = $462d590f11548f00$var$Tabs;




class $0b10a99bea71d582$var$List extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.itemSelector = `[data-list-item]`;
        this.expandBtnSelector = `list-btn[data-trigger="expand"]`;
        this.collapseBtnSelector = `list-btn[data-trigger="collapse"]`;
        this.visibleItemSelector = `${this.itemSelector}:not(.hidden)`;
        this.hiddenItemSelector = `${this.itemSelector}.hidden`;
        this._expandBtn = this.querySelector(this.expandBtnSelector);
        this._collapseBtn = this.querySelector(this.collapseBtnSelector);
    }
    _setInitialHeight() {
        this._initialHeight = this.offsetHeight;
        this.style.maxHeight = `${this._initialHeight}px`;
    }
    _setMaxHeight() {
        this._maxHeight = this.scrollHeight;
        this.style.maxHeight = `${this._maxHeight}px`;
    }
    collapse = ()=>{
        this._hideItems();
        (0, $e6a5d8115fb64fe3$export$7669482c90f5c50f)(this._collapseBtn);
        (0, $e6a5d8115fb64fe3$export$998191bfdf710c72)(this._expandBtn);
    };
    expand = ()=>{
        if (!this._initialHeight) this._setInitialHeight();
        this._showItems();
        this._tryHideExpandBtn();
        (0, $e6a5d8115fb64fe3$export$998191bfdf710c72)(this._collapseBtn);
        this._setMaxHeight();
    };
    _hideItems() {
        const visibleItems = this.querySelectorAll(this.visibleItemSelector);
        const transitionDuration = (0, $e6a5d8115fb64fe3$export$5faba83c1624a4ba)(this);
        this.style.maxHeight = `${this._initialHeight}px`;
        setTimeout(()=>{
            visibleItems.forEach((node, index)=>{
                const initialCount = this.dataset.initialCount ? +this.dataset.initialCount : 0;
                const isOverIntitialCount = index + 1 > +initialCount;
                if (isOverIntitialCount) (0, $e6a5d8115fb64fe3$export$7669482c90f5c50f)(node);
            });
        }, transitionDuration);
    }
    _showItems() {
        const hiddenItems = this.querySelectorAll(this.hiddenItemSelector);
        hiddenItems.forEach((node, index)=>{
            const showCount = this.dataset.showCount ? this.dataset.showCount : 0;
            const isLessShowCount = index + 1 < +showCount;
            if (isLessShowCount) (0, $e6a5d8115fb64fe3$export$998191bfdf710c72)(node);
        });
        this.style.maxHeight = `${this._maxHeight}px`;
    }
    _tryHideExpandBtn() {
        const hiddenItems = this.querySelectorAll(this.hiddenItemSelector);
        if (hiddenItems.length === 0) (0, $e6a5d8115fb64fe3$export$7669482c90f5c50f)(this._expandBtn);
    }
}
var $0b10a99bea71d582$export$2e2bcd8739ae039 = $0b10a99bea71d582$var$List;




class $08381371989a9898$var$ListBtn extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "focus", this._handleButtonFocus);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "blur", this._handleButtonBlur);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "click", this._handleButtonClick);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "focus", this._handleButtonFocus);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "blur", this._handleButtonBlur);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "click", this._handleButtonClick);
    }
    _handleButtonClick = ()=>{
        this.update();
    };
    _handleButtonFocus = ()=>{
        this.addEventListener("keydown", this._handleKeyDown);
    };
    _handleButtonBlur = ()=>{
        this.removeEventListener("keydown", this._handleKeyDown);
    };
    _handleKeyDown = (event)=>{
        const isEnterKey = (0, $eceaf86a082c33f7$export$793b145c7f680179)(event.key || event.keyCode);
        if (isEnterKey) {
            event.preventDefault();
            this.update();
        }
    };
    update() {
        const list = this.closest("list-component");
        if (list) {
            if (this.dataset.trigger === "collapse") list.collapse();
            else list.expand();
            this.emit("click", list);
        }
    }
}
var $08381371989a9898$export$2e2bcd8739ae039 = $08381371989a9898$var$ListBtn;



function $983343fd387df40f$var$getAlignment(placement) {
    return placement.split("-")[1];
}
function $983343fd387df40f$var$getLengthFromAxis(axis) {
    return axis === "y" ? "height" : "width";
}
function $983343fd387df40f$var$getSide(placement) {
    return placement.split("-")[0];
}
function $983343fd387df40f$var$getMainAxisFromPlacement(placement) {
    return [
        "top",
        "bottom"
    ].includes($983343fd387df40f$var$getSide(placement)) ? "x" : "y";
}
function $983343fd387df40f$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference , floating: floating  } = _ref;
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const mainAxis = $983343fd387df40f$var$getMainAxisFromPlacement(placement);
    const length = $983343fd387df40f$var$getLengthFromAxis(mainAxis);
    const commonAlign = reference[length] / 2 - floating[length] / 2;
    const side = $983343fd387df40f$var$getSide(placement);
    const isVertical = mainAxis === "x";
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch($983343fd387df40f$var$getAlignment(placement)){
        case "start":
            coords[mainAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[mainAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $983343fd387df40f$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom" , strategy: strategy = "absolute" , middleware: middleware = [] , platform: platform  } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x , y: y  } = $983343fd387df40f$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name , fn: fn  } = validMiddleware[i];
        const { x: nextX , y: nextY , data: data , reset: reset  } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x , y: y  } = $983343fd387df40f$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
function $983343fd387df40f$var$expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $983343fd387df40f$var$getSideObjectFromPadding(padding) {
    return typeof padding !== "number" ? $983343fd387df40f$var$expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $983343fd387df40f$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $983343fd387df40f$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x , y: y , platform: platform , rects: rects , elements: elements , strategy: strategy  } = state;
    const { boundary: boundary = "clippingAncestors" , rootBoundary: rootBoundary = "viewport" , elementContext: elementContext = "floating" , altBoundary: altBoundary = false , padding: padding = 0  } = options;
    const paddingObject = $983343fd387df40f$var$getSideObjectFromPadding(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = $983343fd387df40f$export$ee05aea0aeecbad4(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = $983343fd387df40f$export$ee05aea0aeecbad4(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
const $983343fd387df40f$var$min = Math.min;
const $983343fd387df40f$var$max = Math.max;
function $983343fd387df40f$var$within(min$1, value, max$1) {
    return $983343fd387df40f$var$max(min$1, $983343fd387df40f$var$min(value, max$1));
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $983343fd387df40f$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            // Since `element` is required, we don't Partial<> the type.
            const { element: element , padding: padding = 0  } = options || {};
            const { x: x , y: y , placement: placement , rects: rects , platform: platform , elements: elements  } = state;
            if (element == null) return {};
            const paddingObject = $983343fd387df40f$var$getSideObjectFromPadding(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = $983343fd387df40f$var$getMainAxisFromPlacement(placement);
            const length = $983343fd387df40f$var$getLengthFromAxis(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min = paddingObject[minProp];
            const max = clientSize - arrowDimensions[length] - paddingObject[maxProp];
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = $983343fd387df40f$var$within(min, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. This stops `shift()` from taking action, but can
            // be worked around by calling it again after the `arrow()` if desired.
            const shouldAddOffset = $983343fd387df40f$var$getAlignment(placement) != null && center != offset && rects.reference[length] / 2 - (center < min ? paddingObject[minProp] : paddingObject[maxProp]) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min ? min - center : max - center : 0;
            return {
                [axis]: coords[axis] - alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset
                }
            };
        }
    });
const $983343fd387df40f$var$sides = [
    "top",
    "right",
    "bottom",
    "left"
];
const $983343fd387df40f$var$allPlacements = /*#__PURE__*/ $983343fd387df40f$var$sides.reduce((acc, side)=>acc.concat(side, side + "-start", side + "-end"), []);
const $983343fd387df40f$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $983343fd387df40f$var$getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$983343fd387df40f$var$oppositeSideMap[side]);
}
function $983343fd387df40f$var$getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $983343fd387df40f$var$getAlignment(placement);
    const mainAxis = $983343fd387df40f$var$getMainAxisFromPlacement(placement);
    const length = $983343fd387df40f$var$getLengthFromAxis(mainAxis);
    let mainAlignmentSide = mainAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $983343fd387df40f$var$getOppositePlacement(mainAlignmentSide);
    return {
        main: mainAlignmentSide,
        cross: $983343fd387df40f$var$getOppositePlacement(mainAlignmentSide)
    };
}
const $983343fd387df40f$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $983343fd387df40f$var$getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>$983343fd387df40f$var$oppositeAlignmentMap[alignment]);
}
function $983343fd387df40f$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>$983343fd387df40f$var$getAlignment(placement) === alignment),
        ...allowedPlacements.filter((placement)=>$983343fd387df40f$var$getAlignment(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>$983343fd387df40f$var$getSide(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return $983343fd387df40f$var$getAlignment(placement) === alignment || (autoAlignment ? $983343fd387df40f$var$getOppositeAlignmentPlacement(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $983343fd387df40f$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects , middlewareData: middlewareData , placement: placement , platform: platform , elements: elements  } = state;
            const { crossAxis: crossAxis = false , alignment: alignment , allowedPlacements: allowedPlacements = $983343fd387df40f$var$allPlacements , autoAlignment: autoAlignment = true , ...detectOverflowOptions } = options;
            const placements = alignment !== undefined || allowedPlacements === $983343fd387df40f$var$allPlacements ? $983343fd387df40f$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $983343fd387df40f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements[currentIndex];
            if (currentPlacement == null) return {};
            const { main: main , cross: cross  } = $983343fd387df40f$var$getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements[0]
                }
            };
            const currentOverflows = [
                overflow[$983343fd387df40f$var$getSide(currentPlacement)],
                overflow[main],
                overflow[cross]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = $983343fd387df40f$var$getAlignment(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                $983343fd387df40f$var$getAlignment(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
function $983343fd387df40f$var$getExpandedPlacements(placement) {
    const oppositePlacement = $983343fd387df40f$var$getOppositePlacement(placement);
    return [
        $983343fd387df40f$var$getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        $983343fd387df40f$var$getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function $983343fd387df40f$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $983343fd387df40f$var$getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = $983343fd387df40f$var$getAlignment(placement);
    let list = $983343fd387df40f$var$getSideList($983343fd387df40f$var$getSide(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($983343fd387df40f$var$getOppositeAlignmentPlacement));
    }
    return list;
}
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $983343fd387df40f$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$flip;
            const { placement: placement , middlewareData: middlewareData , rects: rects , initialPlacement: initialPlacement , platform: platform , elements: elements  } = state;
            const { mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = true , fallbackPlacements: specifiedFallbackPlacements , fallbackStrategy: fallbackStrategy = "bestFit" , fallbackAxisSideDirection: fallbackAxisSideDirection = "none" , flipAlignment: flipAlignment = true , ...detectOverflowOptions } = options;
            const side = $983343fd387df40f$var$getSide(placement);
            const isBasePlacement = $983343fd387df40f$var$getSide(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                $983343fd387df40f$var$getOppositePlacement(initialPlacement)
            ] : $983343fd387df40f$var$getExpandedPlacements(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...$983343fd387df40f$var$getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $983343fd387df40f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const { main: main , cross: cross  } = $983343fd387df40f$var$getAlignmentSides(placement, rects, rtl);
                overflows.push(overflow[main], overflow[cross]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $983343fd387df40f$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $983343fd387df40f$var$isAnySideFullyClipped(overflow) {
    return $983343fd387df40f$var$sides.some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $983343fd387df40f$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { strategy: strategy = "referenceHidden" , ...detectOverflowOptions } = options;
            const { rects: rects  } = state;
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $983343fd387df40f$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $983343fd387df40f$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $983343fd387df40f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $983343fd387df40f$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $983343fd387df40f$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $983343fd387df40f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $983343fd387df40f$var$getBoundingRect(rects) {
    const minX = $983343fd387df40f$var$min(...rects.map((rect)=>rect.left));
    const minY = $983343fd387df40f$var$min(...rects.map((rect)=>rect.top));
    const maxX = $983343fd387df40f$var$max(...rects.map((rect)=>rect.right));
    const maxY = $983343fd387df40f$var$max(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $983343fd387df40f$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>$983343fd387df40f$export$ee05aea0aeecbad4($983343fd387df40f$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $983343fd387df40f$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement , elements: elements , rects: rects , platform: platform , strategy: strategy  } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2 , x: x , y: y  } = options;
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $983343fd387df40f$var$getRectsByLine(nativeClientRects);
            const fallback = $983343fd387df40f$export$ee05aea0aeecbad4($983343fd387df40f$var$getBoundingRect(nativeClientRects));
            const paddingObject = $983343fd387df40f$var$getSideObjectFromPadding(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ($983343fd387df40f$var$getMainAxisFromPlacement(placement) === "x") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = $983343fd387df40f$var$getSide(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = $983343fd387df40f$var$getSide(placement) === "left";
                    const maxRight = $983343fd387df40f$var$max(...clientRects.map((rect)=>rect.right));
                    const minLeft = $983343fd387df40f$var$min(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
async function $983343fd387df40f$var$convertValueToCoords(state, value) {
    const { placement: placement , platform: platform , elements: elements  } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = $983343fd387df40f$var$getSide(placement);
    const alignment = $983343fd387df40f$var$getAlignment(placement);
    const isVertical = $983343fd387df40f$var$getMainAxisFromPlacement(placement) === "x";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = typeof value === "function" ? value(state) : value;
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis , crossAxis: crossAxis , alignmentAxis: alignmentAxis  } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $983343fd387df40f$export$cc800923e997bb8 = function(value) {
    if (value === void 0) value = 0;
    return {
        name: "offset",
        options: value,
        async fn (state) {
            const { x: x , y: y  } = state;
            const diffCoords = await $983343fd387df40f$var$convertValueToCoords(state, value);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
function $983343fd387df40f$var$getCrossAxis(axis) {
    return axis === "x" ? "y" : "x";
}
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $983343fd387df40f$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x , y: y , placement: placement  } = state;
            const { mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = false , limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x , y: y  } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } , ...detectOverflowOptions } = options;
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $983343fd387df40f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const mainAxis = $983343fd387df40f$var$getMainAxisFromPlacement($983343fd387df40f$var$getSide(placement));
            const crossAxis = $983343fd387df40f$var$getCrossAxis(mainAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = $983343fd387df40f$var$within(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = $983343fd387df40f$var$within(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $983343fd387df40f$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x , y: y , placement: placement , rects: rects , middlewareData: middlewareData  } = state;
            const { offset: offset = 0 , mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = true  } = options;
            const coords = {
                x: x,
                y: y
            };
            const mainAxis = $983343fd387df40f$var$getMainAxisFromPlacement(placement);
            const crossAxis = $983343fd387df40f$var$getCrossAxis(mainAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = typeof offset === "function" ? offset(state) : offset;
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes($983343fd387df40f$var$getSide(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $983343fd387df40f$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement , rects: rects , platform: platform , elements: elements  } = state;
            const { apply: apply = ()=>{} , ...detectOverflowOptions } = options;
            const overflow = await $983343fd387df40f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = $983343fd387df40f$var$getSide(placement);
            const alignment = $983343fd387df40f$var$getAlignment(placement);
            const axis = $983343fd387df40f$var$getMainAxisFromPlacement(placement);
            const isXAxis = axis === "x";
            const { width: width , height: height  } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isXAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? $983343fd387df40f$var$min(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? $983343fd387df40f$var$min(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = $983343fd387df40f$var$max(overflow.left, 0);
                const xMax = $983343fd387df40f$var$max(overflow.right, 0);
                const yMin = $983343fd387df40f$var$max(overflow.top, 0);
                const yMax = $983343fd387df40f$var$max(overflow.bottom, 0);
                if (isXAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : $983343fd387df40f$var$max(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : $983343fd387df40f$var$max(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $ea29d606feab1cd3$var$getWindow(node) {
    var _node$ownerDocument;
    return ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $ea29d606feab1cd3$var$getComputedStyle$1(element) {
    return $ea29d606feab1cd3$var$getWindow(element).getComputedStyle(element);
}
function $ea29d606feab1cd3$var$isNode(value) {
    return value instanceof $ea29d606feab1cd3$var$getWindow(value).Node;
}
function $ea29d606feab1cd3$var$getNodeName(node) {
    return $ea29d606feab1cd3$var$isNode(node) ? (node.nodeName || "").toLowerCase() : "";
}
let $ea29d606feab1cd3$var$uaString;
function $ea29d606feab1cd3$var$getUAString() {
    if ($ea29d606feab1cd3$var$uaString) return $ea29d606feab1cd3$var$uaString;
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) {
        $ea29d606feab1cd3$var$uaString = uaData.brands.map((item)=>item.brand + "/" + item.version).join(" ");
        return $ea29d606feab1cd3$var$uaString;
    }
    return navigator.userAgent;
}
function $ea29d606feab1cd3$var$isHTMLElement(value) {
    return value instanceof $ea29d606feab1cd3$var$getWindow(value).HTMLElement;
}
function $ea29d606feab1cd3$var$isElement(value) {
    return value instanceof $ea29d606feab1cd3$var$getWindow(value).Element;
}
function $ea29d606feab1cd3$var$isShadowRoot(node) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    const OwnElement = $ea29d606feab1cd3$var$getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}
function $ea29d606feab1cd3$var$isOverflowElement(element) {
    const { overflow: overflow , overflowX: overflowX , overflowY: overflowY , display: display  } = $ea29d606feab1cd3$var$getComputedStyle$1(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $ea29d606feab1cd3$var$isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($ea29d606feab1cd3$var$getNodeName(element));
}
function $ea29d606feab1cd3$var$isContainingBlock(element) {
    // TODO: Try to use feature detection here instead.
    const isFirefox = /firefox/i.test($ea29d606feab1cd3$var$getUAString());
    const css = $ea29d606feab1cd3$var$getComputedStyle$1(element);
    const backdropFilter = css.backdropFilter || css.WebkitBackdropFilter;
    // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (backdropFilter ? backdropFilter !== "none" : false) || isFirefox && css.willChange === "filter" || isFirefox && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective"
    ].some((value)=>css.willChange.includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>{
        // Add type check for old browsers.
        const contain = css.contain;
        return contain != null ? contain.includes(value) : false;
    });
}
/**
 * Determines whether or not `.getBoundingClientRect()` is affected by visual
 * viewport offsets. In Safari, the `x`/`y` offsets are values relative to the
 * visual viewport, while in other engines, they are values relative to the
 * layout viewport.
 */ function $ea29d606feab1cd3$var$isClientRectVisualViewportBased() {
    // TODO: Try to use feature detection here instead. Feature detection for
    // this can fail in various ways, making the userAgent check the most
    // reliable:
    // • Always-visible scrollbar or not
    // • Width of <html>
    // Is Safari.
    return /^((?!chrome|android).)*safari/i.test($ea29d606feab1cd3$var$getUAString());
}
function $ea29d606feab1cd3$var$isLastTraversableNode(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($ea29d606feab1cd3$var$getNodeName(node));
}
const $ea29d606feab1cd3$var$min = Math.min;
const $ea29d606feab1cd3$var$max = Math.max;
const $ea29d606feab1cd3$var$round = Math.round;
function $ea29d606feab1cd3$var$getCssDimensions(element) {
    const css = $ea29d606feab1cd3$var$getComputedStyle$1(element);
    let width = parseFloat(css.width);
    let height = parseFloat(css.height);
    const hasOffset = $ea29d606feab1cd3$var$isHTMLElement(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = $ea29d606feab1cd3$var$round(width) !== offsetWidth || $ea29d606feab1cd3$var$round(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        fallback: shouldFallback
    };
}
function $ea29d606feab1cd3$var$unwrapElement(element) {
    return !$ea29d606feab1cd3$var$isElement(element) ? element.contextElement : element;
}
const $ea29d606feab1cd3$var$FALLBACK_SCALE = {
    x: 1,
    y: 1
};
function $ea29d606feab1cd3$var$getScale(element) {
    const domElement = $ea29d606feab1cd3$var$unwrapElement(element);
    if (!$ea29d606feab1cd3$var$isHTMLElement(domElement)) return $ea29d606feab1cd3$var$FALLBACK_SCALE;
    const rect = domElement.getBoundingClientRect();
    const { width: width , height: height , fallback: fallback  } = $ea29d606feab1cd3$var$getCssDimensions(domElement);
    let x = (fallback ? $ea29d606feab1cd3$var$round(rect.width) : rect.width) / width;
    let y = (fallback ? $ea29d606feab1cd3$var$round(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
function $ea29d606feab1cd3$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    var _win$visualViewport, _win$visualViewport2;
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $ea29d606feab1cd3$var$unwrapElement(element);
    let scale = $ea29d606feab1cd3$var$FALLBACK_SCALE;
    if (includeScale) {
        if (offsetParent) {
            if ($ea29d606feab1cd3$var$isElement(offsetParent)) scale = $ea29d606feab1cd3$var$getScale(offsetParent);
        } else scale = $ea29d606feab1cd3$var$getScale(element);
    }
    const win = domElement ? $ea29d606feab1cd3$var$getWindow(domElement) : window;
    const addVisualOffsets = $ea29d606feab1cd3$var$isClientRectVisualViewportBased() && isFixedStrategy;
    let x = (clientRect.left + (addVisualOffsets ? ((_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) || 0 : 0)) / scale.x;
    let y = (clientRect.top + (addVisualOffsets ? ((_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) || 0 : 0)) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = $ea29d606feab1cd3$var$getWindow(domElement);
        const offsetWin = offsetParent && $ea29d606feab1cd3$var$isElement(offsetParent) ? $ea29d606feab1cd3$var$getWindow(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $ea29d606feab1cd3$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = getComputedStyle(currentIFrame);
            iframeRect.x += (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            iframeRect.y += (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += iframeRect.x;
            y += iframeRect.y;
            currentIFrame = $ea29d606feab1cd3$var$getWindow(currentIFrame).frameElement;
        }
    }
    return (0, $983343fd387df40f$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $ea29d606feab1cd3$var$getDocumentElement(node) {
    return (($ea29d606feab1cd3$var$isNode(node) ? node.ownerDocument : node.document) || window.document).documentElement;
}
function $ea29d606feab1cd3$var$getNodeScroll(element) {
    if ($ea29d606feab1cd3$var$isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $ea29d606feab1cd3$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect , offsetParent: offsetParent , strategy: strategy  } = _ref;
    const isOffsetParentAnElement = $ea29d606feab1cd3$var$isHTMLElement(offsetParent);
    const documentElement = $ea29d606feab1cd3$var$getDocumentElement(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = {
        x: 1,
        y: 1
    };
    const offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ($ea29d606feab1cd3$var$getNodeName(offsetParent) !== "body" || $ea29d606feab1cd3$var$isOverflowElement(documentElement)) scroll = $ea29d606feab1cd3$var$getNodeScroll(offsetParent);
        if ($ea29d606feab1cd3$var$isHTMLElement(offsetParent)) {
            const offsetRect = $ea29d606feab1cd3$var$getBoundingClientRect(offsetParent);
            scale = $ea29d606feab1cd3$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $ea29d606feab1cd3$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $ea29d606feab1cd3$var$getBoundingClientRect($ea29d606feab1cd3$var$getDocumentElement(element)).left + $ea29d606feab1cd3$var$getNodeScroll(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $ea29d606feab1cd3$var$getDocumentRect(element) {
    const html = $ea29d606feab1cd3$var$getDocumentElement(element);
    const scroll = $ea29d606feab1cd3$var$getNodeScroll(element);
    const body = element.ownerDocument.body;
    const width = $ea29d606feab1cd3$var$max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = $ea29d606feab1cd3$var$max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $ea29d606feab1cd3$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ($ea29d606feab1cd3$var$getComputedStyle$1(body).direction === "rtl") x += $ea29d606feab1cd3$var$max(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $ea29d606feab1cd3$var$getParentNode(node) {
    if ($ea29d606feab1cd3$var$getNodeName(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $ea29d606feab1cd3$var$isShadowRoot(node) && node.host || // Fallback.
    $ea29d606feab1cd3$var$getDocumentElement(node);
    return $ea29d606feab1cd3$var$isShadowRoot(result) ? result.host : result;
}
function $ea29d606feab1cd3$var$getNearestOverflowAncestor(node) {
    const parentNode = $ea29d606feab1cd3$var$getParentNode(node);
    if ($ea29d606feab1cd3$var$isLastTraversableNode(parentNode)) // `getParentNode` will never return a `Document` due to the fallback
    // check, so it's either the <html> or <body> element.
    return parentNode.ownerDocument.body;
    if ($ea29d606feab1cd3$var$isHTMLElement(parentNode) && $ea29d606feab1cd3$var$isOverflowElement(parentNode)) return parentNode;
    return $ea29d606feab1cd3$var$getNearestOverflowAncestor(parentNode);
}
function $ea29d606feab1cd3$export$3b57c1601291186b(node, list) {
    var _node$ownerDocument;
    if (list === void 0) list = [];
    const scrollableAncestor = $ea29d606feab1cd3$var$getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.body);
    const win = $ea29d606feab1cd3$var$getWindow(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $ea29d606feab1cd3$var$isOverflowElement(scrollableAncestor) ? scrollableAncestor : []);
    return list.concat(scrollableAncestor, $ea29d606feab1cd3$export$3b57c1601291186b(scrollableAncestor));
}
function $ea29d606feab1cd3$var$getViewportRect(element, strategy) {
    const win = $ea29d606feab1cd3$var$getWindow(element);
    const html = $ea29d606feab1cd3$var$getDocumentElement(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = $ea29d606feab1cd3$var$isClientRectVisualViewportBased();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $ea29d606feab1cd3$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $ea29d606feab1cd3$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $ea29d606feab1cd3$var$isHTMLElement(element) ? $ea29d606feab1cd3$var$getScale(element) : {
        x: 1,
        y: 1
    };
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $ea29d606feab1cd3$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $ea29d606feab1cd3$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $ea29d606feab1cd3$var$getDocumentRect($ea29d606feab1cd3$var$getDocumentElement(element));
    else if ($ea29d606feab1cd3$var$isElement(clippingAncestor)) rect = $ea29d606feab1cd3$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const mutableRect = {
            ...clippingAncestor
        };
        if ($ea29d606feab1cd3$var$isClientRectVisualViewportBased()) {
            var _win$visualViewport, _win$visualViewport2;
            const win = $ea29d606feab1cd3$var$getWindow(element);
            mutableRect.x -= ((_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) || 0;
            mutableRect.y -= ((_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) || 0;
        }
        rect = mutableRect;
    }
    return (0, $983343fd387df40f$export$ee05aea0aeecbad4)(rect);
}
function $ea29d606feab1cd3$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = $ea29d606feab1cd3$var$getParentNode(element);
    if (parentNode === stopNode || !$ea29d606feab1cd3$var$isElement(parentNode) || $ea29d606feab1cd3$var$isLastTraversableNode(parentNode)) return false;
    return $ea29d606feab1cd3$var$getComputedStyle$1(parentNode).position === "fixed" || $ea29d606feab1cd3$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $ea29d606feab1cd3$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = $ea29d606feab1cd3$export$3b57c1601291186b(element).filter((el)=>$ea29d606feab1cd3$var$isElement(el) && $ea29d606feab1cd3$var$getNodeName(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = $ea29d606feab1cd3$var$getComputedStyle$1(element).position === "fixed";
    let currentNode = elementIsFixed ? $ea29d606feab1cd3$var$getParentNode(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while($ea29d606feab1cd3$var$isElement(currentNode) && !$ea29d606feab1cd3$var$isLastTraversableNode(currentNode)){
        const computedStyle = $ea29d606feab1cd3$var$getComputedStyle$1(currentNode);
        const currentNodeIsContaining = $ea29d606feab1cd3$var$isContainingBlock(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || $ea29d606feab1cd3$var$isOverflowElement(currentNode) && !currentNodeIsContaining && $ea29d606feab1cd3$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = $ea29d606feab1cd3$var$getParentNode(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $ea29d606feab1cd3$var$getClippingRect(_ref) {
    let { element: element , boundary: boundary , rootBoundary: rootBoundary , strategy: strategy  } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $ea29d606feab1cd3$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $ea29d606feab1cd3$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = $ea29d606feab1cd3$var$max(rect.top, accRect.top);
        accRect.right = $ea29d606feab1cd3$var$min(rect.right, accRect.right);
        accRect.bottom = $ea29d606feab1cd3$var$min(rect.bottom, accRect.bottom);
        accRect.left = $ea29d606feab1cd3$var$max(rect.left, accRect.left);
        return accRect;
    }, $ea29d606feab1cd3$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $ea29d606feab1cd3$var$getDimensions(element) {
    return $ea29d606feab1cd3$var$getCssDimensions(element);
}
function $ea29d606feab1cd3$var$getTrueOffsetParent(element, polyfill) {
    if (!$ea29d606feab1cd3$var$isHTMLElement(element) || $ea29d606feab1cd3$var$getComputedStyle$1(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
function $ea29d606feab1cd3$var$getContainingBlock(element) {
    let currentNode = $ea29d606feab1cd3$var$getParentNode(element);
    while($ea29d606feab1cd3$var$isHTMLElement(currentNode) && !$ea29d606feab1cd3$var$isLastTraversableNode(currentNode)){
        if ($ea29d606feab1cd3$var$isContainingBlock(currentNode)) return currentNode;
        else currentNode = $ea29d606feab1cd3$var$getParentNode(currentNode);
    }
    return null;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $ea29d606feab1cd3$var$getOffsetParent(element, polyfill) {
    const window1 = $ea29d606feab1cd3$var$getWindow(element);
    if (!$ea29d606feab1cd3$var$isHTMLElement(element)) return window1;
    let offsetParent = $ea29d606feab1cd3$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && $ea29d606feab1cd3$var$isTableElement(offsetParent) && $ea29d606feab1cd3$var$getComputedStyle$1(offsetParent).position === "static")offsetParent = $ea29d606feab1cd3$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ($ea29d606feab1cd3$var$getNodeName(offsetParent) === "html" || $ea29d606feab1cd3$var$getNodeName(offsetParent) === "body" && $ea29d606feab1cd3$var$getComputedStyle$1(offsetParent).position === "static" && !$ea29d606feab1cd3$var$isContainingBlock(offsetParent))) return window1;
    return offsetParent || $ea29d606feab1cd3$var$getContainingBlock(element) || window1;
}
function $ea29d606feab1cd3$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = $ea29d606feab1cd3$var$isHTMLElement(offsetParent);
    const documentElement = $ea29d606feab1cd3$var$getDocumentElement(offsetParent);
    const rect = $ea29d606feab1cd3$var$getBoundingClientRect(element, true, strategy === "fixed", offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ($ea29d606feab1cd3$var$getNodeName(offsetParent) !== "body" || $ea29d606feab1cd3$var$isOverflowElement(documentElement)) scroll = $ea29d606feab1cd3$var$getNodeScroll(offsetParent);
        if ($ea29d606feab1cd3$var$isHTMLElement(offsetParent)) {
            const offsetRect = $ea29d606feab1cd3$var$getBoundingClientRect(offsetParent, true);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $ea29d606feab1cd3$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
const $ea29d606feab1cd3$export$722a64dea1b767dc = {
    getClippingRect: $ea29d606feab1cd3$var$getClippingRect,
    convertOffsetParentRelativeRectToViewportRelativeRect: $ea29d606feab1cd3$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    isElement: $ea29d606feab1cd3$var$isElement,
    getDimensions: $ea29d606feab1cd3$var$getDimensions,
    getOffsetParent: $ea29d606feab1cd3$var$getOffsetParent,
    getDocumentElement: $ea29d606feab1cd3$var$getDocumentElement,
    getScale: $ea29d606feab1cd3$var$getScale,
    async getElementRects (_ref) {
        let { reference: reference , floating: floating , strategy: strategy  } = _ref;
        const getOffsetParentFn = this.getOffsetParent || $ea29d606feab1cd3$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        return {
            reference: $ea29d606feab1cd3$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
            floating: {
                x: 0,
                y: 0,
                ...await getDimensionsFn(floating)
            }
        };
    },
    getClientRects: (element)=>Array.from(element.getClientRects()),
    isRTL: (element)=>$ea29d606feab1cd3$var$getComputedStyle$1(element).direction === "rtl"
};
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $ea29d606feab1cd3$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true , ancestorResize: ancestorResize = true , elementResize: elementResize = true , animationFrame: animationFrame = false  } = options;
    const ancestors = ancestorScroll || ancestorResize ? [
        ...$ea29d606feab1cd3$var$isElement(reference) ? $ea29d606feab1cd3$export$3b57c1601291186b(reference) : reference.contextElement ? $ea29d606feab1cd3$export$3b57c1601291186b(reference.contextElement) : [],
        ...$ea29d606feab1cd3$export$3b57c1601291186b(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        // ignores Window, checks for [object VisualViewport]
        const isVisualViewport = !$ea29d606feab1cd3$var$isElement(ancestor) && ancestor.toString().includes("V");
        if (ancestorScroll && (animationFrame ? isVisualViewport : true)) ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    let observer = null;
    if (elementResize) {
        observer = new ResizeObserver(()=>{
            update();
        });
        $ea29d606feab1cd3$var$isElement(reference) && !animationFrame && observer.observe(reference);
        if (!$ea29d606feab1cd3$var$isElement(reference) && reference.contextElement && !animationFrame) observer.observe(reference.contextElement);
        observer.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $ea29d606feab1cd3$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $ea29d606feab1cd3$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _observer;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        (_observer = observer) == null || _observer.disconnect();
        observer = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $ea29d606feab1cd3$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $ea29d606feab1cd3$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $983343fd387df40f$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};





class $d0cc054671c594bc$var$FloatElement extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._withOverlay = this.hasAttribute("data-with-overlay");
        const template = this.querySelector("template");
        this.element = (0, $e6a5d8115fb64fe3$export$8ea4fc17cec6f158)(template);
        this._arrow = this.element.querySelector("[data-float-element-arrow]");
    }
    connectedCallback() {
        if (this._isEditorMode) {
            this._editor.subscribe("BLOCK_SELECT", this._handleBlockSelect);
            this._editor.subscribe("BLOCK_DESELECT", this._handleBlockDeselect);
        }
    }
    disconnectedCallback() {
        this._unmount();
        if (this._isEditorMode) this._editor.destroy();
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(window, "wheel", this._handleScroll);
    }
    _handleScroll = ()=>{
        if (this._type === "tooltip") {
            this.hide();
            (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(window, "wheel", this._handleScroll);
        }
    };
    _handleBlockSelect = (e)=>{
        if (this.dataset.sectionId === e.detail.sectionId) {
            const target = this.element.querySelector(`[block-id="${e.detail.blockId}"]`);
            if (target && this._btn) this._btn.trigger();
            else this.hide();
        }
    };
    _handleBlockDeselect = (e)=>{
        if (this.dataset.sectionId === e.detail.sectionId) {
            const target = this.element.querySelector(`[block-id="${e.detail.blockId}"]`);
            if (!target) return;
            this.hide();
        }
    };
    update = ()=>{
        const floatingElement = document.querySelector(`#${this.dataset.floatingElementId}`) || this._btn;
        if (!floatingElement) return;
        (0, $ea29d606feab1cd3$export$48a53dcb22e581d0)(floatingElement, this, this._getOptions()).then((data)=>{
            this._updatePosition(data);
            if (this._arrow) this._updateArrow(data);
        });
    };
    _updatePosition({ x: x , y: y  }) {
        Object.assign(this.style, {
            left: `${x}px`,
            top: `${y}px`
        });
    }
    _getOptions() {
        return {
            placement: this._placement,
            middleware: this._getMiddleware(),
            strategy: this._strategy
        };
    }
    _getMiddleware() {
        const alignmentAxis = this.dataset.alignmentAxisOffset || 0;
        const mainAxis = this.dataset.mainAxisOffset || 0;
        const middleware = [
            (0, $983343fd387df40f$export$cc800923e997bb8)({
                alignmentAxis: +alignmentAxis,
                mainAxis: +mainAxis
            }),
            (0, $983343fd387df40f$export$8a83211c878a3f1f)(),
            (0, $983343fd387df40f$export$fba63a578e423eb)()
        ];
        if (this._arrow) middleware.push((0, $983343fd387df40f$export$f2120bbfa5450bd2)({
            element: this._arrow
        }));
        return middleware;
    }
    checkCursorOutside(x, y) {
        const mainAxisOffset = this.dataset.mainAxisOffset || 0;
        const offset = +mainAxisOffset;
        const interactiveBorder = 2;
        const boundaries = this.getBoundingClientRect();
        const exceedsTop = boundaries.top - (y + offset) > interactiveBorder;
        const exceedsBottom = y - boundaries.bottom - offset > interactiveBorder;
        const exceedsLeft = boundaries.left - (x + offset) > interactiveBorder;
        const exceedsRight = x - boundaries.right - offset > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    }
    _updateArrow({ placement: placement , middlewareData: middlewareData  }) {
        if (!this._arrow) return;
        const { x: arrowX , y: arrowY  } = middlewareData.arrow;
        const staticSide = {
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
        }[placement.split("-")[0]];
        Object.assign(this._arrow.style, {
            left: arrowX != null ? `${arrowX}px` : "",
            top: arrowY != null ? `${arrowY}px` : "",
            right: "",
            bottom: "",
            [staticSide]: "-5px"
        });
    }
    _mount() {
        if (!this.contains(this.element)) this.appendChild(this.element);
    }
    _unmount() {
        if (this.isOpen && this._withOverlay) (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).hideOverlay(this.id);
        if (this.element) this.element.remove();
    }
    playVideos() {
        const videos = [
            ...this.element.querySelectorAll("video")
        ];
        videos.forEach((video)=>{
            video.play();
        });
    }
    pauseVideos() {
        const videos = [
            ...this.element.querySelectorAll("video")
        ];
        videos.forEach((video)=>{
            video.pause();
        });
    }
    show = ()=>{
        if (this._type === "tooltip" && (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).isScrolling) return;
        this._mount();
        this.playVideos();
        this._setVisible(true);
        this.update();
        this.emit("show", {});
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(window, "wheel", this._handleScroll);
    };
    hide = ()=>{
        this._setVisible(false);
        this.pauseVideos();
        this._unmount();
        this.emit("hide", {});
    };
    _setVisible(isVisible) {
        this.setAttribute("aria-hidden", isVisible ? "false" : "true");
        if (this._btn) this._btn.setExpand(isVisible);
        if (this._withOverlay) {
            const withBlur = this.hasAttribute("data-overlay-with-blur");
            const styles = {
                backdropFilter: withBlur ? `blur(16.5px)` : "none"
            };
            this.isOpen ? (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).showOverlay(this.id, styles) : (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).hideOverlay(this.id);
        }
    }
    get _btn() {
        return document.querySelector(`[data-float-element-id="${this.id}"], [data-tooltip-id="${this.id}"]`);
    }
    get isOpen() {
        return this.getAttribute("aria-hidden") === "false";
    }
    get _strategy() {
        return this.dataset.strategy || "absolute";
    }
    get _type() {
        return this.dataset.type;
    }
    get _placement() {
        return this.dataset.placement || "bottom-end";
    }
}
var $d0cc054671c594bc$export$2e2bcd8739ae039 = $d0cc054671c594bc$var$FloatElement;





const $3dc20189bc4eb89f$var$isPointInPolygon = (point, polygon)=>{
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
};
const $3dc20189bc4eb89f$var$svgNs = "http://www.w3.org/2000/svg";
const $3dc20189bc4eb89f$var$contains = (parent, child)=>{
    if (!parent || !child) return false;
    return parent.contains(child);
};
const $3dc20189bc4eb89f$var$isElement = (value)=>{
    return value ? value instanceof (document.defaultView || window).Element : false;
};
const $3dc20189bc4eb89f$var$createPolygonElement = (points, isRect)=>{
    const addVisualOffsets = (0, $eceaf86a082c33f7$export$95df08bae54cb4df)();
    const win = document.defaultView || window;
    const svg = document.createElementNS($3dc20189bc4eb89f$var$svgNs, "svg");
    Object.assign(svg.style, {
        position: "fixed",
        left: `${addVisualOffsets ? win.visualViewport?.offsetLeft || 0 : 0}px`,
        top: `${addVisualOffsets ? win.visualViewport?.offsetTop || 0 : 0}px`,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        zIndex: 2147483647
    });
    svg.setAttribute("data-type", isRect ? "rect" : "triangle");
    const polygon = document.createElementNS($3dc20189bc4eb89f$var$svgNs, "polygon");
    polygon.setAttribute("points", points.map(([x, y])=>`${x},${y}`).join(" "));
    Object.assign(polygon.style, {
        pointerEvents: "auto",
        fill: "transparent",
        opacity: 0
    });
    svg.appendChild(polygon);
    return svg;
};
const $3dc20189bc4eb89f$export$ada5ccdc621e6e28 = (polygonRef)=>{
    if (polygonRef.current) {
        polygonRef.current.remove();
        polygonRef.current = null;
    }
};
const $3dc20189bc4eb89f$export$7484214ab62358d2 = ({ restMs: restMs = 0 , buffer: buffer = 0.5 , blockPointerEvents: blockPointerEvents = true  } = {})=>{
    let timeoutId;
    let isInsideRect = false;
    let hasLanded = false;
    const fn = ({ x: x , y: y , placement: placement , elements: elements , onClose: onClose , polygonRef: polygonRef  })=>{
        return (event)=>{
            const close = ()=>{
                $3dc20189bc4eb89f$export$ada5ccdc621e6e28(polygonRef);
                clearTimeout(timeoutId);
                onClose();
            };
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX , clientY: clientY  } = event;
            const target = event.target;
            const isLeave = event.type === "mouseleave";
            const isOverReference = $3dc20189bc4eb89f$var$contains(elements.domReference, target);
            const isOverFloating = $3dc20189bc4eb89f$var$contains(elements.floating, target);
            if (!isLeave && isOverReference) {
                $3dc20189bc4eb89f$export$ada5ccdc621e6e28(polygonRef);
                return;
            }
            if (!isLeave && (isOverReference || isInsideRect && $3dc20189bc4eb89f$var$contains(polygonRef.current, target))) return;
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && $3dc20189bc4eb89f$var$isElement(event.relatedTarget) && $3dc20189bc4eb89f$var$contains(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            const hasOpenedChildren = elements.floating.querySelector('float-element[aria-hidden="false"]');
            if (hasOpenedChildren) return;
            if (isOverFloating) hasLanded = true;
            // The cursor landed, so we destroy the polygon logic
            if (isOverFloating && !isLeave && polygonRef.current?.dataset.type !== "rect") {
                $3dc20189bc4eb89f$export$ada5ccdc621e6e28(polygonRef);
                return;
            }
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split("-")[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === "top" && y >= refRect.bottom - 1 || side === "bottom" && y <= refRect.top + 1 || side === "left" && x >= refRect.right - 1 || side === "right" && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case "top":
                    rectPoly = [
                        [
                            rect.left,
                            refRect.top + 1
                        ],
                        [
                            rect.left,
                            rect.bottom - 1
                        ],
                        [
                            rect.right,
                            rect.bottom - 1
                        ],
                        [
                            rect.right,
                            refRect.top + 1
                        ]
                    ];
                    isInsideRect = clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= refRect.top + 1;
                    break;
                case "bottom":
                    rectPoly = [
                        [
                            rect.left,
                            rect.top + 1
                        ],
                        [
                            rect.left,
                            refRect.bottom - 1
                        ],
                        [
                            rect.right,
                            refRect.bottom - 1
                        ],
                        [
                            rect.right,
                            rect.top + 1
                        ]
                    ];
                    isInsideRect = clientX >= rect.left && clientX <= rect.right && clientY >= refRect.bottom - 1 && clientY <= rect.bottom;
                    break;
                case "left":
                    rectPoly = [
                        [
                            rect.right - 1,
                            rect.bottom
                        ],
                        [
                            rect.right - 1,
                            rect.top
                        ],
                        [
                            refRect.left + 1,
                            rect.top
                        ],
                        [
                            refRect.left + 1,
                            rect.bottom
                        ]
                    ];
                    isInsideRect = clientX >= rect.left && clientX <= refRect.left + 1 && clientY >= rect.top && clientY <= rect.bottom;
                    break;
                case "right":
                    rectPoly = [
                        [
                            refRect.right - 1,
                            rect.bottom
                        ],
                        [
                            refRect.right - 1,
                            rect.top
                        ],
                        [
                            rect.left + 1,
                            rect.top
                        ],
                        [
                            rect.left + 1,
                            rect.bottom
                        ]
                    ];
                    isInsideRect = clientX >= refRect.right - 1 && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
                    break;
            }
            const getPolygon = ([x, y])=>{
                const isFloatingWider = rect.width > refRect.width;
                const isFloatingTaller = rect.height > refRect.height;
                switch(side){
                    case "top":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "bottom":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "left":
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case "right":
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            };
            const poly = isInsideRect ? rectPoly : getPolygon([
                x,
                y
            ]);
            if (!polygonRef.current && blockPointerEvents && isLeave) {
                polygonRef.current = $3dc20189bc4eb89f$var$createPolygonElement(poly, isInsideRect);
                document.body.appendChild(polygonRef.current);
            }
            if (isInsideRect) return;
            if (!$3dc20189bc4eb89f$var$isPointInPolygon([
                clientX,
                clientY
            ], poly)) close();
            else if (restMs && !hasLanded) timeoutId = setTimeout(onClose, restMs);
        };
    };
    return fn;
};


class $bd45563d04ffcec6$var$FloatElementBtn extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._trigger = this.dataset.trigger === "click" ? "click" : "mouseenter";
        this.element = this.getElement();
        this.polygonRef = {
            current: null
        };
    }
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this.element, "focus", this._handleFocus);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this.element, "blur", this._handleBlur);
        if (this.dataset.trigger === "click") {
            (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(window, "click", this._handleWindowClick);
            (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this.element, "click", this._handleElementClick);
        } else {
            (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this.element, "mouseleave", this._handleMouseLeave);
            (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this.element, "mouseenter", this._handleMouseEnter);
        }
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this.element, "focus", this._handleFocus);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this.element, "blur", this._handleBlur);
        if (this.dataset.trigger === "click") {
            (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(window, "click", this._handleWindowClick);
            (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this.element, "click", this._handleElementClick);
        } else {
            (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this.element, "mouseleave", this._handleMouseLeave);
            (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this.element, "mouseenter", this._handleMouseEnter);
        }
    }
    _handleBlur = ()=>{
        this.blurElementTimeoutId = setTimeout(()=>{
            if (!this._floatElement) return;
            this._floatElement.hide();
        }, 0);
    };
    _handleFocus = ()=>{
        this._floatElement.show();
        this.setTargetListeners("add");
    };
    _handleFirstTargetFocus = ()=>{
        clearTimeout(this.blurElementTimeoutId);
    };
    _handleTargetFocus = ()=>{
        clearTimeout(this.blurLastTargetTimeoutId);
    };
    _handleLastTargetBlur = ()=>{
        this.blurLastTargetTimeoutId = setTimeout(()=>{
            this.setTargetListeners("remove");
            this._floatElement.hide();
        }, 0);
    };
    _handleMouseEnter = ()=>{
        this.mouseenterTimeout = setTimeout(()=>{
            this.trigger();
        }, 0);
    };
    _handleElementClick = ()=>{
        this.trigger();
    };
    _handleWindowClick = (event)=>{
        const isCursorOutside = this._floatElement.checkCursorOutside(event.clientX, event.clientX);
        const isOutsideFloatElements = this._isTargetOutsideFloatElements(event.target);
        if (isCursorOutside && isOutsideFloatElements) {
            (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(window, "click", this._handleWindowClick);
            this._floatElement.hide();
        }
    };
    _handleMouseLeave = (event)=>{
        clearTimeout(this.mouseenterTimeout);
        if (this.safePolygonFn) window.removeEventListener("mousemove", this._handleMouseMove);
        this.safePolygonFn = (0, $3dc20189bc4eb89f$export$7484214ab62358d2)()({
            x: event.clientX,
            y: event.clientY,
            placement: this._floatElement.dataset.placement,
            onClose: ()=>{
                window.removeEventListener("mousemove", this._handleMouseMove);
                if (this._floatElement) this._floatElement.hide();
                (0, $3dc20189bc4eb89f$export$ada5ccdc621e6e28)(this.polygonRef);
            },
            elements: {
                domReference: this.element,
                floating: this._floatElement
            },
            polygonRef: this.polygonRef
        });
        this.safePolygonFn(event);
        window.addEventListener("mousemove", this._handleMouseMove);
    };
    _handleMouseMove = (event)=>{
        this.safePolygonFn(event);
    };
    setTargetListeners(action) {
        const { targets: targets , firstTarget: firstTarget , lastTarget: lastTarget  } = this.getTargets();
        const setter = action === "add" ? (0, $eceaf86a082c33f7$export$72de9d21dee7d369) : (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b);
        setter(firstTarget, "focus", this._handleFirstTargetFocus);
        targets.forEach((target)=>{
            setter(target, "focus", this._handleTargetFocus);
        });
        setter(lastTarget, "blur", this._handleLastTargetBlur);
        setter(window, "click", this._handleWindowClick);
    }
    getElement() {
        const elementSelector = `[data-float-element-trigger="${this.dataset.floatElementId}"]`;
        return this.querySelector(elementSelector) || this;
    }
    getTargets() {
        const element = this._floatElement.element;
        const targets = [
            ...element.querySelectorAll((0, $eceaf86a082c33f7$export$f2d94ec8507fd10b)())
        ];
        const firstTarget = targets[0];
        const lastTarget = targets[targets.length - 1];
        return {
            targets: targets,
            firstTarget: firstTarget,
            lastTarget: lastTarget
        };
    }
    _isTargetOutsideFloatElements(target) {
        const isInsideFloatElement = this._floatElement.contains(target);
        const isInsideFloatElementBtn = this.contains(target);
        return !isInsideFloatElement && !isInsideFloatElementBtn;
    }
    trigger = ()=>{
        if (this._trigger === "click") {
            this._floatElement.isOpen ? this._floatElement.hide() : this._floatElement.show();
            (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(window, "click", this._handleWindowClick);
        } else {
            this._floatElement.show();
            (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this.element, "mouseleave", this._handleMouseLeave);
        }
    };
    setExpand(isExpanded) {
        this.setAttribute("data-aria-expanded", isExpanded);
    }
    get _floatElement() {
        if (!this.dataset.floatElementId) return;
        return document.getElementById(this.dataset.floatElementId);
    }
    get isOpen() {
        return this._floatElement.isOpen;
    }
}
var $bd45563d04ffcec6$export$2e2bcd8739ae039 = $bd45563d04ffcec6$var$FloatElementBtn;





class $a09efbdcaecab19d$var$DropdownOpener extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.element = this.getElement();
    }
    connectedCallback() {
        if (this._floatElement) {
            customElements.upgrade(this._floatElement) // https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/upgrade
            ;
            this._floatElement.subscribe("show", this._handleDropdownShow);
            this._floatElement.subscribe("hide", this._handleDropdownHide);
        }
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this.element, "blur", this._handleBlur);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this.element, "keyup", this._handleKeyUp);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this.element, "mousedown", this._handleTrigger);
    }
    disconnectedCallback() {
        if (this._floatElement) {
            this._floatElement.unsubscribe("show", this._handleDropdownShow);
            this._floatElement.unsubscribe("hide", this._handleDropdownHide);
        }
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this.element, "blur", this._handleBlur);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this.element, "keyup", this._handleKeyUp);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this.element, "mousedown", this._handleTrigger);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(window, "click", this._handleUntrigger);
    }
    _handleBlur = ()=>{
        const { targets: targets  } = this.getTargets();
        this.blurElementTimeoutId = setTimeout(()=>{
            if (!targets.includes(document.activeElement)) {
                if (!this._floatElement) return;
                this.setTargetListeners("remove");
                this._floatElement.hide();
            }
        }, 0);
    };
    _handleDropdownShow = ()=>{
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(window, "keydown", this._handleDropdownKeyDown);
    };
    _handleDropdownHide = ()=>{
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(window, "keydown", this._handleDropdownKeyDown);
    };
    _handleKeyUp = (event)=>{
        if (!this._floatElement) return;
        const key = event.key || event.keyCode;
        const isEnterKey = (0, $eceaf86a082c33f7$export$793b145c7f680179)(key);
        if (isEnterKey) {
            if (!this._floatElement.isOpen) {
                this._floatElement.show();
                this.setTargetListeners("add");
            }
            return;
        }
    };
    _handleDropdownKeyDown = (event)=>{
        if (!this._floatElement) return;
        const key = event.key || event.keyCode;
        const isEscapeKey = key === (0, $0f1057c27003f13c$export$3f0d637ce77a8721).ESCAPE_STRING_KEY || key === (0, $0f1057c27003f13c$export$3f0d637ce77a8721).ESCAPE_NUMBER_KEY;
        if (isEscapeKey) {
            if (this._floatElement.isOpen) {
                this.element.focus();
                this.setTargetListeners("remove");
                this._floatElement.hide();
            }
            return;
        }
    };
    _handleFirstTargetFocus = ()=>{
        clearTimeout(this.blurElementTimeoutId);
    };
    _handleTargetFocus = ()=>{
        clearTimeout(this.blurLastTargetTimeoutId);
    };
    _handleLastTargetBlur = ()=>{
        this.blurLastTargetTimeoutId = setTimeout(()=>{
            if (!this._floatElement) return;
            this.setTargetListeners("remove");
            this._floatElement.hide();
        }, 0);
    };
    _handleTrigger = ()=>{
        this.trigger();
    };
    _handleUntrigger = ({ clientX: x , clientY: y , target: target  })=>{
        if (!this._floatElement) return;
        const isCursorOutside = this._floatElement.checkCursorOutside(x, y);
        const isOutsideFloatElements = this._isTargetOutsideFloatElements(target);
        if (isCursorOutside && isOutsideFloatElements) {
            this._floatElement.hide();
            (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(window, "click", this._handleUntrigger);
        }
    };
    setTargetListeners(action) {
        const { targets: targets , firstTarget: firstTarget , lastTarget: lastTarget  } = this.getTargets();
        const setter = action === "add" ? (0, $eceaf86a082c33f7$export$72de9d21dee7d369) : (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b);
        setter(firstTarget, "focus", this._handleFirstTargetFocus);
        targets.forEach((target)=>{
            setter(target, "focus", this._handleTargetFocus);
        });
        setter(lastTarget, "blur", this._handleLastTargetBlur);
        setter(window, "click", this._handleUntrigger);
    }
    getTargets() {
        if (!this._floatElement) return;
        const element = this._floatElement.element;
        const targets = [
            ...element.querySelectorAll((0, $eceaf86a082c33f7$export$f2d94ec8507fd10b)())
        ];
        const firstTarget = targets[0];
        const lastTarget = targets[targets.length - 1];
        return {
            targets: targets,
            firstTarget: firstTarget,
            lastTarget: lastTarget
        };
    }
    _isTargetOutsideFloatElements(target) {
        if (!this._floatElement) return;
        const isInsideFloatElement = this._floatElement.contains(target);
        const isInsideFloatElementBtn = this.contains(target);
        return !isInsideFloatElement && !isInsideFloatElementBtn;
    }
    getElement() {
        const elementSelector = `[data-float-element-trigger="${this.dataset.floatElementId}"]`;
        return this.querySelector(elementSelector) || this;
    }
    trigger = ()=>{
        if (!this._floatElement) return;
        this._floatElement.isOpen ? this._floatElement.hide() : this._floatElement.show();
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(window, "click", this._handleUntrigger);
    };
    setExpand(isExpanded) {
        this.setAttribute("data-aria-expanded", isExpanded);
    }
    get _floatElement() {
        return document.querySelector(`#${this.dataset.floatElementId}`);
    }
}
var $a09efbdcaecab19d$export$2e2bcd8739ae039 = $a09efbdcaecab19d$var$DropdownOpener;




class $28393f9f207c46ab$var$TooltipTrigger extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "mouseenter", this._handleMouseEnter);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "mouseleave", this._handleMouseLeave);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "mouseenter", this._handleMouseEnter);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "mouseleave", this._handleMouseLeave);
    }
    _handleMouseEnter = ()=>{
        if (!this._floatElement) return;
        this._floatElement.show();
    };
    _handleMouseLeave = ()=>{
        if (!this._floatElement) return;
        this._floatElement.hide();
    };
    setExpand(isExpanded) {
        this.setAttribute("data-aria-expanded", isExpanded ? "true" : "false");
    }
    get _floatElement() {
        if (!this.dataset.floatElementId) return null;
        return document.querySelector(`#${this.dataset.floatElementId}`);
    }
}
var $28393f9f207c46ab$export$2e2bcd8739ae039 = $28393f9f207c46ab$var$TooltipTrigger;





class $4915e32b2b8f0299$var$Accordeon extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._contentSelector = `[data-accordeon-content]`;
        this._contentWrapperSelector = `[data-accordeon-content-wrapper]`;
        this._content = this.querySelector(this._contentSelector);
        this._resizeObserver = new ResizeObserver(this._handleContentResize);
        this._transitionDuration = (0, $e6a5d8115fb64fe3$export$5faba83c1624a4ba)(this);
    }
    connectedCallback() {
        this.updateMaxHeight();
        if (this._content) this._resizeObserver.observe(this._content);
        if (this._isEditorMode) {
            this._editor.subscribe("BLOCK_SELECT", this._handleBlockSelect);
            this._editor.subscribe("BLOCK_DESELECT", this._handleBlockDeselect);
        }
    }
    disconnectedCallback() {
        if (this._content) this._resizeObserver.unobserve(this._content);
        if (this._isEditorMode) this._editor.destroy();
    }
    _handleContentResize = ()=>{
        this.updateMaxHeight();
    };
    _handleBlockSelect = ({ detail: { sectionId: sectionId , blockId: blockId , load: load  }  })=>{
        const contentWrapper = this.querySelector(this._contentWrapperSelector);
        const isCurrentSection = this.dataset.sectionId === sectionId;
        const isCurrentBlock = this.dataset.blockId === blockId;
        const isTarget = isCurrentSection && isCurrentBlock;
        if (isTarget && !this.isExpanded) {
            (0, $e6a5d8115fb64fe3$export$771cf8a539cd846f)(contentWrapper, load);
            (0, $e6a5d8115fb64fe3$export$771cf8a539cd846f)(this, load);
            this.show().then(()=>{
                (0, $e6a5d8115fb64fe3$export$771cf8a539cd846f)(contentWrapper, false);
                (0, $e6a5d8115fb64fe3$export$771cf8a539cd846f)(this, false);
            });
        }
    };
    _handleBlockDeselect = ({ detail: { sectionId: sectionId , blockId: blockId  }  })=>{
        const isTarget = this.dataset.sectionId === sectionId && this.dataset.blockId === blockId;
        if (isTarget && this.isExpanded) this.hide();
    };
    hide() {
        this._setExpand(false);
        return (0, $eceaf86a082c33f7$export$1391212d75b2ee65)(this._transitionDuration);
    }
    show() {
        this._setExpand(true);
        return (0, $eceaf86a082c33f7$export$1391212d75b2ee65)(this._transitionDuration);
    }
    toggle() {
        this._setExpand(!this.isExpanded);
    }
    updateMaxHeight() {
        const accordeon = this.closest("accordeon-component");
        const accordeonContent = this.querySelector(this._contentSelector);
        const accordeonContentWrapper = this.querySelector(this._contentWrapperSelector);
        if (accordeon && accordeonContent && accordeonContentWrapper) {
            const height = accordeon.isExpanded ? accordeonContent.offsetHeight : 0;
            accordeonContentWrapper.style.maxHeight = `${height}px`;
        }
    }
    _setExpand(isExpanded) {
        this.setAttribute("data-aria-expanded", isExpanded ? "true" : "false");
        this.updateMaxHeight();
    }
    get isExpanded() {
        return this.getAttribute("data-aria-expanded") === "true";
    }
    get _contentWrapper() {
        return this.querySelector(this._contentWrapperSelector);
    }
}
var $4915e32b2b8f0299$export$2e2bcd8739ae039 = $4915e32b2b8f0299$var$Accordeon;




class $8f736ebc63d86dda$var$AccordeonBtn extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "focus", this._handleButtonFocus);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "blur", this._handleButtonBlur);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "click", this._handleButtonClick);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "focus", this._handleButtonFocus);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "blur", this._handleButtonBlur);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "click", this._handleButtonClick);
    }
    _handleButtonClick = (event)=>{
        event.preventDefault();
        this.update();
    };
    _handleButtonFocus = ()=>{
        this.addEventListener("keydown", this._handleKeyDown);
    };
    _handleButtonBlur = ()=>{
        this.removeEventListener("keydown", this._handleKeyDown);
    };
    _handleKeyDown = (event)=>{
        const isEnterKey = (0, $eceaf86a082c33f7$export$793b145c7f680179)(event.key || event.keyCode);
        if (isEnterKey) {
            event.preventDefault();
            this.update();
        }
    };
    update() {
        const accordeon = this.closest("accordeon-component");
        if (accordeon) accordeon.toggle();
    }
}
var $8f736ebc63d86dda$export$2e2bcd8739ae039 = $8f736ebc63d86dda$var$AccordeonBtn;




class $ba27785fb9cb3ab9$var$ProductMediaTabs extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._productCard = this.closest("product-card");
        this._productCardInner = this.closest(".product-card__inner");
        this._tabs = [
            ...this.querySelectorAll("product-media-tab")
        ];
        this._selected = null;
    }
    connectedCallback() {
        this.update();
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._productCard, "mouseenter", this._handleMouseEnter);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._productCard, "mouseleave", this._handleMouseLeave);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._productCard, "mouseenter", this._handleMouseEnter);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._productCard, "mouseleave", this._handleMouseLeave);
    }
    _handleMouseEnter = ()=>{
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._productCardInner, "mousemove", this._handleMouseMove);
    };
    _handleMouseLeave = ()=>{
        if (!this._productCard) return;
        const mainImage = this._productCard.querySelector("[data-main-media]");
        if (!mainImage) return;
        if (this._selected) this._reset();
        this._setImageVisible(mainImage, true);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._productCardInner, "mousemove", this._handleMouseMove);
    };
    _handleMouseMove = (event)=>{
        const tab = this._getTabByCoords(event.clientX, event.clientY);
        if (!this._productCard) return;
        if (tab) {
            const mainImage = this._productCard.querySelector("[data-main-media]");
            const img = this._productCard.querySelector(`[data-id="${tab.dataset.id}"]`);
            if (!img || !mainImage) return;
            if (this._selected) this._reset();
            this._setTabSelect(tab, true);
            this._setImageVisible(img, true);
            this._setImageVisible(mainImage, false);
            this._selected = {
                tab: tab,
                img: img
            };
        }
    };
    _getTabByCoords(clientX, clientY) {
        const found = this._tabs.find((tab)=>{
            const tabCoords = tab.getBoundingClientRect();
            const isOverTop = clientY < tabCoords.y;
            const isInsideTabBorder = clientX - tabCoords.x < tabCoords.width;
            return isOverTop && isInsideTabBorder;
        });
        return found;
    }
    update() {
        const tabsLimit = 5;
        this._tabs.forEach((tab, idx)=>{
            tab.style.display = idx + 1 > tabsLimit ? "none" : "flex";
        });
    }
    _setTabSelect(tab, isSelected) {
        tab.classList.toggle("selected", isSelected);
    }
    _setImageVisible(img, isVisible) {
        img.classList.toggle("product-card__img--visible", isVisible);
    }
    _reset() {
        if (!this._selected) return;
        this._selected.img.classList.remove("product-card__img--visible");
        this._selected.tab.classList.remove("selected");
        this._selected = null;
    }
}
var $ba27785fb9cb3ab9$export$2e2bcd8739ae039 = $ba27785fb9cb3ab9$var$ProductMediaTabs;





class $bbc6c05f63396c80$var$ColorSwatchesLabel {
    constructor(element){
        this.element = element;
    }
    update(color) {
        this.element.innerText = color ? (0, $eceaf86a082c33f7$export$9a00dee1beb8f576)(color) : "";
    }
}
var $bbc6c05f63396c80$export$2e2bcd8739ae039 = $bbc6c05f63396c80$var$ColorSwatchesLabel;


class $a249bc13f11faca0$var$ProductCardColorSwatches extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.hiddenCountSelector = `[data-color-swatches-hidden-count]`;
        this.labelSelector = `[data-color-swatches-label]`;
        this.itemSelector = `[data-color-swatches-item]`;
        this._hiddenCount = this.querySelector(this.hiddenCountSelector);
        this._label = this.querySelector(this.labelSelector);
        this._items = [
            ...this.querySelectorAll(this.itemSelector)
        ];
        this._productCard = this.closest("product-card");
        if (this._productCard) this.mainImage = this._productCard.querySelector("[data-main-media]");
        if (this._label) this._labelComponent = new (0, $bbc6c05f63396c80$export$2e2bcd8739ae039)(this._label);
    }
    connectedCallback() {
        this.update();
        this._items.forEach((item)=>{
            item.addEventListener("mouseenter", this.handleSwatchEnter);
            item.addEventListener("mouseleave", this.handleSwatchLeave);
        });
    }
    disconnectedCallback() {
        this._items.forEach((item)=>{
            item.removeEventListener("mouseenter", this.handleSwatchEnter);
            item.removeEventListener("mouseleave", this.handleSwatchLeave);
        });
    }
    handleSwatchEnter = (event)=>{
        if (!this._productCard) return;
        const target = event.target;
        const variantId = target.dataset.variantId;
        const image = this._productCard.querySelector(`[data-variant-id="${variantId}"]`);
        const color = target.dataset.color;
        if (!image || !this.mainImage || !color) return;
        this.updateLabel(color);
        this._setImageVisible(image, true);
        this._setImageVisible(this.mainImage, false);
        this.currentVisibleImage = image;
    };
    handleSwatchLeave = ()=>{
        this.updateLabel("");
        if (this.currentVisibleImage) this._setImageVisible(this.currentVisibleImage, false);
        if (this.mainImage) this._setImageVisible(this.mainImage, true);
    };
    update() {
        this._setSwatchesOffset();
        this._setSwatches();
        this._updateCount();
    }
    _setImageVisible(img, isVisible) {
        img.classList.toggle("product-card__img--visible", isVisible);
    }
    _setSwatchesOffset() {
        this._items.forEach((swatch)=>{
            this._setVisible(swatch, true);
            swatch.dataset.x = `${swatch.offsetLeft + swatch.offsetWidth}`;
        });
    }
    _setSwatches() {
        const hiddenCountWidth = parseInt((0, $e6a5d8115fb64fe3$export$d107df9a86338a09)(this._hiddenCount, "width"));
        this._items.forEach((swatch, index)=>{
            const isOverflow = +(swatch.dataset.x || 0) > this.offsetWidth - hiddenCountWidth;
            const isOverlimit = index + 1 > +(this.dataset.limit || 0);
            this._setVisible(swatch, !(isOverflow || isOverlimit));
        });
    }
    _updateCount() {
        if (!this._hiddenCount) return;
        const notHiddenSwatches = this._items.filter((item)=>!item.classList.contains("hide"));
        const count = +(this.dataset.count || 0) - notHiddenSwatches.length;
        if (count > 0) {
            (0, $e6a5d8115fb64fe3$export$998191bfdf710c72)(this._hiddenCount);
            this._hiddenCount.innerText = `${count}`;
        } else (0, $e6a5d8115fb64fe3$export$7669482c90f5c50f)(this._hiddenCount);
    }
    updateLabel(color) {
        if (!this._labelComponent) return;
        this._labelComponent.update(color);
    }
    _setVisible(swatch, isVisible) {
        swatch.classList.toggle("hide", !isVisible);
    }
}
var $a249bc13f11faca0$export$2e2bcd8739ae039 = $a249bc13f11faca0$var$ProductCardColorSwatches;







class $ec846921809d9add$var$Modal extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._template = this.querySelector("template");
        this.element = (0, $e6a5d8115fb64fe3$export$8ea4fc17cec6f158)(this._template);
    }
    _handleKeydown = (event)=>{
        const key = event.key || event.keyCode;
        const isEscape = key === (0, $0f1057c27003f13c$export$3f0d637ce77a8721).ESCAPE_STRING_KEY || key === (0, $0f1057c27003f13c$export$3f0d637ce77a8721).ESCAPE_NUMBER_KEY;
        if (isEscape) this.hide();
    };
    _handleOutsideClick = (event)=>{
        const overlay = document.getElementById("BodyOverlay");
        const overlayZIndex = parseFloat((0, $e6a5d8115fb64fe3$export$d107df9a86338a09)(overlay, "zIndex"));
        const zIndex = parseFloat((0, $e6a5d8115fb64fe3$export$d107df9a86338a09)(this, "zIndex")) - 1;
        const isOverlay = event.target === overlay;
        const isOutsideClick = isOverlay && overlayZIndex <= zIndex;
        if (isOutsideClick && this.isOpen) this.hide();
    };
    show() {
        this._mount();
        this.focus();
        setTimeout(()=>{
            this._setOpenState(true);
        }, 0);
        this.isOpen = true;
    }
    hide() {
        this._setOpenState(false);
        return (0, $eceaf86a082c33f7$export$1391212d75b2ee65)(this._transitionDuration).then(()=>{
            this._unmount();
            this.isOpen = false;
        });
    }
    toggle() {
        if (this.isOpen) this.hide();
        else this.show();
    }
    _mount() {
        if (this.element && !this.contains(this.element)) this.appendChild(this.element);
    }
    _unmount() {
        if (this.element) this.element.remove();
    }
    _setOpenState(isOpen) {
        const isImportant = this.hasAttribute("data-overlay-important");
        const overlayOpacity = this.getAttribute("data-overlay-opacity") || 50;
        const styles = {
            zIndex: isImportant ? parseFloat((0, $e6a5d8115fb64fe3$export$d107df9a86338a09)(this, "zIndex")) - 1 : 3,
            backgroundColor: `var(--gsc-black-color-${overlayOpacity})`
        };
        isOpen ? (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).showOverlay(this.id, styles) : (0, $eceaf86a082c33f7$export$1391212d75b2ee65)(this._transitionDuration).then(()=>{
            (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).hideOverlay(this.id);
        });
        this._setVisible(isOpen);
        this._setListeners(isOpen ? "add" : "remove");
        this.emit(isOpen ? "show" : "hide", {});
    }
    _setVisible(isVisible) {
        this.toggleAttribute("open", isVisible);
    }
    _setListeners(action) {
        const withOutsideClick = this.hasAttribute("data-with-close-on-outside");
        const eventListenerSetter = `${action}EventListener`;
        if (withOutsideClick) window[eventListenerSetter]("click", this._handleOutsideClick);
        window[eventListenerSetter]("keydown", this._handleKeydown);
    }
    get _transitionDuration() {
        const transitionDuration = (0, $e6a5d8115fb64fe3$export$5faba83c1624a4ba)(this);
        const transitionDelay = (0, $e6a5d8115fb64fe3$export$b8efffc5da5ea806)(this);
        return transitionDuration + transitionDelay;
    }
}
var $ec846921809d9add$export$2e2bcd8739ae039 = $ec846921809d9add$var$Modal;



class $335ac12974ab4752$var$PasswordModal extends (0, $ec846921809d9add$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.passwordInput = this.querySelector("[password-modal-input]");
    }
    show() {
        super.show();
        if (this.passwordInput) this.passwordInput.focus();
    }
}
var $335ac12974ab4752$export$2e2bcd8739ae039 = $335ac12974ab4752$var$PasswordModal;




class $c6fe2e6e54c0399a$var$CartNotificationPopup extends (0, $ec846921809d9add$export$2e2bcd8739ae039) {
    showProductFromParsedState(parsedState, productId) {
        const section = parsedState.sections["cart-notification-popup-content"];
        const sectionHTML = (0, $e6a5d8115fb64fe3$export$8a49393be2d55148)(section);
        if (this.element) {
            const targetProduct = sectionHTML.querySelector(`#CartNotificationPopupItem-${productId}`);
            const content = this.element.querySelector("[data-cart-notification-popup]");
            if (content && targetProduct) {
                content.innerHTML = "";
                content.appendChild(targetProduct);
            }
            this._updateCartCountInHeader(parsedState);
            this.show();
        }
    }
    _updateCartCountInHeader(parsedState) {
        const section = parsedState.sections["cart-count"];
        const sectionHTML = (0, $e6a5d8115fb64fe3$export$8a49393be2d55148)(section);
        const count = document.getElementById("CartCount");
        const stickyCount = document.getElementById("StickyCartCount");
        const newCount = sectionHTML.getElementById("CartCount");
        if (stickyCount && newCount) stickyCount.innerHTML = newCount.innerHTML;
        if (count && newCount) count.innerHTML = newCount.innerHTML;
    }
}
var $c6fe2e6e54c0399a$export$2e2bcd8739ae039 = $c6fe2e6e54c0399a$var$CartNotificationPopup;




class $baa3d328c6b64361$var$ModalOpener extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "focus", this._handleButtonFocus);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "blur", this._handleButtonBlur);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "click", this._handleButtonClick);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "focus", this._handleButtonFocus);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "blur", this._handleButtonBlur);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "click", this._handleButtonClick);
    }
    _handleButtonClick = ()=>{
        this.showModal();
        this.emit("click", {});
    };
    _handleButtonFocus = ()=>{
        this.addEventListener("keydown", this._handleKeyDown);
    };
    _handleButtonBlur = ()=>{
        this.removeEventListener("keydown", this._handleKeyDown);
    };
    _handleKeyDown = (event)=>{
        const isEnterKey = (0, $eceaf86a082c33f7$export$793b145c7f680179)(event.key || event.keyCode);
        if (isEnterKey && this.dataset.modal) {
            event.preventDefault();
            const modal = document.querySelector(this.dataset.modal);
            if (modal) modal.toggle();
        }
    };
    showModal() {
        if (this.dataset.modal) {
            const modal = document.querySelector(this.dataset.modal);
            if (modal) modal.show();
        }
    }
}
var $baa3d328c6b64361$export$2e2bcd8739ae039 = $baa3d328c6b64361$var$ModalOpener;



class $e158d692ac96ed15$var$PasswordModalOpener extends (0, $baa3d328c6b64361$export$2e2bcd8739ae039) {
    connectedCallback() {
        super.connectedCallback();
        this.focus();
    }
}
var $e158d692ac96ed15$export$2e2bcd8739ae039 = $e158d692ac96ed15$var$PasswordModalOpener;




class $11698316884f01b7$var$ModalCloseBtn extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "focus", this._handleButtonFocus);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "blur", this._handleButtonBlur);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "click", this._handleButtonClick);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "focus", this._handleButtonFocus);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "blur", this._handleButtonBlur);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "click", this._handleButtonClick);
    }
    _handleButtonClick = ()=>{
        this.hide();
    };
    _handleButtonFocus = ()=>{
        this.addEventListener("keydown", this._handleKeyDown);
    };
    _handleButtonBlur = ()=>{
        this.removeEventListener("keydown", this._handleKeyDown);
    };
    _handleKeyDown = (event)=>{
        const isEnterKey = (0, $eceaf86a082c33f7$export$793b145c7f680179)(event.key || event.keyCode);
        if (isEnterKey) {
            event.preventDefault();
            this.hide();
        }
    };
    hide() {
        if (this.dataset.modal) {
            const modal = document.querySelector(this.dataset.modal);
            if (modal) modal.hide();
        }
    }
}
var $11698316884f01b7$export$2e2bcd8739ae039 = $11698316884f01b7$var$ModalCloseBtn;




class $19960a3413ca07cd$var$SidebarBtn extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.buttonSelector = `[data-sidebar-button]`;
        this.button = this.querySelector(this.buttonSelector);
    }
    connectedCallback() {
        if (this.button) {
            this.button.addEventListener("click", this._handleButtonClick);
            this.button.addEventListener("focus", this._handleButtonFocus);
            this.button.addEventListener("blur", this._handleButtonBlur);
            this.button.addEventListener("mousedown", this.handleButtonMouseDown);
            this.button.addEventListener("mousemove", this.handleButtonMouseMove);
            this.button.addEventListener("mouseup", this.handleButtonMouseUp);
        }
    }
    disconnectedCallback() {
        if (this.button) {
            this.button.removeEventListener("click", this._handleButtonClick);
            this.button.removeEventListener("focus", this._handleButtonFocus);
            this.button.removeEventListener("blur", this._handleButtonBlur);
            this.button.removeEventListener("mousedown", this.handleButtonMouseDown);
            this.button.removeEventListener("mousemove", this.handleButtonMouseMove);
            this.button.removeEventListener("mouseup", this.handleButtonMouseUp);
        }
    }
    _handleButtonClick = (event)=>{
        event.preventDefault();
    };
    handleButtonMouseDown = (event)=>{
        event.preventDefault();
        const carouselParent = this.closest("carousel-component");
        const dotsCarouselParent = this.closest("carousel-dots");
        this.isDraggingInCarousel = !!(carouselParent || dotsCarouselParent);
        if (this.isDraggingInCarousel) {
            this.setMoveStartPoint(event.clientX, event.clientY);
            this.toggleAfterDraggingInCarousel = true;
        } else this.toggle();
    };
    handleButtonMouseMove = (event)=>{
        if (this.isDraggingInCarousel) {
            const threshold = 24;
            const distanceX = Math.abs(this.startPointX - event.clientX);
            const distanceY = Math.abs(this.startPointY - event.clientY);
            const isAboveThanThreshold = distanceX > threshold || distanceY > threshold;
            if (isAboveThanThreshold) this.toggleAfterDraggingInCarousel = false;
        }
    };
    handleButtonMouseUp = ()=>{
        if (this.isDraggingInCarousel) {
            if (this.toggleAfterDraggingInCarousel) this.toggle();
            this.isDraggingInCarousel = false;
            this.toggleAfterDraggingInCarousel = false;
            this.setMoveStartPoint(0, 0);
        }
    };
    _handleButtonFocus = ()=>{
        if (this.button) this.button.addEventListener("keydown", this.handleKeyDown);
    };
    _handleButtonBlur = ()=>{
        if (this.button) this.button.removeEventListener("keydown", this.handleKeyDown);
    };
    handleKeyDown = (event)=>{
        const isEnterKey = (0, $eceaf86a082c33f7$export$793b145c7f680179)(event.key || event.keyCode);
        if (isEnterKey) {
            event.preventDefault();
            this.toggle();
        }
    };
    setMoveStartPoint(x, y) {
        this.startPointX = x;
        this.startPointY = y;
    }
    toggle() {
        if (this.button) {
            const sidebarId = this.button.dataset.sidebarId || "";
            const sidebar = document.querySelector(`#${sidebarId}`);
            if (sidebar) {
                sidebar.toggle();
                this.update();
            }
        }
    }
    update() {
        if (this.button) {
            const sidebarId = this.button.dataset.sidebarId || "";
            const sidebar = document.querySelector(`#${sidebarId}`);
            if (sidebar) this.button.setAttribute("data-aria-expanded", sidebar.isOpen ? "true" : "false");
        }
    }
}
var $19960a3413ca07cd$export$2e2bcd8739ae039 = $19960a3413ca07cd$var$SidebarBtn;







class $cc5469d7bf7c0ec5$var$Sidebar extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._template = this.querySelector("template");
        this.element = (0, $e6a5d8115fb64fe3$export$8ea4fc17cec6f158)(this._template);
        this.buttonSelector = `[data-sidebar-button][data-sidebar-id="${this.id}"]`;
        if (this.withOpenOnInit) this.open();
    }
    connectedCallback() {
        this.addEventListener("touchstart", this._handleTouchStart);
        this.addEventListener("touchmove", this._handleTouchMove);
        this.addEventListener("touchend", this._handleTouchEnd);
        if (this._isEditorMode) {
            this._editor.subscribe("SECTION_LOAD", this._handleSectionLoad);
            this._editor.subscribe("SECTION_SELECT", this._handleSectionSelect);
            this._editor.subscribe("SECTION_DESELECT", this._handleSectionDeselect);
        }
    }
    disconnectedCallback() {
        this.removeEventListener("touchstart", this._handleTouchStart);
        this.removeEventListener("touchmove", this._handleTouchMove);
        this.removeEventListener("touchend", this._handleTouchEnd);
        if (this._isEditorMode) this._editor.destroy();
    }
    _handleSectionLoad = ()=>{
        if (!this._isSection && !this.withOpenOnInit) this.hide();
    };
    _handleSectionSelect = ({ detail: { sectionId: sectionId  }  })=>{
        if (this._isSection && this.dataset.sectionId === sectionId) this.open();
    };
    _handleSectionDeselect = ({ detail: { sectionId: sectionId  }  })=>{
        if (this._isSection && this.dataset.sectionId === sectionId) this.hide();
    };
    _handleOutsideClick = (event)=>{
        const overlay = document.getElementById("BodyOverlay");
        const overlayZIndex = parseFloat((0, $e6a5d8115fb64fe3$export$d107df9a86338a09)(overlay, "zIndex"));
        const zIndex = parseFloat((0, $e6a5d8115fb64fe3$export$d107df9a86338a09)(this, "zIndex")) - 1;
        const isOverlay = event.target === overlay;
        const isOutsideClick = isOverlay && overlayZIndex <= zIndex;
        if (isOutsideClick && this.isOpen) this.hide();
    };
    _handleTouchStart = (event)=>{
        this._touchStartX = event.targetTouches[0].clientX;
        this._touchStartY = event.targetTouches[0].clientY;
    };
    _handleTouchMove = (event)=>{
        this._touchEndX = event.targetTouches[0].clientX;
        this._touchEndY = event.targetTouches[0].clientY;
    };
    _handleTouchEnd = (event)=>{
        const X_DIRECTION_THRESHOLD = 96;
        const Y_DIRECTION_THRESHOLD = 48;
        const distanceX = Math.abs(this._touchStartX - this._touchEndX);
        const distanceY = Math.abs(this._touchStartY - this._touchEndY);
        const isCarousel = event.target.closest("[data-carousel-viewport]");
        if (isCarousel) return;
        if (this._touchEndX === 0) return;
        if (distanceY > Y_DIRECTION_THRESHOLD) return;
        const isTrigger = this.dataset.openDirection === "right" ? this._touchStartX < this._touchEndX : this._touchStartX > this._touchEndX;
        if (this.isOpen && distanceX > X_DIRECTION_THRESHOLD && isTrigger) this.hide();
        this.cleanTouchPoints();
    };
    _handleKeydown = (event)=>{
        const key = event.key || event.keyCode;
        const withCloseOnEscape = this.hasAttribute("data-with-close-on-escape");
        const isEscape = key === (0, $0f1057c27003f13c$export$3f0d637ce77a8721).ESCAPE_STRING_KEY || key === (0, $0f1057c27003f13c$export$3f0d637ce77a8721).ESCAPE_NUMBER_KEY;
        if (withCloseOnEscape && isEscape) this.hide();
    };
    cleanTouchPoints() {
        this._touchStartX = 0;
        this._touchEndX = 0;
        this._touchStartY = 0;
        this._touchEndY = 0;
    }
    open() {
        this.mount();
        this.setAttribute("tabindex", "-1");
        this.focus();
        setTimeout(()=>{
            this._setOpenState(true);
        }, 0);
        return (0, $eceaf86a082c33f7$export$1391212d75b2ee65)(this._transitionDuration);
    }
    hide(isInstant) {
        this._setOpenState(false);
        if (isInstant) this.unmount();
        else return (0, $eceaf86a082c33f7$export$1391212d75b2ee65)(this._transitionDuration).then(()=>{
            this.unmount();
        });
    }
    toggle() {
        if (this.isOpen) this.hide();
        else this.open();
    }
    mount() {
        if (!this.contains(this.element)) this.appendChild(this.element);
    }
    unmount() {
        if (this.element) this.element.remove();
    }
    updateTemplate(template) {
        this.element.remove();
        this.element = (0, $e6a5d8115fb64fe3$export$8ea4fc17cec6f158)(template);
        this.appendChild(this.element);
    }
    _setOpenState(isOpen) {
        const withOverlay = this.hasAttribute("data-with-overlay");
        const button = document.querySelector(this.buttonSelector);
        this._setVisible(isOpen);
        this._setListeners(isOpen ? "add" : "remove");
        localStorage.setItem(`sidebar-${this.id}`, `${isOpen}`);
        if (withOverlay) {
            const isImportant = this.hasAttribute("data-overlay-important");
            const overlayOpacity = +(this.getAttribute("data-overlay-opacity") || 50);
            const styles = {
                zIndex: isImportant ? parseFloat((0, $e6a5d8115fb64fe3$export$d107df9a86338a09)(this, "zIndex")) - 1 : 3,
                backgroundColor: `var(--gsc-black-color-${overlayOpacity})`
            };
            isOpen ? (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).showOverlay(this.id, styles) : (0, $eceaf86a082c33f7$export$1391212d75b2ee65)(this._transitionDuration).then(()=>{
                (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).hideOverlay(this.id);
            });
        }
        if (button) button.setAttribute("data-aria-expanded", isOpen ? "true" : "false");
    }
    _setVisible(isVisible) {
        this.setAttribute("data-aria-expanded", isVisible ? "true" : "false");
    }
    _setListeners(action) {
        const withOutsideClick = this.hasAttribute("data-with-close-on-outside");
        const eventListenerSetter = `${action}EventListener`;
        if (withOutsideClick) window[eventListenerSetter]("click", this._handleOutsideClick);
        window[eventListenerSetter]("keydown", this._handleKeydown);
    }
    get _isSection() {
        return this.hasAttribute("data-sidebar-section");
    }
    get isOpen() {
        return this.getAttribute("data-aria-expanded") === "true";
    }
    get withOpenOnInit() {
        return this.hasAttribute("data-with-open-on-init");
    }
    get isOpenBeforeSectionChange() {
        return localStorage.getItem(`sidebar-${this.id}`) === "true";
    }
    get _transitionDuration() {
        const transitionDuration = (0, $e6a5d8115fb64fe3$export$5faba83c1624a4ba)(this);
        const transitionDelay = (0, $e6a5d8115fb64fe3$export$b8efffc5da5ea806)(this);
        return transitionDuration + transitionDelay;
    }
}
var $cc5469d7bf7c0ec5$export$2e2bcd8739ae039 = $cc5469d7bf7c0ec5$var$Sidebar;


const $5d3d77426481432d$export$e7a5aad9bb00dd62 = ()=>{
    const mediaQuery = "(max-width: 768px)";
    const isMobile = matchMedia(mediaQuery).matches;
    return isMobile;
};
const $5d3d77426481432d$export$601dcf7c5dad8f97 = ()=>{
    const mediaQuery = "(prefers-reduced-motion: reduce)";
    const isAnimationReduce = matchMedia(mediaQuery).matches;
    return isAnimationReduce;
};




class $80d19487f0c5c1d0$var$SearchSidebar extends (0, $cc5469d7bf7c0ec5$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.searchInputSelector = `[data-sidebar-search-input]`;
        this.searchInputComponentSelector = `[data-sidebar-search-input-component]`;
        this.contentSelector = `[data-sidebar-search-content]`;
        this.contentResultsSelector = `[data-sidebar-search-content-results]`;
        this.content = this.element.querySelector(this.contentSelector);
        this.contentResults = this.element.querySelector(this.contentResultsSelector);
        this._searchInputComponent = this.element.querySelector(this.searchInputComponentSelector);
        this._searchInput = this.element.querySelector(this.searchInputSelector);
        this._resizeObserver = new ResizeObserver(this._handleContentResultsResize);
        this.defaultStateElement = document;
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.content) this.content.addEventListener("scroll", this._handleContentScroll);
        this.addEventListener("click", this._handleClick);
        this.addEventListener("touchend", this._handleSearchSidebarTouchEnd);
        if (this._searchInput) {
            this._searchInput.addEventListener("focus", this._handleInputFocus);
            this._searchInput.addEventListener("keydown", this._handleInputKeydown);
        }
        if (this.contentResults) this._resizeObserver.observe(this.contentResults);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.content) this.content.removeEventListener("scroll", this._handleContentScroll);
        this.removeEventListener("click", this._handleClick);
        this.removeEventListener("touchend", this._handleSearchSidebarTouchEnd);
        if (this._searchInput) {
            this._searchInput.removeEventListener("focus", this._handleInputFocus);
            this._searchInput.removeEventListener("keydown", this._handleInputKeydown);
        }
        if (this.contentResults) this._resizeObserver.unobserve(this.contentResults);
    }
    _handleInputKeydown = (event)=>{
        const isEnterKey = (0, $eceaf86a082c33f7$export$793b145c7f680179)(event.key || event.keyCode);
        if (isEnterKey) event.preventDefault();
    };
    _handleClick = (event)=>{
        const target = event.target;
        const isMobile = (0, $5d3d77426481432d$export$e7a5aad9bb00dd62)();
        const isInput = target === this._searchInput;
        const isLink = target.tagName === "A";
        const queryElement = target.closest("[data-sidebar-search-query]");
        if (this._searchInput && queryElement) {
            const event = new Event("input", {
                bubbles: true
            });
            this._searchInput.value = `${queryElement.getAttribute("data-sidebar-search-query")}`;
            this._searchInput.dispatchEvent(event);
            this._searchInput.focus();
        }
        if (isMobile && isInput) this.isInputFocused = true;
        if (!isInput && this.isInputFocused) {
            if (isLink) event.preventDefault();
            this.isInputFocused = false;
        }
    };
    _handleInputFocus = ()=>{
        const isMobile = (0, $5d3d77426481432d$export$e7a5aad9bb00dd62)();
        if (isMobile) this.isInputFocused = true;
    };
    _handleSearchSidebarTouchEnd = (event)=>{
        const THRESHOLD = 12;
        const target = event.target;
        const distanceX = Math.abs(this._touchStartX - this._touchEndX);
        const distanceY = Math.abs(this._touchStartY - this._touchEndY);
        const isDistanceOverThreshold = distanceX > THRESHOLD || distanceY > THRESHOLD;
        const isLink = target.tagName === "A";
        if (this.isInputFocused && isDistanceOverThreshold && this._searchInput) {
            if (isLink) event.preventDefault();
            this._searchInput.blur();
            this.isInputFocused = false;
        }
        this.cleanTouchPoints();
    };
    _handleContentResultsResize = ()=>{
        this.updateViewport();
    };
    _handleContentScroll = ()=>{
        if (this.content) {
            const isContentOverflow = this.checkContentOverflow();
            const isScrolled = this.content.scrollTop > 0;
            this.toggleAttribute("header-shadow-visible", isContentOverflow && isScrolled);
        }
    };
    updateViewport() {
        const isContentOverflow = this.checkContentOverflow();
        this.toggleAttribute("footer-shadow-visible", isContentOverflow);
    }
    open() {
        return super.open().then(()=>{
            if (this._searchInput && !this._isEditorMode) this._searchInput.focus();
        });
    }
    checkContentOverflow() {
        if (!this.contentResults || !this.content) return false;
        return this.contentResults.offsetHeight > this.content.offsetHeight;
    }
}
var $80d19487f0c5c1d0$export$2e2bcd8739ae039 = $80d19487f0c5c1d0$var$SearchSidebar;





const { Shopify: $24d4ac9481bec18a$var$Shopify  } = window;
class $24d4ac9481bec18a$var$QuickViewComponent extends (0, $cc5469d7bf7c0ec5$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._cache = {};
    }
    requestProductFromUrl(url, id) {
        this._resetProduct();
        if (!this._cache[url]) {
            this.onThisPageRenderedQuickView = document.querySelector(`.shopify-section [data-quick-view-product-id="${id}"]`);
            if (this.onThisPageRenderedQuickView && this.onThisPageRenderedQuickView.dataset.quickViewProductUrl === url) this._cache[url] = (0, $eceaf86a082c33f7$export$1391212d75b2ee65)(0).then(()=>this.onThisPageRenderedQuickView);
            else this._cache[url] = fetch(url).then((response)=>response.text()).then((responseText)=>(0, $e6a5d8115fb64fe3$export$8a49393be2d55148)(responseText));
        }
    }
    _handleContentScroll = ()=>{
        const isScrolled = this.content ? this.content.scrollTop > 0 : false;
        this.toggleAttribute("header-shadow-visible", isScrolled);
    };
    open() {
    //
    }
    openAndRenderProductByUrl = (url)=>{
        if (this._cache[url]) this._cache[url].then((html)=>{
            this._setProductFromHTML(html);
            if (this.onThisPageRenderedQuickView) this.onThisPageRenderedQuickView.innerHTML = "";
            if (!this.isOpen) super.open();
            $24d4ac9481bec18a$var$Shopify?.PaymentButton?.init();
        });
    };
    _setProductFromHTML(html) {
        if (this.dataset.targetId) {
            const target = html.getElementById(this.dataset.targetId);
            if (target) {
                const targetClass = target.getAttribute("class") || "";
                this.element.setAttribute("class", targetClass);
                this.element.innerHTML = target.innerHTML;
                this.content = this.element.querySelector("[data-quick-view-content]");
                if (this.content) this.content.addEventListener("scroll", this._handleContentScroll);
            }
        }
    }
    _resetProduct() {
        if (this.content) {
            this.content.removeEventListener("scroll", this._handleContentScroll);
            if (this.onThisPageRenderedQuickView) this.onThisPageRenderedQuickView.innerHTML = this.content.innerHTML;
            this.content = null;
        }
        this.element.innerHTML = "";
    }
}
var $24d4ac9481bec18a$export$2e2bcd8739ae039 = $24d4ac9481bec18a$var$QuickViewComponent;



function $b943896dbfd2206b$var$map(value, iStart, iStop, oStart, oStop) {
    return oStart + (oStop - oStart) * ((value - iStart) / (iStop - iStart));
}
function $b943896dbfd2206b$var$isNumber(subject) {
    return typeof subject === "number";
}
function $b943896dbfd2206b$var$isString(subject) {
    return typeof subject === "string";
}
function $b943896dbfd2206b$var$isObject(subject) {
    return Object.prototype.toString.call(subject) === "[object Object]";
}
function $b943896dbfd2206b$var$isArray(subject) {
    return Array.isArray(subject);
}
function $b943896dbfd2206b$var$isRecord(subject) {
    return $b943896dbfd2206b$var$isObject(subject) || $b943896dbfd2206b$var$isArray(subject);
}
function $b943896dbfd2206b$var$mathAbs(n) {
    return Math.abs(n);
}
function $b943896dbfd2206b$var$mathSign(n) {
    return !n ? 0 : n / $b943896dbfd2206b$var$mathAbs(n);
}
function $b943896dbfd2206b$var$deltaAbs(valueB, valueA) {
    return $b943896dbfd2206b$var$mathAbs(valueB - valueA);
}
function $b943896dbfd2206b$var$factorAbs(valueB, valueA) {
    if (valueB === 0 || valueA === 0) return 0;
    if ($b943896dbfd2206b$var$mathAbs(valueB) <= $b943896dbfd2206b$var$mathAbs(valueA)) return 0;
    var diff = $b943896dbfd2206b$var$deltaAbs($b943896dbfd2206b$var$mathAbs(valueB), $b943896dbfd2206b$var$mathAbs(valueA));
    return $b943896dbfd2206b$var$mathAbs(diff / valueB);
}
function $b943896dbfd2206b$var$roundToDecimals(decimalPoints) {
    var pow = Math.pow(10, decimalPoints);
    return function(n) {
        return Math.round(n * pow) / pow;
    };
}
function $b943896dbfd2206b$var$arrayKeys(array) {
    return $b943896dbfd2206b$var$objectKeys(array).map(Number);
}
function $b943896dbfd2206b$var$arrayLast(array) {
    return array[$b943896dbfd2206b$var$arrayLastIndex(array)];
}
function $b943896dbfd2206b$var$arrayLastIndex(array) {
    return Math.max(0, array.length - 1);
}
function $b943896dbfd2206b$var$objectKeys(object) {
    return Object.keys(object);
}
function $b943896dbfd2206b$var$objectsMergeDeep(objectA, objectB) {
    return [
        objectA,
        objectB
    ].reduce(function(mergedObjects, currentObject) {
        $b943896dbfd2206b$var$objectKeys(currentObject).forEach(function(key) {
            var valueA = mergedObjects[key];
            var valueB = currentObject[key];
            var areObjects = $b943896dbfd2206b$var$isObject(valueA) && $b943896dbfd2206b$var$isObject(valueB);
            mergedObjects[key] = areObjects ? $b943896dbfd2206b$var$objectsMergeDeep(valueA, valueB) : valueB;
        });
        return mergedObjects;
    }, {});
}
function $b943896dbfd2206b$var$objectsAreEqual(objectA, objectB) {
    var objectAKeys = $b943896dbfd2206b$var$objectKeys(objectA);
    var objectBKeys = $b943896dbfd2206b$var$objectKeys(objectB);
    if (objectAKeys.length !== objectBKeys.length) return false;
    return objectAKeys.every(function(key) {
        var valueA = objectA[key];
        var valueB = objectB[key];
        if (typeof valueA === "function") return "".concat(valueA) === "".concat(valueB);
        if (!$b943896dbfd2206b$var$isRecord(valueA) || !$b943896dbfd2206b$var$isRecord(valueB)) return valueA === valueB;
        return $b943896dbfd2206b$var$objectsAreEqual(valueA, valueB);
    });
}
function $b943896dbfd2206b$var$Alignment(align, viewSize) {
    var predefined = {
        start: start,
        center: center,
        end: end
    };
    function start() {
        return 0;
    }
    function center(n) {
        return end(n) / 2;
    }
    function end(n) {
        return viewSize - n;
    }
    function percent() {
        return viewSize * Number(align);
    }
    function measure(n) {
        if ($b943896dbfd2206b$var$isNumber(align)) return percent();
        return predefined[align](n);
    }
    var self = {
        measure: measure
    };
    return self;
}
function $b943896dbfd2206b$var$Animation(callback) {
    var animationFrame = 0;
    function ifAnimating(active, cb) {
        return function() {
            if (active === !!animationFrame) cb();
        };
    }
    function start() {
        animationFrame = window.requestAnimationFrame(callback);
    }
    function stop() {
        window.cancelAnimationFrame(animationFrame);
        animationFrame = 0;
    }
    var self = {
        proceed: ifAnimating(true, start),
        start: ifAnimating(false, start),
        stop: ifAnimating(true, stop)
    };
    return self;
}
function $b943896dbfd2206b$var$Axis(axis, direction) {
    var scroll = axis === "y" ? "y" : "x";
    var cross = axis === "y" ? "x" : "y";
    var startEdge = getStartEdge();
    var endEdge = getEndEdge();
    function measureSize(rect) {
        var width = rect.width, height = rect.height;
        return scroll === "x" ? width : height;
    }
    function getStartEdge() {
        if (scroll === "y") return "top";
        return direction === "rtl" ? "right" : "left";
    }
    function getEndEdge() {
        if (scroll === "y") return "bottom";
        return direction === "rtl" ? "left" : "right";
    }
    var self = {
        scroll: scroll,
        cross: cross,
        startEdge: startEdge,
        endEdge: endEdge,
        measureSize: measureSize
    };
    return self;
}
function $b943896dbfd2206b$var$Limit(min, max) {
    var length = $b943896dbfd2206b$var$mathAbs(min - max);
    function reachedMin(n) {
        return n < min;
    }
    function reachedMax(n) {
        return n > max;
    }
    function reachedAny(n) {
        return reachedMin(n) || reachedMax(n);
    }
    function constrain(n) {
        if (!reachedAny(n)) return n;
        return reachedMin(n) ? min : max;
    }
    function removeOffset(n) {
        if (!length) return n;
        return n - length * Math.ceil((n - max) / length);
    }
    var self = {
        length: length,
        max: max,
        min: min,
        constrain: constrain,
        reachedAny: reachedAny,
        reachedMax: reachedMax,
        reachedMin: reachedMin,
        removeOffset: removeOffset
    };
    return self;
}
function $b943896dbfd2206b$var$Counter(max, start, loop) {
    var _a = $b943896dbfd2206b$var$Limit(0, max), min = _a.min, constrain = _a.constrain;
    var loopEnd = max + 1;
    var counter = withinLimit(start);
    function withinLimit(n) {
        return !loop ? constrain(n) : $b943896dbfd2206b$var$mathAbs((loopEnd + n) % loopEnd);
    }
    function get() {
        return counter;
    }
    function set(n) {
        counter = withinLimit(n);
        return self;
    }
    function add(n) {
        return set(get() + n);
    }
    function clone() {
        return $b943896dbfd2206b$var$Counter(max, get(), loop);
    }
    var self = {
        add: add,
        clone: clone,
        get: get,
        set: set,
        min: min,
        max: max
    };
    return self;
}
function $b943896dbfd2206b$var$Direction(direction) {
    var sign = direction === "rtl" ? -1 : 1;
    function apply(n) {
        return n * sign;
    }
    var self = {
        apply: apply
    };
    return self;
}
function $b943896dbfd2206b$var$EventStore() {
    var listeners = [];
    function add(node, type, handler, options) {
        if (options === void 0) options = {
            passive: true
        };
        node.addEventListener(type, handler, options);
        listeners.push(function() {
            return node.removeEventListener(type, handler, options);
        });
        return self;
    }
    function removeAll() {
        listeners = listeners.filter(function(remove) {
            return remove();
        });
        return self;
    }
    var self = {
        add: add,
        removeAll: removeAll
    };
    return self;
}
function $b943896dbfd2206b$var$Vector1D(value) {
    var vector = value;
    function get() {
        return vector;
    }
    function set(n) {
        vector = readNumber(n);
        return self;
    }
    function add(n) {
        vector += readNumber(n);
        return self;
    }
    function subtract(n) {
        vector -= readNumber(n);
        return self;
    }
    function multiply(n) {
        vector *= n;
        return self;
    }
    function divide(n) {
        vector /= n;
        return self;
    }
    function normalize() {
        if (vector !== 0) divide(vector);
        return self;
    }
    function readNumber(n) {
        return $b943896dbfd2206b$var$isNumber(n) ? n : n.get();
    }
    var self = {
        add: add,
        divide: divide,
        get: get,
        multiply: multiply,
        normalize: normalize,
        set: set,
        subtract: subtract
    };
    return self;
}
function $b943896dbfd2206b$var$DragHandler(axis, direction, rootNode, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, loop, dragFree, skipSnaps) {
    var crossAxis = axis.cross;
    var focusNodes = [
        "INPUT",
        "SELECT",
        "TEXTAREA"
    ];
    var nonPassiveEvent = {
        passive: false
    };
    var dragStartPoint = $b943896dbfd2206b$var$Vector1D(0);
    var activationEvents = $b943896dbfd2206b$var$EventStore();
    var interactionEvents = $b943896dbfd2206b$var$EventStore();
    var dragThreshold = percentOfView.measure(20);
    var snapForceBoost = {
        mouse: 300,
        touch: 400
    };
    var freeForceBoost = {
        mouse: 500,
        touch: 600
    };
    var baseSpeed = dragFree ? 5 : 16;
    var baseMass = 1;
    var startScroll = 0;
    var startCross = 0;
    var pointerIsDown = false;
    var preventScroll = false;
    var preventClick = false;
    var isMouse = false;
    function addActivationEvents() {
        var node = rootNode;
        activationEvents.add(node, "dragstart", function(evt) {
            return evt.preventDefault();
        }, nonPassiveEvent).add(node, "touchmove", function() {
            return undefined;
        }, nonPassiveEvent).add(node, "touchend", function() {
            return undefined;
        }).add(node, "touchstart", down).add(node, "mousedown", down).add(node, "touchcancel", up).add(node, "contextmenu", up).add(node, "click", click, true);
    }
    function addInteractionEvents() {
        var node = isMouse ? document : rootNode;
        interactionEvents.add(node, "touchmove", move, nonPassiveEvent).add(node, "touchend", up).add(node, "mousemove", move, nonPassiveEvent).add(node, "mouseup", up);
    }
    function removeAllEvents() {
        activationEvents.removeAll();
        interactionEvents.removeAll();
    }
    function isFocusNode(node) {
        var name = node.nodeName || "";
        return focusNodes.indexOf(name) > -1;
    }
    function forceBoost() {
        var boost = dragFree ? freeForceBoost : snapForceBoost;
        var type = isMouse ? "mouse" : "touch";
        return boost[type];
    }
    function allowedForce(force, targetChanged) {
        var next = index.clone().add($b943896dbfd2206b$var$mathSign(force) * -1);
        var isEdge = next.get() === index.min || next.get() === index.max;
        var baseForce = scrollTarget.byDistance(force, !dragFree).distance;
        if (dragFree || $b943896dbfd2206b$var$mathAbs(force) < dragThreshold) return baseForce;
        if (!loop && isEdge) return baseForce * 0.4;
        if (skipSnaps && targetChanged) return baseForce * 0.5;
        return scrollTarget.byIndex(next.get(), 0).distance;
    }
    function down(evt) {
        isMouse = !dragTracker.isTouchEvent(evt);
        if (isMouse && evt.button !== 0) return;
        if (isFocusNode(evt.target)) return;
        var isMoving = $b943896dbfd2206b$var$deltaAbs(target.get(), location.get()) >= 2;
        var clearPreventClick = isMouse || !isMoving;
        pointerIsDown = true;
        dragTracker.pointerDown(evt);
        dragStartPoint.set(target);
        target.set(location);
        scrollBody.useBaseMass().useSpeed(80);
        addInteractionEvents();
        startScroll = dragTracker.readPoint(evt);
        startCross = dragTracker.readPoint(evt, crossAxis);
        eventHandler.emit("pointerDown");
        if (clearPreventClick) preventClick = false;
    }
    function move(evt) {
        if (!preventScroll && !isMouse) {
            if (!evt.cancelable) return up(evt);
            var lastScroll = dragTracker.readPoint(evt);
            var lastCross = dragTracker.readPoint(evt, crossAxis);
            var diffScroll = $b943896dbfd2206b$var$deltaAbs(lastScroll, startScroll);
            var diffCross = $b943896dbfd2206b$var$deltaAbs(lastCross, startCross);
            preventScroll = diffScroll > diffCross;
            if (!preventScroll && !preventClick) return up(evt);
        }
        var diff = dragTracker.pointerMove(evt);
        if (!preventClick && diff) preventClick = true;
        animation.start();
        target.add(direction.apply(diff));
        evt.preventDefault();
    }
    function up(evt) {
        var currentLocation = scrollTarget.byDistance(0, false);
        var targetChanged = currentLocation.index !== index.get();
        var rawForce = dragTracker.pointerUp(evt) * forceBoost();
        var force = allowedForce(direction.apply(rawForce), targetChanged);
        var forceFactor = $b943896dbfd2206b$var$factorAbs(rawForce, force);
        var isMoving = $b943896dbfd2206b$var$deltaAbs(target.get(), dragStartPoint.get()) >= 0.5;
        var isVigorous = targetChanged && forceFactor > 0.75;
        var isBelowThreshold = $b943896dbfd2206b$var$mathAbs(rawForce) < dragThreshold;
        var speed = isVigorous ? 10 : baseSpeed;
        var mass = isVigorous ? baseMass + 2.5 * forceFactor : baseMass;
        if (isMoving && !isMouse) preventClick = true;
        preventScroll = false;
        pointerIsDown = false;
        interactionEvents.removeAll();
        scrollBody.useSpeed(isBelowThreshold ? 9 : speed).useMass(mass);
        scrollTo.distance(force, !dragFree);
        isMouse = false;
        eventHandler.emit("pointerUp");
    }
    function click(evt) {
        if (preventClick) {
            evt.stopPropagation();
            evt.preventDefault();
        }
    }
    // DEPRECATED - Remove in v8 because handled automatically
    function clickAllowed() {
        return !preventClick;
    }
    function pointerDown() {
        return pointerIsDown;
    }
    var self = {
        addActivationEvents: addActivationEvents,
        clickAllowed: clickAllowed,
        pointerDown: pointerDown,
        removeAllEvents: removeAllEvents
    };
    return self;
}
function $b943896dbfd2206b$var$DragTracker(axis) {
    var logInterval = 170;
    var startEvent;
    var lastEvent;
    function isTouchEvent(evt) {
        return typeof TouchEvent !== "undefined" && evt instanceof TouchEvent;
    }
    function readTime(evt) {
        return evt.timeStamp;
    }
    function readPoint(evt, evtAxis) {
        var property = evtAxis || axis.scroll;
        var coord = "client".concat(property === "x" ? "X" : "Y");
        return (isTouchEvent(evt) ? evt.touches[0] : evt)[coord];
    }
    function pointerDown(evt) {
        startEvent = evt;
        lastEvent = evt;
        return readPoint(evt);
    }
    function pointerMove(evt) {
        var diff = readPoint(evt) - readPoint(lastEvent);
        var expired = readTime(evt) - readTime(startEvent) > logInterval;
        lastEvent = evt;
        if (expired) startEvent = evt;
        return diff;
    }
    function pointerUp(evt) {
        if (!startEvent || !lastEvent) return 0;
        var diffDrag = readPoint(lastEvent) - readPoint(startEvent);
        var diffTime = readTime(evt) - readTime(startEvent);
        var expired = readTime(evt) - readTime(lastEvent) > logInterval;
        var force = diffDrag / diffTime;
        var isFlick = diffTime && !expired && $b943896dbfd2206b$var$mathAbs(force) > 0.1;
        return isFlick ? force : 0;
    }
    var self = {
        isTouchEvent: isTouchEvent,
        pointerDown: pointerDown,
        pointerMove: pointerMove,
        pointerUp: pointerUp,
        readPoint: readPoint
    };
    return self;
}
function $b943896dbfd2206b$var$PercentOfView(viewSize) {
    function measure(n) {
        return viewSize * (n / 100);
    }
    var self = {
        measure: measure
    };
    return self;
}
function $b943896dbfd2206b$var$ScrollBody(location, baseSpeed, baseMass) {
    var roundToTwoDecimals = $b943896dbfd2206b$var$roundToDecimals(2);
    var velocity = $b943896dbfd2206b$var$Vector1D(0);
    var acceleration = $b943896dbfd2206b$var$Vector1D(0);
    var attraction = $b943896dbfd2206b$var$Vector1D(0);
    var attractionDirection = 0;
    var speed = baseSpeed;
    var mass = baseMass;
    function update() {
        velocity.add(acceleration);
        location.add(velocity);
        acceleration.multiply(0);
    }
    function applyForce(force) {
        force.divide(mass);
        acceleration.add(force);
    }
    function seek(target) {
        attraction.set(target).subtract(location);
        var magnitude = $b943896dbfd2206b$var$map(attraction.get(), 0, 100, 0, speed);
        attractionDirection = $b943896dbfd2206b$var$mathSign(attraction.get());
        attraction.normalize().multiply(magnitude).subtract(velocity);
        applyForce(attraction);
        return self;
    }
    function settle(target) {
        var diff = target.get() - location.get();
        var hasSettled = !roundToTwoDecimals(diff);
        if (hasSettled) location.set(target);
        return hasSettled;
    }
    function direction() {
        return attractionDirection;
    }
    function useBaseSpeed() {
        return useSpeed(baseSpeed);
    }
    function useBaseMass() {
        return useMass(baseMass);
    }
    function useSpeed(n) {
        speed = n;
        return self;
    }
    function useMass(n) {
        mass = n;
        return self;
    }
    var self = {
        direction: direction,
        seek: seek,
        settle: settle,
        update: update,
        useBaseMass: useBaseMass,
        useBaseSpeed: useBaseSpeed,
        useMass: useMass,
        useSpeed: useSpeed
    };
    return self;
}
function $b943896dbfd2206b$var$ScrollBounds(limit, location, target, scrollBody, percentOfView) {
    var pullBackThreshold = percentOfView.measure(10);
    var edgeOffsetTolerance = percentOfView.measure(50);
    var maxFriction = 0.85;
    var disabled = false;
    function shouldConstrain() {
        if (disabled) return false;
        if (!limit.reachedAny(target.get())) return false;
        if (!limit.reachedAny(location.get())) return false;
        return true;
    }
    function constrain(pointerDown) {
        if (!shouldConstrain()) return;
        var edge = limit.reachedMin(location.get()) ? "min" : "max";
        var diffToEdge = $b943896dbfd2206b$var$mathAbs(limit[edge] - location.get());
        var diffToTarget = target.get() - location.get();
        var friction = Math.min(diffToEdge / edgeOffsetTolerance, maxFriction);
        target.subtract(diffToTarget * friction);
        if (!pointerDown && $b943896dbfd2206b$var$mathAbs(diffToTarget) < pullBackThreshold) {
            target.set(limit.constrain(target.get()));
            scrollBody.useSpeed(10).useMass(3);
        }
    }
    function toggleActive(active) {
        disabled = !active;
    }
    var self = {
        constrain: constrain,
        toggleActive: toggleActive
    };
    return self;
}
function $b943896dbfd2206b$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll) {
    var scrollBounds = $b943896dbfd2206b$var$Limit(-contentSize + viewSize, snapsAligned[0]);
    var snapsBounded = snapsAligned.map(scrollBounds.constrain);
    var snapsContained = measureContained();
    function findDuplicates() {
        var startSnap = snapsBounded[0];
        var endSnap = $b943896dbfd2206b$var$arrayLast(snapsBounded);
        var min = snapsBounded.lastIndexOf(startSnap);
        var max = snapsBounded.indexOf(endSnap) + 1;
        return $b943896dbfd2206b$var$Limit(min, max);
    }
    function measureContained() {
        if (contentSize <= viewSize) return [
            scrollBounds.max
        ];
        if (containScroll === "keepSnaps") return snapsBounded;
        var _a = findDuplicates(), min = _a.min, max = _a.max;
        return snapsBounded.slice(min, max);
    }
    var self = {
        snapsContained: snapsContained
    };
    return self;
}
function $b943896dbfd2206b$var$ScrollLimit(contentSize, scrollSnaps, loop) {
    var limit = measureLimit();
    function measureLimit() {
        var startSnap = scrollSnaps[0];
        var endSnap = $b943896dbfd2206b$var$arrayLast(scrollSnaps);
        var min = loop ? startSnap - contentSize : endSnap;
        var max = startSnap;
        return $b943896dbfd2206b$var$Limit(min, max);
    }
    var self = {
        limit: limit
    };
    return self;
}
function $b943896dbfd2206b$var$ScrollLooper(contentSize, limit, location, vectors) {
    var jointSafety = 0.1;
    var min = limit.min + jointSafety;
    var max = limit.max + jointSafety;
    var _a = $b943896dbfd2206b$var$Limit(min, max), reachedMin = _a.reachedMin, reachedMax = _a.reachedMax;
    function shouldLoop(direction) {
        if (direction === 1) return reachedMax(location.get());
        if (direction === -1) return reachedMin(location.get());
        return false;
    }
    function loop(direction) {
        if (!shouldLoop(direction)) return;
        var loopDistance = contentSize * (direction * -1);
        vectors.forEach(function(v) {
            return v.add(loopDistance);
        });
    }
    var self = {
        loop: loop
    };
    return self;
}
function $b943896dbfd2206b$var$ScrollProgress(limit) {
    var max = limit.max, scrollLength = limit.length;
    function get(n) {
        var currentLocation = n - max;
        return currentLocation / -scrollLength;
    }
    var self = {
        get: get
    };
    return self;
}
function $b943896dbfd2206b$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slideSizesWithGaps, slidesToScroll, containScroll) {
    var startEdge = axis.startEdge, endEdge = axis.endEdge;
    var groupSlides = slidesToScroll.groupSlides;
    var alignments = measureSizes().map(alignment.measure);
    var snaps = measureUnaligned();
    var snapsAligned = measureAligned();
    function measureSizes() {
        return groupSlides(slideRects).map(function(rects) {
            return $b943896dbfd2206b$var$arrayLast(rects)[endEdge] - rects[0][startEdge];
        }).map($b943896dbfd2206b$var$mathAbs);
    }
    function measureUnaligned() {
        return slideRects.map(function(rect) {
            return containerRect[startEdge] - rect[startEdge];
        }).map(function(snap) {
            return -$b943896dbfd2206b$var$mathAbs(snap);
        });
    }
    function measureAligned() {
        var containedStartSnap = 0;
        var containedEndSnap = $b943896dbfd2206b$var$arrayLast(snaps) - $b943896dbfd2206b$var$arrayLast(slideSizesWithGaps);
        return groupSlides(snaps).map(function(g) {
            return g[0];
        }).map(function(snap, index, groupedSnaps) {
            var isFirst = !index;
            var isLast = index === $b943896dbfd2206b$var$arrayLastIndex(groupedSnaps);
            if (containScroll && isFirst) return containedStartSnap;
            if (containScroll && isLast) return containedEndSnap;
            return snap + alignments[index];
        });
    }
    var self = {
        snaps: snaps,
        snapsAligned: snapsAligned
    };
    return self;
}
function $b943896dbfd2206b$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
    var reachedAny = limit.reachedAny, removeOffset = limit.removeOffset, constrain = limit.constrain;
    function minDistance(distances) {
        return distances.concat().sort(function(a, b) {
            return $b943896dbfd2206b$var$mathAbs(a) - $b943896dbfd2206b$var$mathAbs(b);
        })[0];
    }
    function findTargetSnap(target) {
        var distance = loop ? removeOffset(target) : constrain(target);
        var ascDiffsToSnaps = scrollSnaps.map(function(scrollSnap) {
            return scrollSnap - distance;
        }).map(function(diffToSnap) {
            return shortcut(diffToSnap, 0);
        }).map(function(diff, i) {
            return {
                diff: diff,
                index: i
            };
        }).sort(function(d1, d2) {
            return $b943896dbfd2206b$var$mathAbs(d1.diff) - $b943896dbfd2206b$var$mathAbs(d2.diff);
        });
        var index = ascDiffsToSnaps[0].index;
        return {
            index: index,
            distance: distance
        };
    }
    function shortcut(target, direction) {
        var targets = [
            target,
            target + contentSize,
            target - contentSize
        ];
        if (!loop) return targets[0];
        if (!direction) return minDistance(targets);
        var matchingTargets = targets.filter(function(t) {
            return $b943896dbfd2206b$var$mathSign(t) === direction;
        });
        return minDistance(matchingTargets);
    }
    function byIndex(index, direction) {
        var diffToSnap = scrollSnaps[index] - targetVector.get();
        var distance = shortcut(diffToSnap, direction);
        return {
            index: index,
            distance: distance
        };
    }
    function byDistance(distance, snap) {
        var target = targetVector.get() + distance;
        var _a = findTargetSnap(target), index = _a.index, targetSnapDistance = _a.distance;
        var reachedBound = !loop && reachedAny(target);
        if (!snap || reachedBound) return {
            index: index,
            distance: distance
        };
        var diffToSnap = scrollSnaps[index] - targetSnapDistance;
        var snapDistance = distance + shortcut(diffToSnap, 0);
        return {
            index: index,
            distance: snapDistance
        };
    }
    var self = {
        byDistance: byDistance,
        byIndex: byIndex,
        shortcut: shortcut
    };
    return self;
}
function $b943896dbfd2206b$var$ScrollTo(animation, indexCurrent, indexPrevious, scrollTarget, targetVector, eventHandler) {
    function scrollTo(target) {
        var distanceDiff = target.distance;
        var indexDiff = target.index !== indexCurrent.get();
        if (distanceDiff) {
            animation.start();
            targetVector.add(distanceDiff);
        }
        if (indexDiff) {
            indexPrevious.set(indexCurrent.get());
            indexCurrent.set(target.index);
            eventHandler.emit("select");
        }
    }
    function distance(n, snap) {
        var target = scrollTarget.byDistance(n, snap);
        scrollTo(target);
    }
    function index(n, direction) {
        var targetIndex = indexCurrent.clone().set(n);
        var target = scrollTarget.byIndex(targetIndex.get(), direction);
        scrollTo(target);
    }
    var self = {
        distance: distance,
        index: index
    };
    return self;
}
function $b943896dbfd2206b$var$Translate(axis, direction, container) {
    var translate = axis.scroll === "x" ? x : y;
    var containerStyle = container.style;
    var disabled = false;
    function x(n) {
        return "translate3d(".concat(n, "px,0px,0px)");
    }
    function y(n) {
        return "translate3d(0px,".concat(n, "px,0px)");
    }
    function to(target) {
        if (disabled) return;
        containerStyle.transform = translate(direction.apply(target.get()));
    }
    function toggleActive(active) {
        disabled = !active;
    }
    function clear() {
        if (disabled) return;
        containerStyle.transform = "";
        if (!container.getAttribute("style")) container.removeAttribute("style");
    }
    var self = {
        clear: clear,
        to: to,
        toggleActive: toggleActive
    };
    return self;
}
function $b943896dbfd2206b$var$SlideLooper(axis, direction, viewSize, contentSize, slideSizesWithGaps, scrollSnaps, slidesInView, scroll, slides) {
    var ascItems = $b943896dbfd2206b$var$arrayKeys(slideSizesWithGaps);
    var descItems = $b943896dbfd2206b$var$arrayKeys(slideSizesWithGaps).reverse();
    var loopPoints = startPoints().concat(endPoints());
    function removeSlideSizes(indexes, from) {
        return indexes.reduce(function(a, i) {
            return a - slideSizesWithGaps[i];
        }, from);
    }
    function slidesInGap(indexes, gap) {
        return indexes.reduce(function(a, i) {
            var remainingGap = removeSlideSizes(a, gap);
            return remainingGap > 0 ? a.concat([
                i
            ]) : a;
        }, []);
    }
    function findLoopPoints(indexes, edge) {
        var isStartEdge = edge === "start";
        var offset = isStartEdge ? -contentSize : contentSize;
        var slideBounds = slidesInView.findSlideBounds([
            offset
        ]);
        return indexes.map(function(index) {
            var initial = isStartEdge ? 0 : -contentSize;
            var altered = isStartEdge ? contentSize : 0;
            var bounds = slideBounds.filter(function(b) {
                return b.index === index;
            })[0];
            var point = bounds[isStartEdge ? "end" : "start"];
            var shift = $b943896dbfd2206b$var$Vector1D(-1);
            var location = $b943896dbfd2206b$var$Vector1D(-1);
            var translate = $b943896dbfd2206b$var$Translate(axis, direction, slides[index]);
            var target = function() {
                return shift.set(scroll.get() > point ? initial : altered);
            };
            return {
                index: index,
                location: location,
                translate: translate,
                target: target
            };
        });
    }
    function startPoints() {
        var gap = scrollSnaps[0] - 1;
        var indexes = slidesInGap(descItems, gap);
        return findLoopPoints(indexes, "end");
    }
    function endPoints() {
        var gap = viewSize - scrollSnaps[0] - 1;
        var indexes = slidesInGap(ascItems, gap);
        return findLoopPoints(indexes, "start");
    }
    function canLoop() {
        return loopPoints.every(function(_a) {
            var index = _a.index;
            var otherIndexes = ascItems.filter(function(i) {
                return i !== index;
            });
            return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
        });
    }
    function loop() {
        loopPoints.forEach(function(loopPoint) {
            var target = loopPoint.target, translate = loopPoint.translate, location = loopPoint.location;
            var shift = target();
            if (shift.get() === location.get()) return;
            if (shift.get() === 0) translate.clear();
            else translate.to(shift);
            location.set(shift);
        });
    }
    function clear() {
        loopPoints.forEach(function(loopPoint) {
            return loopPoint.translate.clear();
        });
    }
    var self = {
        canLoop: canLoop,
        clear: clear,
        loop: loop,
        loopPoints: loopPoints
    };
    return self;
}
function $b943896dbfd2206b$var$SlidesInView(viewSize, contentSize, slideSizes, snaps, limit, loop, inViewThreshold) {
    var removeOffset = limit.removeOffset, constrain = limit.constrain;
    var roundingSafety = 0.5;
    var cachedOffsets = loop ? [
        0,
        contentSize,
        -contentSize
    ] : [
        0
    ];
    var cachedBounds = findSlideBounds(cachedOffsets, inViewThreshold);
    function findSlideThresholds(threshold) {
        var slideThreshold = threshold || 0;
        return slideSizes.map(function(slideSize) {
            var thresholdLimit = $b943896dbfd2206b$var$Limit(roundingSafety, slideSize - roundingSafety);
            return thresholdLimit.constrain(slideSize * slideThreshold);
        });
    }
    function findSlideBounds(offsets, threshold) {
        var slideOffsets = offsets || cachedOffsets;
        var slideThresholds = findSlideThresholds(threshold);
        return slideOffsets.reduce(function(list, offset) {
            var bounds = snaps.map(function(snap, index) {
                return {
                    start: snap - slideSizes[index] + slideThresholds[index] + offset,
                    end: snap + viewSize - slideThresholds[index] + offset,
                    index: index
                };
            });
            return list.concat(bounds);
        }, []);
    }
    function check(location, bounds) {
        var limitedLocation = loop ? removeOffset(location) : constrain(location);
        var slideBounds = bounds || cachedBounds;
        return slideBounds.reduce(function(list, slideBound) {
            var index = slideBound.index, start = slideBound.start, end = slideBound.end;
            var inList = list.indexOf(index) !== -1;
            var inView = start < limitedLocation && end > limitedLocation;
            return !inList && inView ? list.concat([
                index
            ]) : list;
        }, []);
    }
    var self = {
        check: check,
        findSlideBounds: findSlideBounds
    };
    return self;
}
function $b943896dbfd2206b$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap) {
    var measureSize = axis.measureSize, startEdge = axis.startEdge, endEdge = axis.endEdge;
    var withEdgeGap = slideRects[0] && readEdgeGap;
    var startGap = measureStartGap();
    var endGap = measureEndGap();
    var slideSizes = slideRects.map(measureSize);
    var slideSizesWithGaps = measureWithGaps();
    function measureStartGap() {
        if (!withEdgeGap) return 0;
        var slideRect = slideRects[0];
        return $b943896dbfd2206b$var$mathAbs(containerRect[startEdge] - slideRect[startEdge]);
    }
    function measureEndGap() {
        if (!withEdgeGap) return 0;
        var style = window.getComputedStyle($b943896dbfd2206b$var$arrayLast(slides));
        return parseFloat(style.getPropertyValue("margin-".concat(endEdge)));
    }
    function measureWithGaps() {
        return slideRects.map(function(rect, index, rects) {
            var isFirst = !index;
            var isLast = index === $b943896dbfd2206b$var$arrayLastIndex(rects);
            if (isFirst) return slideSizes[index] + startGap;
            if (isLast) return slideSizes[index] + endGap;
            return rects[index + 1][startEdge] - rect[startEdge];
        }).map($b943896dbfd2206b$var$mathAbs);
    }
    var self = {
        slideSizes: slideSizes,
        slideSizesWithGaps: slideSizesWithGaps
    };
    return self;
}
function $b943896dbfd2206b$var$SlidesToScroll(viewSize, slideSizesWithGaps, slidesToScroll) {
    var groupByNumber = $b943896dbfd2206b$var$isNumber(slidesToScroll);
    function byNumber(array, groupSize) {
        return $b943896dbfd2206b$var$arrayKeys(array).filter(function(i) {
            return i % groupSize === 0;
        }).map(function(i) {
            return array.slice(i, i + groupSize);
        });
    }
    function bySize(array) {
        return $b943896dbfd2206b$var$arrayKeys(array).reduce(function(groupSizes, i) {
            var chunk = slideSizesWithGaps.slice($b943896dbfd2206b$var$arrayLast(groupSizes), i + 1);
            var chunkSize = chunk.reduce(function(a, s) {
                return a + s;
            }, 0);
            return !i || chunkSize > viewSize ? groupSizes.concat(i) : groupSizes;
        }, []).map(function(start, i, groupSizes) {
            return array.slice(start, groupSizes[i + 1]);
        });
    }
    function groupSlides(array) {
        return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
    }
    var self = {
        groupSlides: groupSlides
    };
    return self;
}
function $b943896dbfd2206b$var$Engine(root, container, slides, options, eventHandler) {
    // Options
    var align = options.align, scrollAxis = options.axis, contentDirection = options.direction, startIndex = options.startIndex, inViewThreshold = options.inViewThreshold, loop = options.loop, speed = options.speed, dragFree = options.dragFree, groupSlides = options.slidesToScroll, skipSnaps = options.skipSnaps, containScroll = options.containScroll;
    // Measurements
    var containerRect = container.getBoundingClientRect();
    var slideRects = slides.map(function(slide) {
        return slide.getBoundingClientRect();
    });
    var direction = $b943896dbfd2206b$var$Direction(contentDirection);
    var axis = $b943896dbfd2206b$var$Axis(scrollAxis, contentDirection);
    var viewSize = axis.measureSize(containerRect);
    var percentOfView = $b943896dbfd2206b$var$PercentOfView(viewSize);
    var alignment = $b943896dbfd2206b$var$Alignment(align, viewSize);
    var containSnaps = !loop && containScroll !== "";
    var readEdgeGap = loop || containScroll !== "";
    var _a = $b943896dbfd2206b$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap), slideSizes = _a.slideSizes, slideSizesWithGaps = _a.slideSizesWithGaps;
    var slidesToScroll = $b943896dbfd2206b$var$SlidesToScroll(viewSize, slideSizesWithGaps, groupSlides);
    var _b = $b943896dbfd2206b$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slideSizesWithGaps, slidesToScroll, containSnaps), snaps = _b.snaps, snapsAligned = _b.snapsAligned;
    var contentSize = -$b943896dbfd2206b$var$arrayLast(snaps) + $b943896dbfd2206b$var$arrayLast(slideSizesWithGaps);
    var snapsContained = $b943896dbfd2206b$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll).snapsContained;
    var scrollSnaps = containSnaps ? snapsContained : snapsAligned;
    var limit = $b943896dbfd2206b$var$ScrollLimit(contentSize, scrollSnaps, loop).limit;
    // Indexes
    var index = $b943896dbfd2206b$var$Counter($b943896dbfd2206b$var$arrayLastIndex(scrollSnaps), startIndex, loop);
    var indexPrevious = index.clone();
    var slideIndexes = $b943896dbfd2206b$var$arrayKeys(slides);
    // Draw
    var update = function() {
        if (!loop) engine.scrollBounds.constrain(engine.dragHandler.pointerDown());
        engine.scrollBody.seek(target).update();
        var settled = engine.scrollBody.settle(target);
        if (settled && !engine.dragHandler.pointerDown()) {
            engine.animation.stop();
            eventHandler.emit("settle");
        }
        if (!settled) eventHandler.emit("scroll");
        if (loop) {
            engine.scrollLooper.loop(engine.scrollBody.direction());
            engine.slideLooper.loop();
        }
        engine.translate.to(location);
        engine.animation.proceed();
    };
    // Shared
    var animation = $b943896dbfd2206b$var$Animation(update);
    var startLocation = scrollSnaps[index.get()];
    var location = $b943896dbfd2206b$var$Vector1D(startLocation);
    var target = $b943896dbfd2206b$var$Vector1D(startLocation);
    var scrollBody = $b943896dbfd2206b$var$ScrollBody(location, speed, 1);
    var scrollTarget = $b943896dbfd2206b$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
    var scrollTo = $b943896dbfd2206b$var$ScrollTo(animation, index, indexPrevious, scrollTarget, target, eventHandler);
    var slidesInView = $b943896dbfd2206b$var$SlidesInView(viewSize, contentSize, slideSizes, snaps, limit, loop, inViewThreshold);
    // DragHandler
    var dragHandler = $b943896dbfd2206b$var$DragHandler(axis, direction, root, target, $b943896dbfd2206b$var$DragTracker(axis), location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, loop, dragFree, skipSnaps);
    // Engine
    var engine = {
        containerRect: containerRect,
        slideRects: slideRects,
        animation: animation,
        axis: axis,
        direction: direction,
        dragHandler: dragHandler,
        eventStore: $b943896dbfd2206b$var$EventStore(),
        percentOfView: percentOfView,
        index: index,
        indexPrevious: indexPrevious,
        limit: limit,
        location: location,
        options: options,
        scrollBody: scrollBody,
        scrollBounds: $b943896dbfd2206b$var$ScrollBounds(limit, location, target, scrollBody, percentOfView),
        scrollLooper: $b943896dbfd2206b$var$ScrollLooper(contentSize, limit, location, [
            location,
            target
        ]),
        scrollProgress: $b943896dbfd2206b$var$ScrollProgress(limit),
        scrollSnaps: scrollSnaps,
        scrollTarget: scrollTarget,
        scrollTo: scrollTo,
        slideLooper: $b943896dbfd2206b$var$SlideLooper(axis, direction, viewSize, contentSize, slideSizesWithGaps, scrollSnaps, slidesInView, location, slides),
        slidesToScroll: slidesToScroll,
        slidesInView: slidesInView,
        slideIndexes: slideIndexes,
        target: target,
        translate: $b943896dbfd2206b$var$Translate(axis, direction, container)
    };
    return engine;
}
function $b943896dbfd2206b$var$EventHandler() {
    var listeners = {};
    function getListeners(evt) {
        return listeners[evt] || [];
    }
    function emit(evt) {
        getListeners(evt).forEach(function(e) {
            return e(evt);
        });
        return self;
    }
    function on(evt, cb) {
        listeners[evt] = getListeners(evt).concat([
            cb
        ]);
        return self;
    }
    function off(evt, cb) {
        listeners[evt] = getListeners(evt).filter(function(e) {
            return e !== cb;
        });
        return self;
    }
    var self = {
        emit: emit,
        off: off,
        on: on
    };
    return self;
}
var $b943896dbfd2206b$var$defaultOptions = {
    align: "center",
    axis: "x",
    container: null,
    slides: null,
    containScroll: "",
    direction: "ltr",
    slidesToScroll: 1,
    breakpoints: {},
    dragFree: false,
    draggable: true,
    inViewThreshold: 0,
    loop: false,
    skipSnaps: false,
    speed: 10,
    startIndex: 0,
    active: true
};
function $b943896dbfd2206b$var$OptionsHandler() {
    function merge(optionsA, optionsB) {
        return $b943896dbfd2206b$var$objectsMergeDeep(optionsA, optionsB || {});
    }
    function areEqual(optionsA, optionsB) {
        var breakpointsA = JSON.stringify($b943896dbfd2206b$var$objectKeys(optionsA.breakpoints || {}));
        var breakpointsB = JSON.stringify($b943896dbfd2206b$var$objectKeys(optionsB.breakpoints || {}));
        if (breakpointsA !== breakpointsB) return false;
        return $b943896dbfd2206b$var$objectsAreEqual(optionsA, optionsB);
    }
    function atMedia(options) {
        var optionsAtMedia = options.breakpoints || {};
        var matchedMediaOptions = $b943896dbfd2206b$var$objectKeys(optionsAtMedia).filter(function(media) {
            return window.matchMedia(media).matches;
        }).map(function(media) {
            return optionsAtMedia[media];
        }).reduce(function(a, mediaOption) {
            return merge(a, mediaOption);
        }, {});
        return merge(options, matchedMediaOptions);
    }
    var self = {
        merge: merge,
        areEqual: areEqual,
        atMedia: atMedia
    };
    return self;
}
function $b943896dbfd2206b$var$PluginsHandler() {
    var _a = $b943896dbfd2206b$var$OptionsHandler(), atMedia = _a.atMedia, areEqual = _a.areEqual;
    var activePlugins = [];
    var pluginsChanged = [];
    function haveChanged() {
        return pluginsChanged.some(function(hasChanged) {
            return hasChanged();
        });
    }
    function hasChanged(plugin) {
        var options = atMedia(plugin.options);
        return function() {
            return !areEqual(options, atMedia(plugin.options));
        };
    }
    function init(plugins, embla) {
        pluginsChanged = plugins.map(hasChanged);
        activePlugins = plugins.filter(function(plugin) {
            return atMedia(plugin.options).active;
        });
        activePlugins.forEach(function(plugin) {
            return plugin.init(embla);
        });
        return plugins.reduce(function(map, plugin) {
            var _a;
            return Object.assign(map, (_a = {}, _a[plugin.name] = plugin, _a));
        }, {});
    }
    function destroy() {
        activePlugins = activePlugins.filter(function(plugin) {
            return plugin.destroy();
        });
    }
    var self = {
        init: init,
        destroy: destroy,
        haveChanged: haveChanged
    };
    return self;
}
function $b943896dbfd2206b$export$2e2bcd8739ae039(root, userOptions, userPlugins) {
    var resizeHandlers = $b943896dbfd2206b$var$EventStore();
    var optionsHandler = $b943896dbfd2206b$var$OptionsHandler();
    var pluginsHandler = $b943896dbfd2206b$var$PluginsHandler();
    var eventHandler = $b943896dbfd2206b$var$EventHandler();
    var on = eventHandler.on, off = eventHandler.off;
    var reInit = reActivate;
    var destroyed = false;
    var engine;
    var optionsBase = optionsHandler.merge($b943896dbfd2206b$var$defaultOptions, $b943896dbfd2206b$export$2e2bcd8739ae039.globalOptions);
    var options = optionsHandler.merge(optionsBase);
    var pluginList = [];
    var pluginApis;
    var rootSize = 0;
    var container;
    var slides;
    function storeElements() {
        var userContainer = options.container, userSlides = options.slides;
        var customContainer = $b943896dbfd2206b$var$isString(userContainer) ? root.querySelector(userContainer) : userContainer;
        container = customContainer || root.children[0];
        var customSlides = $b943896dbfd2206b$var$isString(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
        slides = [].slice.call(customSlides || container.children);
    }
    function activate(withOptions, withPlugins) {
        if (destroyed) return;
        optionsBase = optionsHandler.merge(optionsBase, withOptions);
        options = optionsHandler.atMedia(optionsBase);
        storeElements();
        engine = $b943896dbfd2206b$var$Engine(root, container, slides, options, eventHandler);
        rootSize = engine.axis.measureSize(root.getBoundingClientRect());
        if (!options.active) return deActivate();
        engine.translate.to(engine.location);
        pluginList = withPlugins || pluginList;
        pluginApis = pluginsHandler.init(pluginList, self);
        if (options.loop) {
            if (!engine.slideLooper.canLoop()) {
                deActivate();
                activate({
                    loop: false
                }, withPlugins);
                optionsBase = optionsHandler.merge(optionsBase, {
                    loop: true
                });
                return;
            }
            engine.slideLooper.loop();
        }
        if (options.draggable && container.offsetParent && slides.length) engine.dragHandler.addActivationEvents();
    }
    function reActivate(withOptions, withPlugins) {
        var startIndex = selectedScrollSnap();
        deActivate();
        activate(optionsHandler.merge({
            startIndex: startIndex
        }, withOptions), withPlugins);
        eventHandler.emit("reInit");
    }
    function deActivate() {
        engine.dragHandler.removeAllEvents();
        engine.animation.stop();
        engine.eventStore.removeAll();
        engine.translate.clear();
        engine.slideLooper.clear();
        pluginsHandler.destroy();
    }
    function destroy() {
        if (destroyed) return;
        destroyed = true;
        resizeHandlers.removeAll();
        deActivate();
        eventHandler.emit("destroy");
    }
    function resize() {
        var newOptions = optionsHandler.atMedia(optionsBase);
        var optionsChanged = !optionsHandler.areEqual(newOptions, options);
        var newRootSize = engine.axis.measureSize(root.getBoundingClientRect());
        var rootSizeChanged = rootSize !== newRootSize;
        var pluginsChanged = pluginsHandler.haveChanged();
        if (rootSizeChanged || optionsChanged || pluginsChanged) reActivate();
        eventHandler.emit("resize");
    }
    function slidesInView(target) {
        var location = engine[target ? "target" : "location"].get();
        var type = options.loop ? "removeOffset" : "constrain";
        return engine.slidesInView.check(engine.limit[type](location));
    }
    function slidesNotInView(target) {
        var inView = slidesInView(target);
        return engine.slideIndexes.filter(function(index) {
            return inView.indexOf(index) === -1;
        });
    }
    function scrollTo(index, jump, direction) {
        if (!options.active || destroyed) return;
        engine.scrollBody.useBaseMass().useSpeed(jump ? 100 : options.speed);
        engine.scrollTo.index(index, direction || 0);
    }
    function scrollNext(jump) {
        var next = engine.index.clone().add(1);
        scrollTo(next.get(), jump === true, -1);
    }
    function scrollPrev(jump) {
        var prev = engine.index.clone().add(-1);
        scrollTo(prev.get(), jump === true, 1);
    }
    function canScrollNext() {
        var next = engine.index.clone().add(1);
        return next.get() !== selectedScrollSnap();
    }
    function canScrollPrev() {
        var prev = engine.index.clone().add(-1);
        return prev.get() !== selectedScrollSnap();
    }
    function scrollSnapList() {
        return engine.scrollSnaps.map(engine.scrollProgress.get);
    }
    function scrollProgress() {
        return engine.scrollProgress.get(engine.location.get());
    }
    function selectedScrollSnap() {
        return engine.index.get();
    }
    function previousScrollSnap() {
        return engine.indexPrevious.get();
    }
    function clickAllowed() {
        return engine.dragHandler.clickAllowed();
    }
    function plugins() {
        return pluginApis;
    }
    function internalEngine() {
        return engine;
    }
    function rootNode() {
        return root;
    }
    function containerNode() {
        return container;
    }
    function slideNodes() {
        return slides;
    }
    var self = {
        canScrollNext: canScrollNext,
        canScrollPrev: canScrollPrev,
        clickAllowed: clickAllowed,
        containerNode: containerNode,
        internalEngine: internalEngine,
        destroy: destroy,
        off: off,
        on: on,
        plugins: plugins,
        previousScrollSnap: previousScrollSnap,
        reInit: reInit,
        rootNode: rootNode,
        scrollNext: scrollNext,
        scrollPrev: scrollPrev,
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnapList,
        scrollTo: scrollTo,
        selectedScrollSnap: selectedScrollSnap,
        slideNodes: slideNodes,
        slidesInView: slidesInView,
        slidesNotInView: slidesNotInView
    };
    activate(userOptions, userPlugins);
    resizeHandlers.add(window, "resize", resize);
    setTimeout(function() {
        return eventHandler.emit("init");
    }, 0);
    return self;
}
$b943896dbfd2206b$export$2e2bcd8739ae039.globalOptions = undefined;
$b943896dbfd2206b$export$2e2bcd8739ae039.optionsHandler = $b943896dbfd2206b$var$OptionsHandler;



var $8ffbf1b65d396f28$var$defaultOptions = {
    active: true,
    breakpoints: {},
    selected: "is-selected",
    draggable: "is-draggable",
    dragging: "is-dragging"
};
function $8ffbf1b65d396f28$var$removeClass(node, className) {
    var cl = node.classList;
    if (className && cl.contains(className)) cl.remove(className);
}
function $8ffbf1b65d396f28$var$addClass(node, className) {
    var cl = node.classList;
    if (className && !cl.contains(className)) cl.add(className);
}
function $8ffbf1b65d396f28$export$2e2bcd8739ae039(userOptions) {
    var optionsHandler = (0, $b943896dbfd2206b$export$2e2bcd8739ae039).optionsHandler();
    var optionsBase = optionsHandler.merge($8ffbf1b65d396f28$var$defaultOptions, $8ffbf1b65d396f28$export$2e2bcd8739ae039.globalOptions);
    var options;
    var carousel;
    var root;
    var slides;
    var selectedEvents = [
        "select",
        "pointerUp"
    ];
    var draggingEvents = [
        "pointerDown",
        "pointerUp"
    ];
    function init(embla) {
        carousel = embla;
        options = optionsHandler.atMedia(self.options);
        root = carousel.rootNode();
        slides = carousel.slideNodes();
        var isDraggable = carousel.internalEngine().options.draggable;
        if (isDraggable) $8ffbf1b65d396f28$var$addClass(root, options.draggable);
        if (options.dragging) draggingEvents.forEach(function(evt) {
            return carousel.on(evt, toggleDraggingClass);
        });
        if (options.selected) {
            selectedEvents.forEach(function(evt) {
                return carousel.on(evt, toggleSelectedClass);
            });
            toggleSelectedClass();
        }
    }
    function destroy() {
        $8ffbf1b65d396f28$var$removeClass(root, options.draggable);
        draggingEvents.forEach(function(evt) {
            return carousel.off(evt, toggleDraggingClass);
        });
        selectedEvents.forEach(function(evt) {
            return carousel.off(evt, toggleSelectedClass);
        });
        slides.forEach(function(slide) {
            return $8ffbf1b65d396f28$var$removeClass(slide, options.selected);
        });
    }
    function toggleDraggingClass(evt) {
        if (evt === "pointerDown") $8ffbf1b65d396f28$var$addClass(root, options.dragging);
        else $8ffbf1b65d396f28$var$removeClass(root, options.dragging);
    }
    function toggleSelectedClass() {
        var inView = carousel.slidesInView(true);
        var notInView = carousel.slidesNotInView(true);
        notInView.forEach(function(index) {
            return $8ffbf1b65d396f28$var$removeClass(slides[index], options.selected);
        });
        inView.forEach(function(index) {
            return $8ffbf1b65d396f28$var$addClass(slides[index], options.selected);
        });
    }
    var self = {
        name: "classNames",
        options: optionsHandler.merge(optionsBase, userOptions),
        init: init,
        destroy: destroy
    };
    return self;
}
$8ffbf1b65d396f28$export$2e2bcd8739ae039.globalOptions = undefined;



const $5edd84e97cd1200c$var$STATE = {
    idle: "idle",
    running: "running",
    paused: "paused",
    resumed: "resumed"
};
class $5edd84e97cd1200c$var$IntervalTimer {
    constructor(callback, interval){
        this.interval = interval;
        this.callback = callback;
        this.state = $5edd84e97cd1200c$var$STATE.idle;
        this.pausedTime = 0;
        this.remainingTime = 0;
    }
    proxyCallback() {
        this.lastFireTime = new Date();
        this.callback();
    }
    start() {
        this.timerId = setInterval(()=>this.proxyCallback(), this.interval);
        this.lastFireTime = new Date();
        this.state = $5edd84e97cd1200c$var$STATE.running;
    }
    pause() {
        if (this.state !== $5edd84e97cd1200c$var$STATE.running && this.state !== $5edd84e97cd1200c$var$STATE.resumed) return;
        this.remainingTime = this.interval - (new Date() - this.lastFireTime) + this.pausedTime;
        this.lastPauseTime = new Date();
        clearInterval(this.timerId);
        clearTimeout(this.resumeId);
        this.state = $5edd84e97cd1200c$var$STATE.paused;
    }
    resume() {
        if (this.state !== $5edd84e97cd1200c$var$STATE.paused) return;
        this.pausedTime += new Date() - this.lastPauseTime;
        this.state = $5edd84e97cd1200c$var$STATE.resumed;
        this.resumeId = setTimeout(()=>this.timeoutCallback(), this.remainingTime);
    }
    timeoutCallback() {
        if (this.state !== $5edd84e97cd1200c$var$STATE.resumed) return;
        this.pausedTime = 0;
        this.proxyCallback();
        this.start();
    }
    stop() {
        if (this.state === $5edd84e97cd1200c$var$STATE.idle) return;
        clearInterval(this.timerId);
        clearTimeout(this.resumeId);
        this.state = $5edd84e97cd1200c$var$STATE.idle;
    }
    setInterval(newInterval) {
        if (this.state === $5edd84e97cd1200c$var$STATE.running) {
            this.pause();
            this.interval = newInterval;
            this.resume();
        } else this.interval = newInterval;
    }
}
var $5edd84e97cd1200c$export$2e2bcd8739ae039 = $5edd84e97cd1200c$var$IntervalTimer;


const $e5f186cf4aa73346$var$carouselAutoPlay = (embla, interval)=>{
    const next = ()=>{
        const lastSlideIndex = embla.scrollSnapList().length - 1;
        const isLastSlide = embla.selectedScrollSnap() === lastSlideIndex;
        if (isLastSlide) embla.scrollTo(0);
        else embla.scrollNext();
    };
    const intervalTimer = new (0, $5edd84e97cd1200c$export$2e2bcd8739ae039)(next, interval);
    const play = ()=>{
        intervalTimer.resume();
    };
    const stop = ()=>{
        intervalTimer.stop();
    };
    const pause = ()=>{
        intervalTimer.pause();
    };
    const start = ()=>{
        intervalTimer.start();
    };
    return {
        play: play,
        stop: stop,
        start: start,
        pause: pause
    };
};
var $e5f186cf4aa73346$export$2e2bcd8739ae039 = $e5f186cf4aa73346$var$carouselAutoPlay;



var $e8126b7100a99238$exports = {};

$parcel$export($e8126b7100a99238$exports, "debounce", function () { return $e8126b7100a99238$export$61fc7d43ac8f84b0; }, function (v) { return $e8126b7100a99238$export$61fc7d43ac8f84b0 = v; });
const $e8126b7100a99238$export$61fc7d43ac8f84b0 = (fn, wait)=>{
    let t;
    return (...args)=>{
        clearTimeout(t);
        t = setTimeout(()=>fn.apply(undefined, args), wait);
    };
};


class $1fbcf34fe6e6f853$var$Carousel extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        const autoplayInterval = +(this.dataset.autoplayInterval || 0);
        this._isFocused = false;
        this.withAutoplay = autoplayInterval > 0;
        this.isPlay = autoplayInterval > 0;
        this.forceStopped = false;
        this._resizeObserver = new ResizeObserver(this._handleCarouselResize);
    }
    connectedCallback() {
        this.focusableTargets = [
            ...this.querySelectorAll((0, $eceaf86a082c33f7$export$f2d94ec8507fd10b)())
        ];
        this._setCarousel();
        document.fonts.ready.then(this._handleFontsReady);
        if (this.focusableTargets.length > 0) this.focusableTargets.forEach((target)=>{
            target.addEventListener("keydown", this._handleCarouselTargetKeyDown);
        });
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "mouseenter", this._handleCarouselEnter);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "mouseleave", this._handleCarouselLeave);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "focus", this._handleCarouselFocus);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "blur", this._handleCarouselBlur);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "blur", this._handleCarouselLeave);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(document, "keydown", this._handleKeydown);
        this.embla.on("select", this._handleCarouselSelect);
        this.embla.on("pointerUp", this._handleCarouselPointerUp);
        this.embla.on("pointerDown", this._handleCarouselPointerDown);
        if (this._isEditorMode) {
            this._resizeObserver.observe(this);
            this._editor.subscribe("BLOCK_SELECT", this._handleBlockSelect);
            this._editor.subscribe("SECTION_LOAD", this._handleSectionLoad);
        }
    }
    disconnectedCallback() {
        if (this.focusableTargets.length > 0) this.focusableTargets.forEach((target)=>{
            target.removeEventListener("keydown", this._handleCarouselTargetKeyDown);
        });
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "mouseenter", this._handleCarouselEnter);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "mouseleave", this._handleCarouselLeave);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "focus", this._handleCarouselFocus);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "blur", this._handleCarouselBlur);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(document, "keydown", this._handleKeydown);
        this.embla.off("select", this._handleCarouselSelect);
        this.embla.off("pointerUp", this._handleCarouselPointerUp);
        this.embla.off("pointerDown", this._handleCarouselPointerDown);
        if (this._isEditorMode) {
            this._resizeObserver.disconnect();
            this._editor.destroy();
        }
        this.embla.destroy();
    }
    attributeChangedCallback = (_, oldValue, newValue)=>{
        if (oldValue !== newValue) this.reInit();
    };
    _handleFontsReady = ()=>{
        this.reInit();
    };
    _handleCarouselTargetKeyDown = (e)=>{
        e.preventDefault();
        const targetIndex = this.focusableTargets.findIndex((target)=>target === e.target);
        const currentFocusTarget = this.focusableTargets[targetIndex];
        const nextFocusTarget = this.focusableTargets[targetIndex + 1];
        const prevFocusTarget = this.focusableTargets[targetIndex - 1];
        if (e.keyCode === 9) {
            e.preventDefault();
            if (document.activeElement === currentFocusTarget) this.focusScroll(currentFocusTarget);
            if (!e.shiftKey) {
                if (nextFocusTarget) this.focusScroll(nextFocusTarget);
                else document.activeElement.blur();
            }
            if (e.shiftKey) {
                if (prevFocusTarget) this.focusScroll(prevFocusTarget);
                else document.activeElement.blur();
            }
        }
    };
    _handleCarouselResize = (0, $e8126b7100a99238$exports.debounce)(()=>{
        const currentViewMode = (0, $5d3d77426481432d$export$e7a5aad9bb00dd62)() ? "mobile" : "desktop";
        const isAnotherViewMode = this.lastViewModeIsMobile !== currentViewMode;
        if (isAnotherViewMode && this.forceStopped) {
            this.forcePlay();
            this.changePlayState(true);
        }
        this.lastViewModeIsMobile = currentViewMode;
    }, 100);
    focusScroll = (targetElement)=>{
        const slideIndex = this.slides.findIndex((slide)=>slide.contains(targetElement));
        if (slideIndex !== -1) {
            this.embla.scrollTo(slideIndex, true);
            this.forceStop();
        }
        targetElement.focus();
    };
    _handleCarouselFocus = ()=>{
        this._isFocused = true;
    };
    _handleCarouselBlur = ()=>{
        this._isFocused = false;
    };
    _handleCarouselEnter = ()=>{
        const isMobile = (0, $5d3d77426481432d$export$e7a5aad9bb00dd62)();
        if (isMobile) return;
        this.changePlayState(false);
    };
    _handleCarouselSelect = ()=>{
        if (this.isTouchOnCarousel) this.forceStop();
    };
    _handleCarouselPointerUp = ()=>{
        this.isTouchOnCarousel = false;
    };
    _handleCarouselPointerDown = ()=>{
        this.isTouchOnCarousel = true;
    };
    _handleCarouselLeave = ()=>{
        const isMobile = (0, $5d3d77426481432d$export$e7a5aad9bb00dd62)();
        if (isMobile) return;
        this.changePlayState(true);
    };
    _handleKeydown = (e)=>{
        if (this._isFocused) {
            const key = e.key || e.keyCode;
            const isLeftArrow = (0, $eceaf86a082c33f7$export$703c582f38858004)(key);
            const isRightArrow = (0, $eceaf86a082c33f7$export$e2fe3643cb517b19)(key);
            if (isLeftArrow) this.embla.scrollPrev();
            if (isRightArrow) this.embla.scrollNext();
        }
    };
    _handleBlockSelect = ({ detail: { sectionId: sectionId , blockId: blockId , load: load  }  })=>{
        if (this.dataset.sectionId === sectionId) {
            const slides = this.embla.slideNodes();
            const targetIndex = slides.findIndex(({ attributes: attributes  })=>attributes["block-id"]?.value === blockId);
            if (targetIndex !== -1) {
                this.embla.scrollTo(targetIndex, load);
                this.forceStop();
            }
        }
    };
    _handleSectionLoad = ({ detail: { sectionId: sectionId  }  })=>{
        if (this.dataset.sectionId === sectionId) this.reInit();
    };
    _getOptions = ()=>({
            loop: this.dataset.loop === "infinite",
            dragFree: this.dataset.dragFree,
            draggable: this.hasAttribute("data-draggable") ? this.dataset.draggable === "true" : true,
            skipSnaps: this.dataset.skipSnaps || true,
            align: this.dataset.align || "start",
            inViewThreshold: +(this.dataset.inViewThreshhold || 0) || 0.75,
            containScroll: this.hasAttribute("data-contain-scroll") ? this.dataset.containScroll : "trimSnaps",
            axis: this.dataset.axis === "vertical" ? "y" : "x",
            speed: this._getSpeed()
        });
    _getPlugins = ()=>{
        return [
            this._getClassNamesPlugin()
        ];
    };
    _setCarousel() {
        const viewport = this.querySelector("[data-carousel-viewport]");
        if (!viewport) return;
        this.embla = (0, $b943896dbfd2206b$export$2e2bcd8739ae039)(viewport, this._getOptions(), this._getPlugins());
        if (this.withAutoplay) {
            this.autoplay = (0, $e5f186cf4aa73346$export$2e2bcd8739ae039)(this.embla, this.autoplayInterval * 1000);
            this.autoplay.start();
        }
    }
    _getClassNamesPlugin() {
        return (0, $8ffbf1b65d396f28$export$2e2bcd8739ae039)();
    }
    _getSpeed() {
        const isAnimationReduce = (0, $5d3d77426481432d$export$601dcf7c5dad8f97)();
        if (isAnimationReduce) return 100;
        return this.dataset.animation === "fade" ? 100 : 10;
    }
    setFocus = ()=>{
        this._isFocused = true;
    };
    removeFocus = ()=>{
        this._isFocused = false;
    };
    changePlayState = (isPlay)=>{
        if (!this.withAutoplay) return;
        if (this.forceStopped) return;
        this.isPlay = isPlay;
        isPlay ? this.autoplay.play() : this.autoplay.pause();
        this.emit("changePlayState", {});
    };
    forceStop() {
        if (!this.withAutoplay) return;
        this.autoplay.stop();
        this.isPlay = false;
        this.forceStopped = true;
        this.emit("forceChangePlayState", {});
    }
    forcePlay() {
        if (!this.withAutoplay) return;
        this.forceStopped = false;
        this.isPlay = true;
        this.autoplay.start();
        this.changePlayState(false);
        this.emit("forceChangePlayState", {});
    }
    reInit = (options = {})=>{
        const preparedOptions = {
            ...this._getOptions(),
            ...options
        };
        const preparedPlugins = this._getPlugins();
        this.embla.reInit(preparedOptions, preparedPlugins);
    };
    scrollNext = ()=>{
        this.embla.scrollNext();
    };
    scrollPrev = ()=>{
        this.embla.scrollPrev();
    };
    canScrollNext = ()=>{
        return this.embla.canScrollNext();
    };
    canScrollPrev = ()=>{
        return this.embla.canScrollPrev();
    };
    get autoplayInterval() {
        return +(this.dataset.autoplayInterval || 0);
    }
    get slides() {
        return [
            ...this.embla.slideNodes()
        ];
    }
}
var $1fbcf34fe6e6f853$export$2e2bcd8739ae039 = $1fbcf34fe6e6f853$var$Carousel;



class $4328a7aafc445600$var$CarouselPlayButton extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.button = this.querySelector("[data-carousel-play-button]");
    }
    connectedCallback() {
        this.updatePlayState();
        if (this.button) this.button.addEventListener("click", this._handleButtonClick);
        if (this._carousel) {
            customElements.upgrade(this._carousel) // https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/upgrade
            ;
            this._carousel.subscribe("forceChangePlayState", this._handleCarouselChangePlayState);
        }
    }
    disconnectedCallback() {
        if (this.button) this.button.removeEventListener("click", this._handleButtonClick);
        if (this._carousel) this._carousel.unsubscribe("forceChangePlayState", this._handleCarouselChangePlayState);
    }
    _handleCarouselChangePlayState = ()=>{
        this.updatePlayState();
    };
    _handleButtonClick = (event)=>{
        event.stopPropagation();
        if (!this._carousel) return;
        const forceStopped = this._carousel.forceStopped;
        if (forceStopped) this._carousel.forcePlay();
        else this._carousel.forceStop();
    };
    updatePlayState() {
        if (!this._carousel || !this.button) return;
        const forceStopped = this._carousel.forceStopped;
        this.button.setAttribute("data-autoplay-stopped", forceStopped ? "true" : "false");
    }
    get _carousel() {
        return this.closest("carousel-component");
    }
}
var $4328a7aafc445600$export$2e2bcd8739ae039 = $4328a7aafc445600$var$CarouselPlayButton;





function $b9e908af9b4538a9$var$_extends() {
    $b9e908af9b4538a9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b9e908af9b4538a9$var$_extends.apply(this, arguments);
}
var $b9e908af9b4538a9$var$DECAY = 0.996;
/**
 * movement projection based on velocity
 * @param velocityPxMs
 * @param decay
 */ var $b9e908af9b4538a9$export$b74061472fe7c07 = function projection(velocityPxMs, decay) {
    if (decay === void 0) decay = $b9e908af9b4538a9$var$DECAY;
    return velocityPxMs * decay / (1 - decay);
};
function $b9e908af9b4538a9$export$891a5c5c55cf41aa(array) {
    return array[array.length - 1];
}
function $b9e908af9b4538a9$export$cc6710ee5f037d57(numbers) {
    return numbers.reduce(function(a, b) {
        return a + b;
    }) / numbers.length;
}
var $b9e908af9b4538a9$export$7d15b64cf5a3a4c4 = function clamp(value, min, max) {
    return Math.min(Math.max(min, value), max);
};
function $b9e908af9b4538a9$export$75064e1c6824e15c(v1, v2) {
    if (v1.length !== v2.length) throw new Error("vectors must be same length");
    return v1.map(function(val, i) {
        return val + v2[i];
    });
}
function $b9e908af9b4538a9$export$bb8a7d60274b5fc6(numbers) {
    return Math.max.apply(Math, numbers.map(Math.abs));
} // eslint-disable-next-line @typescript-eslint/ban-types
function $b9e908af9b4538a9$export$7e32b29e1cb162e1(o) {
    Object.freeze(o);
    Object.values(o).forEach(function(value) {
        if (value !== null && typeof value === "object" && !Object.isFrozen(value)) $b9e908af9b4538a9$export$7e32b29e1cb162e1(value);
    });
    return o;
}
function $b9e908af9b4538a9$var$EventBus() {
    var listeners = {};
    function on(type, listener) {
        listeners[type] = (listeners[type] || []).concat(listener);
        return function() {
            return off(type, listener);
        };
    }
    function off(type, listener) {
        listeners[type] = (listeners[type] || []).filter(function(l) {
            return l !== listener;
        });
    }
    function dispatch(type, data) {
        if (!(type in listeners)) return;
        listeners[type].forEach(function(l) {
            return l(data);
        });
    }
    return $b9e908af9b4538a9$export$7e32b29e1cb162e1({
        on: on,
        off: off,
        dispatch: dispatch
    });
}
function $b9e908af9b4538a9$var$WheelTargetObserver(eventListener) {
    var targets = []; // add event listener to target element
    var observe = function observe(target) {
        target.addEventListener("wheel", eventListener, {
            passive: false
        });
        targets.push(target);
        return function() {
            return unobserve(target);
        };
    }; /// remove event listener from target element
    var unobserve = function unobserve(target) {
        target.removeEventListener("wheel", eventListener);
        targets = targets.filter(function(t) {
            return t !== target;
        });
    }; // stops watching all of its target elements for visibility changes.
    var disconnect = function disconnect() {
        targets.forEach(unobserve);
    };
    return $b9e908af9b4538a9$export$7e32b29e1cb162e1({
        observe: observe,
        unobserve: unobserve,
        disconnect: disconnect
    });
}
var $b9e908af9b4538a9$var$LINE_HEIGHT = 18;
var $b9e908af9b4538a9$var$PAGE_HEIGHT = typeof window !== "undefined" && window.innerHeight || 800;
var $b9e908af9b4538a9$var$DELTA_MODE_UNIT = [
    1,
    $b9e908af9b4538a9$var$LINE_HEIGHT,
    $b9e908af9b4538a9$var$PAGE_HEIGHT
];
function $b9e908af9b4538a9$var$normalizeWheel(e) {
    var deltaX = e.deltaX * $b9e908af9b4538a9$var$DELTA_MODE_UNIT[e.deltaMode];
    var deltaY = e.deltaY * $b9e908af9b4538a9$var$DELTA_MODE_UNIT[e.deltaMode];
    var deltaZ = (e.deltaZ || 0) * $b9e908af9b4538a9$var$DELTA_MODE_UNIT[e.deltaMode];
    return {
        timeStamp: e.timeStamp,
        axisDelta: [
            deltaX,
            deltaY,
            deltaZ
        ]
    };
}
var $b9e908af9b4538a9$var$reverseAll = [
    -1,
    -1,
    -1
];
function $b9e908af9b4538a9$var$reverseAxisDeltaSign(wheel, reverseSign) {
    if (!reverseSign) return wheel;
    var multipliers = reverseSign === true ? $b9e908af9b4538a9$var$reverseAll : reverseSign.map(function(shouldReverse) {
        return shouldReverse ? -1 : 1;
    });
    return $b9e908af9b4538a9$var$_extends({}, wheel, {
        axisDelta: wheel.axisDelta.map(function(delta, i) {
            return delta * multipliers[i];
        })
    });
}
var $b9e908af9b4538a9$var$DELTA_MAX_ABS = 700;
var $b9e908af9b4538a9$var$clampAxisDelta = function clampAxisDelta(wheel) {
    return $b9e908af9b4538a9$var$_extends({}, wheel, {
        axisDelta: wheel.axisDelta.map(function(delta) {
            return $b9e908af9b4538a9$export$7d15b64cf5a3a4c4(delta, -$b9e908af9b4538a9$var$DELTA_MAX_ABS, $b9e908af9b4538a9$var$DELTA_MAX_ABS);
        })
    });
};
var $b9e908af9b4538a9$var$__DEV__ = false;
var $b9e908af9b4538a9$var$ACC_FACTOR_MIN = 0.6;
var $b9e908af9b4538a9$var$ACC_FACTOR_MAX = 0.96;
var $b9e908af9b4538a9$var$WHEELEVENTS_TO_MERGE = 2;
var $b9e908af9b4538a9$var$WHEELEVENTS_TO_ANALAZE = 5;
var $b9e908af9b4538a9$export$3208dd15ca232a1a = /*#__PURE__*/ $b9e908af9b4538a9$export$7e32b29e1cb162e1({
    preventWheelAction: true,
    reverseSign: [
        true,
        true,
        false
    ]
});
var $b9e908af9b4538a9$var$WILL_END_TIMEOUT_DEFAULT = 400;
function $b9e908af9b4538a9$var$createWheelGesturesState() {
    return {
        isStarted: false,
        isStartPublished: false,
        isMomentum: false,
        startTime: 0,
        lastAbsDelta: Infinity,
        axisMovement: [
            0,
            0,
            0
        ],
        axisVelocity: [
            0,
            0,
            0
        ],
        accelerationFactors: [],
        scrollPoints: [],
        scrollPointsToMerge: [],
        willEndTimeout: $b9e908af9b4538a9$var$WILL_END_TIMEOUT_DEFAULT
    };
}
function $b9e908af9b4538a9$export$fd0a73f04f41aa21(optionsParam) {
    if (optionsParam === void 0) optionsParam = {};
    var _EventBus = $b9e908af9b4538a9$var$EventBus(), on = _EventBus.on, off = _EventBus.off, dispatch = _EventBus.dispatch;
    var config = $b9e908af9b4538a9$export$3208dd15ca232a1a;
    var state = $b9e908af9b4538a9$var$createWheelGesturesState();
    var currentEvent;
    var negativeZeroFingerUpSpecialEvent = false;
    var prevWheelEventState;
    var feedWheel = function feedWheel(wheelEvents) {
        if (Array.isArray(wheelEvents)) wheelEvents.forEach(function(wheelEvent) {
            return processWheelEventData(wheelEvent);
        });
        else processWheelEventData(wheelEvents);
    };
    var updateOptions = function updateOptions(newOptions) {
        if (newOptions === void 0) newOptions = {};
        if (Object.values(newOptions).some(function(option) {
            return option === undefined || option === null;
        })) {
            $b9e908af9b4538a9$var$__DEV__ && console.error("updateOptions ignored! undefined & null options not allowed");
            return config;
        }
        return config = $b9e908af9b4538a9$export$7e32b29e1cb162e1($b9e908af9b4538a9$var$_extends({}, $b9e908af9b4538a9$export$3208dd15ca232a1a, config, newOptions));
    };
    var publishWheel = function publishWheel(additionalData) {
        var wheelEventState = $b9e908af9b4538a9$var$_extends({
            event: currentEvent,
            isStart: false,
            isEnding: false,
            isMomentumCancel: false,
            isMomentum: state.isMomentum,
            axisDelta: [
                0,
                0,
                0
            ],
            axisVelocity: state.axisVelocity,
            axisMovement: state.axisMovement,
            get axisMovementProjection () {
                return $b9e908af9b4538a9$export$75064e1c6824e15c(wheelEventState.axisMovement, wheelEventState.axisVelocity.map(function(velocity) {
                    return $b9e908af9b4538a9$export$b74061472fe7c07(velocity);
                }));
            }
        }, additionalData);
        dispatch("wheel", $b9e908af9b4538a9$var$_extends({}, wheelEventState, {
            previous: prevWheelEventState
        })); // keep reference without previous, otherwise we would create a long chain
        prevWheelEventState = wheelEventState;
    }; // should prevent when there is mainly movement on the desired axis
    var shouldPreventDefault = function shouldPreventDefault(deltaMaxAbs, axisDelta) {
        var _config = config, preventWheelAction = _config.preventWheelAction;
        var deltaX = axisDelta[0], deltaY = axisDelta[1], deltaZ = axisDelta[2];
        if (typeof preventWheelAction === "boolean") return preventWheelAction;
        switch(preventWheelAction){
            case "x":
                return Math.abs(deltaX) >= deltaMaxAbs;
            case "y":
                return Math.abs(deltaY) >= deltaMaxAbs;
            case "z":
                return Math.abs(deltaZ) >= deltaMaxAbs;
            default:
                $b9e908af9b4538a9$var$__DEV__ && console.warn("unsupported preventWheelAction value: " + preventWheelAction, "warn");
                return false;
        }
    };
    var processWheelEventData = function processWheelEventData(wheelEvent) {
        var _clampAxisDelta = $b9e908af9b4538a9$var$clampAxisDelta($b9e908af9b4538a9$var$reverseAxisDeltaSign($b9e908af9b4538a9$var$normalizeWheel(wheelEvent), config.reverseSign)), axisDelta = _clampAxisDelta.axisDelta, timeStamp = _clampAxisDelta.timeStamp;
        var deltaMaxAbs = $b9e908af9b4538a9$export$bb8a7d60274b5fc6(axisDelta);
        if (wheelEvent.preventDefault && shouldPreventDefault(deltaMaxAbs, axisDelta)) wheelEvent.preventDefault();
        if (!state.isStarted) start();
        else if (state.isMomentum && deltaMaxAbs > Math.max(2, state.lastAbsDelta * 2)) {
            end(true);
            start();
        } // special finger up event on windows + blink
        if (deltaMaxAbs === 0 && Object.is && Object.is(wheelEvent.deltaX, -0)) {
            negativeZeroFingerUpSpecialEvent = true; // return -> zero delta event should not influence velocity
            return;
        }
        currentEvent = wheelEvent;
        state.axisMovement = $b9e908af9b4538a9$export$75064e1c6824e15c(state.axisMovement, axisDelta);
        state.lastAbsDelta = deltaMaxAbs;
        state.scrollPointsToMerge.push({
            axisDelta: axisDelta,
            timeStamp: timeStamp
        });
        mergeScrollPointsCalcVelocity(); // only wheel event (move) and not start/end get the delta values
        publishWheel({
            axisDelta: axisDelta,
            isStart: !state.isStartPublished
        }); // state.isMomentum ? MOMENTUM_WHEEL : WHEEL, { axisDelta })
        // publish start after velocity etc. have been updated
        state.isStartPublished = true; // calc debounced end function, to recognize end of wheel event stream
        willEnd();
    };
    var mergeScrollPointsCalcVelocity = function mergeScrollPointsCalcVelocity() {
        if (state.scrollPointsToMerge.length === $b9e908af9b4538a9$var$WHEELEVENTS_TO_MERGE) {
            state.scrollPoints.unshift({
                axisDeltaSum: state.scrollPointsToMerge.map(function(b) {
                    return b.axisDelta;
                }).reduce($b9e908af9b4538a9$export$75064e1c6824e15c),
                timeStamp: $b9e908af9b4538a9$export$cc6710ee5f037d57(state.scrollPointsToMerge.map(function(b) {
                    return b.timeStamp;
                }))
            }); // only update velocity after a merged scrollpoint was generated
            updateVelocity(); // reset toMerge array
            state.scrollPointsToMerge.length = 0; // after calculation of velocity only keep the most recent merged scrollPoint
            state.scrollPoints.length = 1;
            if (!state.isMomentum) detectMomentum();
        } else if (!state.isStartPublished) updateStartVelocity();
    };
    var updateStartVelocity = function updateStartVelocity() {
        state.axisVelocity = $b9e908af9b4538a9$export$891a5c5c55cf41aa(state.scrollPointsToMerge).axisDelta.map(function(d) {
            return d / state.willEndTimeout;
        });
    };
    var updateVelocity = function updateVelocity() {
        // need to have two recent points to calc velocity
        var _state$scrollPoints = state.scrollPoints, latestScrollPoint = _state$scrollPoints[0], prevScrollPoint = _state$scrollPoints[1];
        if (!prevScrollPoint || !latestScrollPoint) return;
         // time delta
        var deltaTime = latestScrollPoint.timeStamp - prevScrollPoint.timeStamp;
        if (deltaTime <= 0) {
            $b9e908af9b4538a9$var$__DEV__ && console.warn("invalid deltaTime");
            return;
        } // calc the velocity per axes
        var velocity = latestScrollPoint.axisDeltaSum.map(function(d) {
            return d / deltaTime;
        }); // calc the acceleration factor per axis
        var accelerationFactor = velocity.map(function(v, i) {
            return v / (state.axisVelocity[i] || 1);
        });
        state.axisVelocity = velocity;
        state.accelerationFactors.push(accelerationFactor);
        updateWillEndTimeout(deltaTime);
    };
    var updateWillEndTimeout = function updateWillEndTimeout(deltaTime) {
        // use current time between events rounded up and increased by a bit as timeout
        var newTimeout = Math.ceil(deltaTime / 10) * 12; // double the timeout, when momentum was not detected yet
        if (!state.isMomentum) newTimeout = Math.max(100, newTimeout * 2);
        state.willEndTimeout = Math.min(1000, Math.round(newTimeout));
    };
    var accelerationFactorInMomentumRange = function accelerationFactorInMomentumRange(accFactor) {
        // when main axis is the the other one and there is no movement/change on the current one
        if (accFactor === 0) return true;
        return accFactor <= $b9e908af9b4538a9$var$ACC_FACTOR_MAX && accFactor >= $b9e908af9b4538a9$var$ACC_FACTOR_MIN;
    };
    var detectMomentum = function detectMomentum() {
        if (state.accelerationFactors.length >= $b9e908af9b4538a9$var$WHEELEVENTS_TO_ANALAZE) {
            if (negativeZeroFingerUpSpecialEvent) {
                negativeZeroFingerUpSpecialEvent = false;
                if ($b9e908af9b4538a9$export$bb8a7d60274b5fc6(state.axisVelocity) >= 0.2) {
                    recognizedMomentum();
                    return;
                }
            }
            var recentAccelerationFactors = state.accelerationFactors.slice($b9e908af9b4538a9$var$WHEELEVENTS_TO_ANALAZE * -1); // check recent acceleration / deceleration factors
            // all recent need to match, if any did not match
            var detectedMomentum = recentAccelerationFactors.every(function(accFac) {
                // when both axis decelerate exactly in the same rate it is very likely caused by momentum
                var sameAccFac = !!accFac.reduce(function(f1, f2) {
                    return f1 && f1 < 1 && f1 === f2 ? 1 : 0;
                }); // check if acceleration factor is within momentum range
                var bothAreInRangeOrZero = accFac.filter(accelerationFactorInMomentumRange).length === accFac.length; // one the requirements must be fulfilled
                return sameAccFac || bothAreInRangeOrZero;
            });
            if (detectedMomentum) recognizedMomentum();
             // only keep the most recent events
            state.accelerationFactors = recentAccelerationFactors;
        }
    };
    var recognizedMomentum = function recognizedMomentum() {
        state.isMomentum = true;
    };
    var start = function start() {
        state = $b9e908af9b4538a9$var$createWheelGesturesState();
        state.isStarted = true;
        state.startTime = Date.now();
        prevWheelEventState = undefined;
        negativeZeroFingerUpSpecialEvent = false;
    };
    var willEnd = function() {
        var willEndId;
        return function() {
            clearTimeout(willEndId);
            willEndId = setTimeout(end, state.willEndTimeout);
        };
    }();
    var end = function end(isMomentumCancel) {
        if (isMomentumCancel === void 0) isMomentumCancel = false;
        if (!state.isStarted) return;
        if (state.isMomentum && isMomentumCancel) publishWheel({
            isEnding: true,
            isMomentumCancel: true
        });
        else publishWheel({
            isEnding: true
        });
        state.isMomentum = false;
        state.isStarted = false;
    };
    var _WheelTargetObserver = $b9e908af9b4538a9$var$WheelTargetObserver(feedWheel), observe = _WheelTargetObserver.observe, unobserve = _WheelTargetObserver.unobserve, disconnect = _WheelTargetObserver.disconnect;
    updateOptions(optionsParam);
    return $b9e908af9b4538a9$export$7e32b29e1cb162e1({
        on: on,
        off: off,
        observe: observe,
        unobserve: unobserve,
        disconnect: disconnect,
        feedWheel: feedWheel,
        updateOptions: updateOptions
    });
}
var $b9e908af9b4538a9$export$2e2bcd8739ae039 = $b9e908af9b4538a9$export$fd0a73f04f41aa21;


var $05bed03cbde0592c$var$defaultOptions = {
    active: true,
    breakpoints: {},
    wheelDraggingClass: "is-wheel-dragging",
    forceWheelAxis: undefined,
    target: undefined
};
$05bed03cbde0592c$export$1c3f64aa406d3265.globalOptions = undefined;
var $05bed03cbde0592c$var$__DEV__ = false;
function $05bed03cbde0592c$export$1c3f64aa406d3265(userOptions) {
    var optionsHandler = (0, $b943896dbfd2206b$export$2e2bcd8739ae039).optionsHandler();
    var optionsBase = optionsHandler.merge($05bed03cbde0592c$var$defaultOptions, $05bed03cbde0592c$export$1c3f64aa406d3265.globalOptions);
    var options;
    var cleanup = function cleanup() {};
    function init(embla) {
        var _options$target, _options$forceWheelAx;
        options = optionsHandler.atMedia(self.options);
        var engine = embla.internalEngine();
        var targetNode = (_options$target = options.target) != null ? _options$target : embla.containerNode().parentNode;
        var wheelAxis = (_options$forceWheelAx = options.forceWheelAxis) != null ? _options$forceWheelAx : engine.options.axis;
        var wheelGestures = (0, $b9e908af9b4538a9$export$2e2bcd8739ae039)({
            preventWheelAction: wheelAxis,
            reverseSign: [
                true,
                true,
                false
            ]
        });
        var unobserveTargetNode = wheelGestures.observe(targetNode);
        var offWheel = wheelGestures.on("wheel", handleWheel);
        var isStarted = false;
        var startEvent;
        function wheelGestureStarted(state) {
            try {
                startEvent = new MouseEvent("mousedown", state.event);
                dispatchEvent(startEvent);
            } catch (e) {
                // Legacy Browsers like IE 10 & 11 will throw when attempting to create the Event
                if ($05bed03cbde0592c$var$__DEV__) console.warn("Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)");
                return cleanup();
            }
            isStarted = true;
            addNativeMouseEventListeners();
            if (options.wheelDraggingClass) targetNode.classList.add(options.wheelDraggingClass);
        }
        function wheelGestureEnded(state) {
            isStarted = false;
            dispatchEvent(createRelativeMouseEvent("mouseup", state));
            removeNativeMouseEventListeners();
            if (options.wheelDraggingClass) targetNode.classList.remove(options.wheelDraggingClass);
        }
        function addNativeMouseEventListeners() {
            document.documentElement.addEventListener("mousemove", preventNativeMouseHandler, true);
            document.documentElement.addEventListener("mouseup", preventNativeMouseHandler, true);
            document.documentElement.addEventListener("mousedown", preventNativeMouseHandler, true);
        }
        function removeNativeMouseEventListeners() {
            document.documentElement.removeEventListener("mousemove", preventNativeMouseHandler, true);
            document.documentElement.removeEventListener("mouseup", preventNativeMouseHandler, true);
            document.documentElement.removeEventListener("mousedown", preventNativeMouseHandler, true);
        }
        function preventNativeMouseHandler(e) {
            if (isStarted && e.isTrusted) e.stopImmediatePropagation();
        }
        function createRelativeMouseEvent(type, state) {
            var moveX, moveY;
            if (wheelAxis === engine.options.axis) {
                var _state$axisMovement = state.axisMovement;
                moveX = _state$axisMovement[0];
                moveY = _state$axisMovement[1];
            } else {
                var _state$axisMovement2 = state.axisMovement;
                moveY = _state$axisMovement2[0];
                moveX = _state$axisMovement2[1];
            }
            return new MouseEvent(type, {
                clientX: startEvent.clientX + moveX,
                clientY: startEvent.clientY + moveY,
                screenX: startEvent.screenX + moveX,
                screenY: startEvent.screenY + moveY,
                movementX: moveX,
                movementY: moveY,
                button: 0,
                bubbles: true,
                cancelable: true,
                composed: true
            });
        }
        function dispatchEvent(event) {
            embla.containerNode().dispatchEvent(event);
        }
        function handleWheel(state) {
            var _state$axisDelta = state.axisDelta, deltaX = _state$axisDelta[0], deltaY = _state$axisDelta[1];
            var primaryAxisDelta = wheelAxis === "x" ? deltaX : deltaY;
            var crossAxisDelta = wheelAxis === "x" ? deltaY : deltaX;
            var isRelease = state.isMomentum && state.previous && !state.previous.isMomentum;
            var isEndingOrRelease = state.isEnding && !state.isMomentum || isRelease;
            var primaryAxisDeltaIsDominant = Math.abs(primaryAxisDelta) > Math.abs(crossAxisDelta);
            if (primaryAxisDeltaIsDominant && !isStarted && !state.isMomentum) wheelGestureStarted(state);
            if (!isStarted) return;
            if (isEndingOrRelease) wheelGestureEnded(state);
            else dispatchEvent(createRelativeMouseEvent("mousemove", state));
        }
        cleanup = function cleanup() {
            unobserveTargetNode();
            offWheel();
            removeNativeMouseEventListeners();
        };
    }
    var self = {
        name: "wheelGestures",
        options: optionsHandler.merge(optionsBase, userOptions),
        init: init,
        destroy: function destroy() {
            return cleanup();
        }
    };
    return self;
}




class $1c33733b85ca7469$var$CarouselDots extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    connectedCallback() {
        this._init();
        if (this._carousel) this._carousel.embla.on("reInit", this._handleCarouselReInit);
        this.embla.on("resize", this._handleCarouselResize);
    }
    disconnectedCallback() {
        if (this._carousel) this._carousel.embla.off("reInit", this._handleCarouselReInit);
        this.embla.off("resize", this._handleCarouselResize);
        this.embla.destroy();
    }
    _handleCarouselReInit = ()=>{
        this.embla.reInit(this._getOptions(), this._getPlugins());
    };
    _handleCarouselResize = ()=>{
        this.embla.reInit(this._getOptions(), this._getPlugins());
    };
    _getOptions = ()=>({
            inViewThreshold: +(this.dataset.inViewThreshhold || 0) || 0.5,
            containScroll: this.hasAttribute("data-contain-scroll") ? this.dataset.containScroll : "keepSnaps",
            align: this.dataset.align || "center",
            speed: this._getSpeed(),
            skipSnaps: this.hasAttribute("data-skip-snaps"),
            draggable: this.hasAttribute("is-draggable"),
            axis: this._axis
        });
    _getPlugins = ()=>{
        const plugins = [];
        const classNamesPlugin = (0, $8ffbf1b65d396f28$export$2e2bcd8739ae039)();
        plugins.push(classNamesPlugin);
        if (this.hasAttribute("data-with-wheel-gestures")) {
            const wheelGesturesPlugin = (0, $05bed03cbde0592c$export$1c3f64aa406d3265)({
                forceWheelAxis: this._axis
            });
            plugins.push(wheelGesturesPlugin);
        }
        return plugins;
    };
    _getSpeed() {
        const isAnimationReduce = (0, $5d3d77426481432d$export$601dcf7c5dad8f97)();
        if (isAnimationReduce) return 100;
        return 80;
    }
    _init() {
        const viewport = this.querySelector("[data-carousel-viewport]");
        if (!viewport) return;
        this.embla = (0, $b943896dbfd2206b$export$2e2bcd8739ae039)(viewport, this._getOptions(), this._getPlugins());
    }
    scrollNext = ()=>{
        if (!this._carousel) return;
        this._carousel.embla.scrollNext();
    };
    scrollPrev = ()=>{
        if (!this._carousel) return;
        this._carousel.embla.scrollPrev();
    };
    canScrollNext = ()=>{
        if (!this._carousel) return false;
        return this._carousel.embla.canScrollNext();
    };
    canScrollPrev = ()=>{
        if (!this._carousel) return false;
        return this._carousel.embla.canScrollPrev();
    };
    get _carousel() {
        return this.closest("carousel-component");
    }
    get _axis() {
        return this.dataset.axis === "vertical" ? "y" : "x";
    }
}
var $1c33733b85ca7469$export$2e2bcd8739ae039 = $1c33733b85ca7469$var$CarouselDots;




class $7843b352e3449695$var$CarouselDot extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._autoplayLoader = this.querySelector("[data-autoplay-indicator]");
        this._dotsCarousel = this.closest("carousel-dots");
    }
    connectedCallback() {
        this._updateAutoplayIndicator();
        if (this._carousel) {
            customElements.upgrade(this._carousel) // https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/upgrade
            ;
            this._carousel.subscribe("changePlayState", this._handleCarouselChangePlayState);
            this._carousel.subscribe("forceChangePlayState", this._handleCarouselForceChangePlayState);
            this._carousel.embla.on("select", this._handleCarouselSelect);
        }
        this._updateDot();
        if (this._dotsCarousel) {
            this._dotsCarousel.embla.on("settle", this._handleDotCarouselSettle);
            this._dotsCarousel.embla.on("reInit", this._handleCarouselSelect);
            this._dotsCarousel.embla.on("resize", this._handleDotCarouselResize);
        }
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "focus", this._handleFocus);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "blur", this._handleBlur);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "click", this._handleDotClick);
    }
    disconnectedCallback() {
        if (this._carousel) {
            this._carousel.unsubscribe("changePlayState", this._handleCarouselChangePlayState);
            this._carousel.unsubscribe("forceChangePlayState", this._handleCarouselForceChangePlayState);
            this._carousel.embla.off("select", this._handleCarouselSelect);
        }
        if (this._dotsCarousel) {
            this._dotsCarousel.embla.off("settle", this._handleDotCarouselSettle);
            this._dotsCarousel.embla.off("reInit", this._handleCarouselSelect);
            this._dotsCarousel.embla.off("resize", this._handleDotCarouselResize);
            this._dotsCarousel.embla.destroy();
        }
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "focus", this._handleFocus);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "blur", this._handleBlur);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "click", this._handleDotClick);
    }
    _handleCarouselForceChangePlayState = ()=>{
        if (!this._autoplayLoader || !this._carousel) return;
        const forceStopped = this._carousel.forceStopped;
        this._autoplayLoader.setAttribute("data-autoplay-stopped", forceStopped ? "true" : "false");
    };
    _handleCarouselChangePlayState = ()=>{
        this._updateAutoplayIndicator();
    };
    _handleDotClick = ()=>{
        this.trigger();
    };
    _handleCarouselSelect = ()=>{
        if (!this._carousel || !this._dotsCarousel) return;
        const selectedDotIndex = this._carousel.embla.selectedScrollSnap();
        if (selectedDotIndex === this._currentDotIndex) {
            this._dotsCarousel.embla.scrollTo(selectedDotIndex);
            this.classList.add("is-primary");
        } else this.classList.remove("is-primary");
    };
    _handleDotCarouselSettle = ()=>{
        this._updateDot();
    };
    _handleDotCarouselResize = ()=>{
        this._updateDot();
    };
    _handleFocus = ()=>{
        this.addEventListener("keydown", this._handleKeyDown);
    };
    _handleBlur = ()=>{
        this.removeEventListener("keydown", this._handleKeyDown);
    };
    _handleKeyDown = (event)=>{
        const isEnterKey = (0, $eceaf86a082c33f7$export$793b145c7f680179)(event.key || event.keyCode);
        if (isEnterKey) {
            event.preventDefault();
            this.trigger();
        }
    };
    _updateDot() {
        if (!this._dotsCarousel) return;
        this.classList.remove("is-prev-prev");
        const dotIndexList = this._dotsCarousel.embla.slideNodes().map((_, index)=>index);
        const visibleDotIndexList = this._dotsCarousel.embla.slidesInView();
        const firstDotIndex = dotIndexList[0];
        const firstVisibleDotIndex = visibleDotIndexList[0];
        const lastDotIndex = dotIndexList[dotIndexList.length - 1];
        const lastVisibleDotIndex = visibleDotIndexList[visibleDotIndexList.length - 1];
        const isLastDot = this._currentDotIndex === lastDotIndex;
        const isLastVisibleDot = this._currentDotIndex === lastVisibleDotIndex;
        const isFirstDot = this._currentDotIndex === firstDotIndex;
        const isFirstVisibleDot = this._currentDotIndex === firstVisibleDotIndex;
        if ((isFirstVisibleDot || isLastVisibleDot) && !isLastDot && !isFirstDot) this.classList.add("is-prev-prev");
    }
    _updateAutoplayIndicator() {
        if (!this._carousel) return;
        const isPlay = this._carousel.isPlay;
        if (this._autoplayLoader) this._autoplayLoader.setAttribute("data-play-state", isPlay ? "true" : "false");
    }
    trigger() {
        if (!this._carousel) return;
        this._carousel.embla.scrollTo(this._currentDotIndex);
        this._carousel.forceStop();
    }
    get _currentDotIndex() {
        if (!this._dotsCarousel) return -1;
        return [
            ...this._dotsCarousel.embla.slideNodes()
        ].indexOf(this);
    }
    get _carousel() {
        return this.closest("carousel-component");
    }
}
var $7843b352e3449695$export$2e2bcd8739ae039 = $7843b352e3449695$var$CarouselDot;





class $cbc43b5cf3f16955$var$CarouselBtn extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    connectedCallback() {
        this._update();
        if (this._carousel) {
            this._carousel.embla.on("reInit", this._handleCarouselReInit);
            this._carousel.embla.on("select", this._handleCarouselSelect);
            this._carousel.embla.on("scroll", this._handleCarouselScroll);
        }
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "focus", this._handleButtonFocus);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "blur", this._handleButtonBlur);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "click", this._handleButtonClick);
    }
    disconnectedCallback() {
        if (this._carousel) {
            this._carousel.embla.off("reInit", this._handleCarouselReInit);
            this._carousel.embla.off("select", this._handleCarouselSelect);
            this._carousel.embla.off("scroll", this._handleCarouselScroll);
        }
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "focus", this._handleButtonFocus);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "blur", this._handleButtonBlur);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "click", this._handleButtonClick);
    }
    _handleButtonClick = ()=>{
        this.trigger();
    };
    _handleCarouselReInit = ()=>{
        this._update();
    };
    _handleCarouselSelect = ()=>{
        this._update();
    };
    _handleCarouselScroll = (0, $e8126b7100a99238$exports.debounce)(()=>{
        this._update();
    }, 50);
    _handleButtonFocus = ()=>{
        this.addEventListener("keydown", this._handleKeyDown);
    };
    _handleButtonBlur = ()=>{
        this.removeEventListener("keydown", this._handleKeyDown);
    };
    _handleKeyDown = (event)=>{
        const isEnterKey = (0, $eceaf86a082c33f7$export$793b145c7f680179)(event.key || event.keyCode);
        if (isEnterKey) {
            event.preventDefault();
            this.trigger();
        }
    };
    _update() {
        this._updateDisabled();
        this._updateVisible();
    }
    _updateDisabled = ()=>{
        this.toggleAttribute("disabled", !this._canScroll());
    };
    _updateVisible() {
        if (!this._carousel) return;
        const snapList = [
            ...Array(this._carousel.embla.slideNodes().length).keys()
        ];
        const firstSnap = 0;
        const lastSnap = snapList.length - 1;
        const slidesInView = this._carousel.embla.slidesInView();
        const isNextButton = this.dataset.scrollDirection === "next";
        const isVisible = isNextButton ? slidesInView.includes(lastSnap) : slidesInView.includes(firstSnap);
        this.toggleAttribute("has-not-slides-not-in-view", isVisible);
    }
    _canScroll() {
        if (!this._carousel) return false;
        const isScrollNext = this.dataset.scrollDirection === "next";
        const canScroll = isScrollNext ? this._carousel.canScrollNext() : this._carousel.canScrollPrev();
        return canScroll;
    }
    trigger() {
        if (!this._carousel) return;
        const { scrollNext: scrollNext , scrollPrev: scrollPrev  } = this._carousel;
        const isScrollNext = this.dataset.scrollDirection === "next";
        if (isScrollNext) scrollNext();
        else scrollPrev();
    }
    get _carousel() {
        const carouselDots = this.closest("carousel-dots");
        const carousel = this.closest("carousel-component");
        return carouselDots || carousel;
    }
}
var $cbc43b5cf3f16955$export$2e2bcd8739ae039 = $cbc43b5cf3f16955$var$CarouselBtn;



class $03c7a98d4300db99$var$CarouselProgress extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._eventSetProgress = this.dataset.target === "scroll" ? "scroll" : "settle";
    }
    connectedCallback() {
        this.updateProgressBar();
        if (this._carousel) {
            this._carousel.embla.on(this._eventSetProgress, this._handleProgress);
            this._carousel.embla.on("reInit", this._handleCarouselReInit);
        }
    }
    disconnectedCallback() {
        if (this._carousel) {
            this._carousel.embla.off(this._eventSetProgress, this._handleProgress);
            this._carousel.embla.off("reInit", this._handleCarouselReInit);
        }
    }
    _handleProgress = ()=>{
        this.updateProgressBar();
    };
    _handleCarouselReInit = ()=>{
        this.updateProgressBar();
    };
    updateProgressBar() {
        const progressBarIndicator = this.querySelector("[data-carousel-progress-indicator]");
        if (!progressBarIndicator) return;
        const progress = this.getProgress();
        const isVerticalBar = this.dataset.axis === "vertical";
        progressBarIndicator.style.transform = isVerticalBar ? `translate3d(0, ${progress}%, 0)` : `translate3d(${progress}%, 0, 0)`;
    }
    getProgress() {
        const isTargetScroll = this.dataset.target === "scroll";
        return isTargetScroll ? this.getProgressByScroll() : this.getProgressBySlideInView();
    }
    getProgressBySlideInView() {
        if (!this._carousel) return 0;
        const slideCount = this._carousel.embla.slideNodes().length;
        const visibleSlides = this._carousel.embla.slidesInView();
        const lastVisibleSlide = visibleSlides[visibleSlides.length - 1] + 1;
        const progressPerSlide = 100 / slideCount;
        const progress = Math.ceil(progressPerSlide * lastVisibleSlide);
        return progress;
    }
    getProgressByScroll() {
        if (!this._carousel) return 0;
        const scrollProgress = this._carousel.embla.scrollProgress();
        const progress = Math.max(0, Math.min(1, scrollProgress)) * 100;
        return progress;
    }
    get _carousel() {
        return this.closest("carousel-component");
    }
}
var $03c7a98d4300db99$export$2e2bcd8739ae039 = $03c7a98d4300db99$var$CarouselProgress;






class $7752be30cbaa0b4a$var$HeaderComponent extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._lastScrollPosition = 0;
        this._resizeObserver = new ResizeObserver(this._handleResize);
        this._dropdowns = [
            ...this.querySelectorAll("[data-header-dropdown]")
        ];
    }
    connectedCallback() {
        this._setSticky();
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(window, "scroll", this._handleScroll);
        this._dropdowns.forEach((dropdown)=>{
            customElements.upgrade(dropdown) // https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/upgrade
            ;
            dropdown.subscribe("show", this._handleDropdownShow);
            dropdown.subscribe("hide", this._handleDrodpownHide);
        });
        this._resizeObserver.observe(this);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(window, "scroll", this._handleScroll);
        this._dropdowns.forEach((dropdown)=>{
            dropdown.unsubscribe("show", this._handleDropdownShow);
            dropdown.unsubscribe("hide", this._handleDrodpownHide);
        });
        this._resizeObserver.disconnect();
    }
    _handleResize = ()=>{
        this._setHidden(false);
        this.updatePosition();
        this.updateAnnouncementBarPosition();
        this.updateDropdowns();
    };
    _handleScroll = ()=>{
        const isMobile = (0, $5d3d77426481432d$export$e7a5aad9bb00dd62)();
        if (!this._isSticky && isMobile) this._updateVisibleAfterScroll();
        this._setScrollStatus();
    };
    _handleDrodpownHide = ()=>{
        this.classList.remove("header--light-bordered");
    };
    _handleDropdownShow = ()=>{
        this.classList.add("header--light-bordered");
    };
    _setScrollStatus() {
        if (!this._headerSection) return;
        const hasScrollProgress = this._announcementBar ? this._scrollPosition >= this._announcementBar.offsetHeight : this._scrollPosition >= 0;
        this._headerSection.toggleAttribute("scrolled", hasScrollProgress);
    }
    updateDropdowns() {
        this._dropdowns.forEach((dropdown)=>{
            dropdown.update();
        });
    }
    _updateVisibleAfterScroll() {
        const scrollPosition = window.scrollY;
        const isOverLastScrollPosition = this._lastScrollPosition < scrollPosition;
        const announcementBarHeight = this._announcementBar ? this._announcementBar.offsetHeight : 0;
        const headerSectionHeight = this._headerSection ? this._headerSection.offsetHeight : 0;
        const isUnderHeader = scrollPosition > announcementBarHeight + headerSectionHeight;
        const isHidden = isOverLastScrollPosition && isUnderHeader;
        if (this._headerSection) this._setHidden(isHidden);
        this._lastScrollPosition = scrollPosition;
    }
    _setHidden(isHidden) {
        if (!this._headerSection) return;
        this._headerSection.setAttribute("aria-hidden", isHidden ? "true" : "false");
    }
    _setSticky() {
        if (!this._headerSection) return;
        this._headerSection.setAttribute("mobile-sticky", "");
        this._headerSection.toggleAttribute("desktop-sticky", this._isSticky);
    }
    updatePosition() {
        if (!this._headerSection) return;
        (0, $e6a5d8115fb64fe3$export$f99c757f0e3e3773)("header-height", `${this._headerSection.offsetHeight}px`);
    }
    updateAnnouncementBarPosition() {
        if (!this._announcementBar) return;
        const visiblePart = this._announcementBar.offsetHeight - this._scrollPosition;
        (0, $e6a5d8115fb64fe3$export$f99c757f0e3e3773)("announcement-bar-height", `${visiblePart}px`);
        if (this._scrollPosition > this._announcementBar.offsetHeight) (0, $e6a5d8115fb64fe3$export$f99c757f0e3e3773)("announcement-bar-height", `0px`);
    }
    get _scrollPosition() {
        return window.scrollY || Math.abs(parseInt(document.body.style.top || "0"));
    }
    get _isSticky() {
        return this.hasAttribute("is-sticky");
    }
    get _headerSection() {
        return document.querySelector(".shopify-section.shopify-section-header");
    }
    get _announcementBar() {
        return document.querySelector(".shopify-section.shopify-section-announcement-bar");
    }
}
var $7752be30cbaa0b4a$export$2e2bcd8739ae039 = $7752be30cbaa0b4a$var$HeaderComponent;





class $175e16ebc295b679$var$DrawerMenu extends (0, $cc5469d7bf7c0ec5$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.header = document.querySelector("header-component");
        this.pages = [
            ...this.element.querySelectorAll("drawer-menu-page")
        ];
        this.pageMap = this.generatePageMap();
        this.homePage = this.pageMap["Menu"];
        this.toggler = document.getElementById("DrawerMenuToggler");
    }
    connectedCallback() {
        super.connectedCallback();
        this.mountBlocks();
        this.pages.forEach((page)=>{
            page.addEventListener("keydown", this.handlePageKeydown);
        });
        if (this._isEditorMode) {
            this._editor.subscribe("BLOCK_SELECT", this._handleBlockSelect);
            this._editor.subscribe("BLOCK_DESELECT", this._handleBlockDeselect);
            this._editor.subscribe("SECTION_SELECT", this._handleSectionSelect);
            this._editor.subscribe("SECTION_DESELECT", this._handleSectionDeselect);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.pages.forEach((page)=>{
            page.removeEventListener("keydown", this.handlePageKeydown);
        });
        if (this._isEditorMode) this._editor.destroy();
    }
    _handleSectionLoad = ()=>{
    //
    };
    _handleSectionSelect = ({ detail: { sectionId: sectionId  }  })=>{
        if (this.isVisible && this.dataset.sectionId === sectionId) {
            this.mount();
            this.reset();
        }
    };
    _handleSectionDeselect = ({ detail: { sectionId: sectionId  }  })=>{
        if (this.isVisible && this.dataset.sectionId === sectionId) {
            this.reset();
            this.hide(true);
        }
    };
    _handleBlockSelect = ({ detail: { blockId: blockId , sectionId: sectionId  }  })=>{
        if (this.dataset.sectionId === sectionId) {
            const target = this.pages.find((page)=>{
                return page.getAttribute("block-id") === blockId;
            });
            if (!target) return;
            this.open();
            this.setPage(target);
        }
    };
    _handleBlockDeselect = ({ detail: { blockId: blockId , sectionId: sectionId  }  })=>{
        if (this.dataset.sectionId === sectionId) {
            const target = this.pages.find((page)=>{
                return page.getAttribute("block-id") === blockId;
            });
            if (!target) return;
            this.hide(true);
        }
    };
    handlePageKeydown = (event)=>{
        const target = event.target;
        const page = target.closest("drawer-menu-page");
        if (!page) return;
        const targets = page.querySelectorAll((0, $eceaf86a082c33f7$export$f2d94ec8507fd10b)());
        const isLastTarget = target === targets[targets.length - 1];
        const isFirstTarget = target === targets[0];
        const isShift = event.shiftKey;
        if (event.keyCode !== 9) return;
        if (isShift && isFirstTarget || !isShift && isLastTarget) {
            event.preventDefault();
            this.focusOnToggler();
        }
    };
    focusOnToggler() {
        if (!this.toggler) return;
        this.toggler.focus();
        this.hide();
    }
    generatePageMap() {
        const pageMap = this.pages.reduce((map, page)=>{
            const pageId = page.dataset.pageId;
            return pageId ? {
                ...map,
                [pageId]: page
            } : map;
        }, {});
        return pageMap;
    }
    setPage(page) {
        const pageId = page.dataset.pageId;
        const prevOpenedPageId = this.openedPage?.dataset.prevPageId;
        const isReturn = pageId === prevOpenedPageId;
        const isNextPageEmpty = page.hasAttribute("data-empty-menu");
        if (this.openedPage) {
            if (isReturn || isNextPageEmpty) this.setPageVisible(this.openedPage, false);
        }
        const firstFocusTarget = page.querySelector((0, $eceaf86a082c33f7$export$f2d94ec8507fd10b)());
        if (firstFocusTarget) firstFocusTarget.focus();
        this.setPageVisible(page, true);
        this.openedPage = page;
    }
    reset() {
        this.pages.forEach((page)=>{
            this.setPageVisible(page, false);
        });
        this.setPageVisible(this.homePage, true);
        this.openedPage = this.homePage;
    }
    setPageVisible(page, isVisible) {
        page.setAttribute("aria-hidden", isVisible ? "false" : "true");
    }
    open() {
        if (this.header) {
            this.header.updatePosition();
            this.header.updateAnnouncementBarPosition();
        }
        return super.open();
    }
    hide(isInstant) {
        this.reset();
        return super.hide(isInstant);
    }
    mountBlocks() {
        const targets = this.element.querySelectorAll("[data-drawer-menu-target-block-id]");
        const template = this.element.querySelector("#drawer-menu-blocks-template");
        const templateContent = (0, $e6a5d8115fb64fe3$export$d4e734980dda982f)(template);
        targets.forEach((target)=>{
            const blockId = target.getAttribute("data-drawer-menu-target-block-id");
            const block = templateContent.querySelector(`[data-drawer-menu-block-id="${blockId}"]`);
            if (!block) return;
            target.className = `${target.className} ${block.className}`;
            target.innerHTML = block.innerHTML;
        });
    }
    getPage(pageId) {
        return this.pageMap[pageId];
    }
    get isVisible() {
        const isLowResolution = matchMedia("(max-width: 1016px)").matches;
        const isSection = this.hasAttribute("data-drawer-menu-is-section");
        return isSection || isLowResolution;
    }
}
var $175e16ebc295b679$export$2e2bcd8739ae039 = $175e16ebc295b679$var$DrawerMenu;



class $852602e034d5db4d$var$DrawerHeaderPage extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.block = this.querySelector("[data-drawer-menu-content]");
    }
    connectedCallback() {
        if (this.block) this.block.addEventListener("scroll", this._handleBlockScroll);
    }
    disconnectedCallback() {
        if (this.block) this.block.removeEventListener("scroll", this._handleBlockScroll);
    }
    _handleBlockScroll = ()=>{
        if (!this.block) return;
        const isScrolled = this.block.scrollTop > 0;
        this.toggleAttribute("header-shadow-visible", isScrolled);
    };
}
var $852602e034d5db4d$export$2e2bcd8739ae039 = $852602e034d5db4d$var$DrawerHeaderPage;





class $a03bb2dc4ff90b66$var$DrawerHeaderPageLink extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "click", this._handlePageLinkClick);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "keyup", this._handleKeyUp);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "click", this._handlePageLinkClick);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "keyup", this._handleKeyUp);
    }
    _handlePageLinkClick = (event)=>{
        event.preventDefault();
        this.setPage();
    };
    _handleKeyUp = (event)=>{
        event.preventDefault();
        const key = event.key || event.keyCode;
        const isEnterKey = (0, $eceaf86a082c33f7$export$793b145c7f680179)(key);
        if (isEnterKey) this.setPage();
    };
    setPage() {
        const drawerHeader = this.closest("drawer-menu");
        const pageId = this.dataset.pageId;
        if (!pageId || !drawerHeader) return;
        const page = drawerHeader.getPage(pageId);
        if (!page) return;
        drawerHeader.setPage(page);
    }
}
var $a03bb2dc4ff90b66$export$2e2bcd8739ae039 = $a03bb2dc4ff90b66$var$DrawerHeaderPageLink;



class $5c99123a7789bac3$var$Preloader {
    constructor(element){
        this._element = element;
    }
    show() {
        this._element.classList.remove("hidden");
    }
    hide() {
        this._element.classList.add("hidden");
    }
}
var $5c99123a7789bac3$export$2e2bcd8739ae039 = $5c99123a7789bac3$var$Preloader;


class $8b14e97d6a2de558$var$Pagination extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.cache = {};
    }
    updateTargetsFromHTML(html) {
        if (!this.dataset.containerId) return;
        const newResults = html.getElementById(this.dataset.containerId);
        const results = document.getElementById(this.dataset.containerId);
        if (newResults && results) {
            const targets = newResults.querySelectorAll(`.${this.dataset.target}`);
            targets.forEach((target)=>results.appendChild(target));
        }
    }
    updateResultsFromHTML(html) {
        if (!this.dataset.containerId) return;
        const newResults = html.getElementById(this.dataset.containerId);
        const results = document.getElementById(this.dataset.containerId);
        if (newResults && results) {
            results.innerHTML = newResults.innerHTML;
            results.scrollIntoView({
                behavior: "smooth"
            });
        }
    }
    updateFromHTML(html) {
        const newPagination = html.querySelector("pagination-component");
        if (newPagination) this.innerHTML = newPagination.innerHTML;
    }
    get loadingOverlay() {
        const prealoader = document.getElementById(this.dataset.overlayId || "");
        return new (0, $5c99123a7789bac3$export$2e2bcd8739ae039)(prealoader);
    }
}
var $8b14e97d6a2de558$export$2e2bcd8739ae039 = $8b14e97d6a2de558$var$Pagination;






class $439f73167559ba78$var$PaginationLoadButton extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "focus", this._handleButtonFocus);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "blur", this._handleButtonBlur);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "click", this._handleButtonClick);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "focus", this._handleButtonFocus);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "blur", this._handleButtonBlur);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "click", this._handleButtonClick);
    }
    _handleButtonClick = ()=>{
        this._fetchResults();
    };
    _handleButtonFocus = ()=>{
        this.addEventListener("keydown", this._handleKeyDown);
    };
    _handleButtonBlur = ()=>{
        this.removeEventListener("keydown", this._handleKeyDown);
    };
    _handleKeyDown = (event)=>{
        const isEnterKey = (0, $eceaf86a082c33f7$export$793b145c7f680179)(event.key || event.keyCode);
        if (isEnterKey) {
            event.preventDefault();
            this._fetchResults();
        }
    };
    _fetchResults() {
        const url = this.dataset.url;
        if (url) {
            this._setLoadingStatus(true);
            fetch(url).then((response)=>response.text()).then((responseText)=>{
                const html = (0, $e6a5d8115fb64fe3$export$8a49393be2d55148)(responseText);
                this._setLoadingStatus(false);
                this._updateFromHTML(html);
                this._updatePaginationFromHTML(html);
            }).catch(()=>{
                if (!(0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification) return;
                (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification.show("Error in pagination load button component", "warning");
            });
        }
    }
    _updatePaginationFromHTML(html) {
        const pagination = this.closest("pagination-component");
        if (pagination) {
            pagination.updateTargetsFromHTML(html);
            pagination.updateFromHTML(html);
        }
    }
    _setPaginationUrl(newBtn) {
        this.dataset.url = newBtn.dataset.url;
    }
    _removePagination() {
        const pagination = this.closest("pagination-component");
        if (pagination) pagination.remove();
    }
    _updateFromHTML(html) {
        const newBtn = html.querySelector("pagination-load-button");
        if (newBtn) this._setPaginationUrl(newBtn);
        else this._removePagination();
    }
    _setLoadingStatus(isLoading) {
        this.toggleAttribute("disabled", isLoading);
        this.classList.toggle("loading", isLoading);
    }
}
var $439f73167559ba78$export$2e2bcd8739ae039 = $439f73167559ba78$var$PaginationLoadButton;






class $a4b2f5820c603abd$var$PaginationLink extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "focus", this._handleLinkFocus);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "blur", this._handleLinkBlur);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "click", this._handleLinkClick);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "focus", this._handleLinkFocus);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "blur", this._handleLinkBlur);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "click", this._handleLinkClick);
    }
    _handleLinkClick = ()=>{
        this._fetchResults();
    };
    _handleLinkFocus = ()=>{
        this.addEventListener("keydown", this._handleKeyDown);
    };
    _handleLinkBlur = ()=>{
        this.removeEventListener("keydown", this._handleKeyDown);
    };
    _handleKeyDown = (event)=>{
        const isEnterKey = (0, $eceaf86a082c33f7$export$793b145c7f680179)(event.key || event.keyCode);
        if (isEnterKey) {
            event.preventDefault();
            this._fetchResults();
        }
    };
    _fetchResults() {
        const pagination = this.closest("pagination-component");
        const url = this.dataset.url;
        if (pagination && url) {
            if (pagination.cache[url]) this._updatePaginationFromHTML(pagination.cache[url]);
            else this._getFromUrl(url);
        }
    }
    _getFromUrl(url) {
        const pagination = this.closest("pagination-component");
        if (pagination) {
            pagination.loadingOverlay.show();
            fetch(url).then((response)=>response.text()).then((responseText)=>{
                const html = (0, $e6a5d8115fb64fe3$export$8a49393be2d55148)(responseText);
                pagination.loadingOverlay.hide();
                pagination.cache[url] = html;
                this._updatePaginationFromHTML(html);
            }).catch(()=>{
                if (!(0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification) return;
                (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification.show("Error in pagination link component", "warning");
            });
        }
    }
    _updatePaginationFromHTML(html) {
        const pagination = this.closest("pagination-component");
        if (pagination) {
            pagination.updateResultsFromHTML(html);
            pagination.updateFromHTML(html);
        }
    }
}
var $a4b2f5820c603abd$export$2e2bcd8739ae039 = $a4b2f5820c603abd$var$PaginationLink;






class $ca9aa4a2ecd080ca$var$PaginationInfiniteScroll extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._observerOptions = {
            root: null,
            rootMargin: "-35% 0px -35% 0px"
        };
        this._preloaderSelector = ".loading-spinner";
        this._preloader = this.querySelector(this._preloaderSelector);
        this._preloaderComponent = new (0, $5c99123a7789bac3$export$2e2bcd8739ae039)(this._preloader);
    }
    connectedCallback() {
        this._intersectionObserver = new IntersectionObserver(this._handleIntersectionObserve, this._observerOptions);
        this._intersectionObserver.observe(this);
    }
    disconnectedCallback() {
        this._intersectionObserver.disconnect();
    }
    _handleIntersectionObserve = (entries)=>{
        const url = this.dataset.url;
        if (url) {
            if (!entries[0].isIntersecting) return;
            this._preloaderComponent.show();
            fetch(url).then((response)=>response.text()).then((responseText)=>{
                const html = (0, $e6a5d8115fb64fe3$export$8a49393be2d55148)(responseText);
                const pagination = this.closest("pagination-component");
                this._preloaderComponent.hide();
                this._updateFromHTML(html);
                if (pagination) pagination.updateTargetsFromHTML(html);
            }).catch(()=>{
                if (!(0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification) return;
                (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification.show("Error in infinite scroll component", "warning");
            });
        }
    };
    _updateFromHTML(html) {
        const newPagination = html.querySelector("pagination-infinite-scroll");
        if (newPagination) {
            const url = newPagination.dataset.url;
            if (url) this._setPaginationUrl(url);
            else this._intersectionObserver.unobserve(this);
        }
    }
    _setPaginationUrl(url) {
        this.dataset.url = url;
    }
}
var $ca9aa4a2ecd080ca$export$2e2bcd8739ae039 = $ca9aa4a2ecd080ca$var$PaginationInfiniteScroll;




class $ab56719770e828e6$var$DeferredMedia extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._poster = this.querySelector('[id^="Deferred-Poster-"]');
        this._carousel = this.closest("carousel-component");
    }
    connectedCallback() {
        if (this.hasAttribute("data-autoplay")) this.loadContent();
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._poster, "click", this._handlePosterClick);
        if (this._carousel) this._carousel.embla.on("select", this._handleCarouselSelect);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._poster, "click", this._handlePosterClick);
        if (this._carousel) this._carousel.embla.off("select", this._handleCarouselSelect);
    }
    _handleCarouselSelect = ()=>{
        this._removeVideo();
    };
    _handlePosterClick = ()=>{
        this.loadContent();
    };
    loadContent() {
        if (!this.getAttribute("loaded")) {
            this._addVideo();
            this.setAttribute("loaded", "true");
        }
    }
    _removeVideo() {
        const video = this.querySelector("video,  iframe");
        if (video) {
            video.remove();
            this.removeAttribute("loaded");
        }
    }
    _addVideo() {
        const content = document.createElement("div");
        const template = this.querySelector("template");
        const templateContent = template?.content;
        if (!templateContent || !templateContent.firstElementChild) return;
        const firstChild = templateContent.firstElementChild.cloneNode(true);
        content.appendChild(firstChild);
        const video = content.querySelector("video, model-viewer, iframe");
        if (!video) return;
        this.appendChild(video);
        if (video.tagName === "VIDEO") video.play();
    }
}
var $ab56719770e828e6$export$2e2bcd8739ae039 = $ab56719770e828e6$var$DeferredMedia;





class $56412a68e1de6aa4$var$PickupAvailability extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.fetchAvailability();
    }
    fetchAvailability() {
        const variantSectionUrl = `${this.dataset.baseUrl}variants/${this.dataset.variantId}/?section_id=pickup-availability`;
        fetch(variantSectionUrl).then((response)=>response.text()).then((text)=>{
            const html = (0, $e6a5d8115fb64fe3$export$8a49393be2d55148)(text).querySelector(".shopify-section");
            this.updateSidebarFromHTML(html);
            this.updateContentFromHTML(html);
        }).catch(()=>{
            if (!(0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification) return;
            (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification.show("Error in pickup availability component", "warning");
        });
    }
    updateVariantId(newVariantId) {
        this.dataset.variantId = newVariantId;
    }
    updateContentFromHTML(html) {
        const content = this.querySelector("pickup-availability-content");
        const newContent = html.querySelector("pickup-availability-content");
        if (content && newContent) content.innerHTML = newContent.innerHTML;
    }
    updateSidebarFromHTML(html) {
        const drawer = document.querySelector(`#pickup-availability-sidebar`);
        const newTemplate = html.querySelector("#pickup-availability-sidebar template");
        if (drawer && newTemplate) drawer.updateTemplate(newTemplate);
    }
}
var $56412a68e1de6aa4$export$2e2bcd8739ae039 = $56412a68e1de6aa4$var$PickupAvailability;


class $39569d312fa19772$var$Button {
    constructor(element){
        this._element = element;
        this._text = this._element.querySelector("[data-button-text]");
    }
    setDisable(isDisabled) {
        this._element.toggleAttribute("disabled", isDisabled);
    }
    setLoading(isLoading) {
        this._element.classList.toggle("loading", isLoading);
    }
    setText(text) {
        if (!this._text) return;
        this._text.textContent = text;
    }
}
var $39569d312fa19772$export$2e2bcd8739ae039 = $39569d312fa19772$var$Button;




const { routes: $f932825f9961cd15$var$routes  } = window;
class $f932825f9961cd15$var$CartAPI {
    change(config) {
        return fetch($f932825f9961cd15$var$routes.cart_change_url, config).then((response)=>response.text());
    }
    add(config) {
        return fetch($f932825f9961cd15$var$routes.cart_add_url, config).then((response)=>response.text());
    }
    update(config) {
        return fetch(`${$f932825f9961cd15$var$routes.cart_update_url}`, config);
    }
    get() {
        return fetch($f932825f9961cd15$var$routes.cart_url).then((response)=>response.text());
    }
}
var $f932825f9961cd15$export$2e2bcd8739ae039 = $f932825f9961cd15$var$CartAPI;


const $0cd7bcc90e4d304e$export$1811237fdf5ac5d = (type = "json")=>{
    return {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: `application/${type}`
        }
    };
};


const $35578a442c28da97$export$2bccf78e246a5305 = (form)=>{
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()){
        const regex = /(?:^(properties\[))(.*?)(?:\]$)/;
        if (regex.test(key)) {
            obj.properties = obj.properties || {};
            obj.properties[regex.exec(key)[2]] = formData.get(key);
        } else obj[key] = formData.get(key);
    }
    return JSON.stringify(obj);
};



class $5ea14d7179693556$var$QuickView {
    constructor(elementId){
        this._element = document.querySelector(`#${elementId}`);
    }
    requestProductFromUrl = (url, id)=>{
        if (this._element) this._element.requestProductFromUrl(url, id);
    };
    openAndRenderProductByUrl = (url)=>{
        if (this._element) this._element.openAndRenderProductByUrl(url);
    };
    hide() {
        if (this._element) return this._element.hide();
        return (0, $eceaf86a082c33f7$export$1391212d75b2ee65)();
    }
    get isOpen() {
        if (!this._element) return false;
        return this._element.isOpen;
    }
}
const $5ea14d7179693556$export$e53b747444795854 = new $5ea14d7179693556$var$QuickView("Quick-view");

class $c983ea34406e93d3$var$ProductForm extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.sidebar = document.querySelector(`#sidebar-component-for-cart`);
        this.cart = document.querySelector("#cart-page-component");
        this.cartNotificationPopup = document.querySelector("#CartNotificationPopup");
        this.formSelector = "form";
        this.variantInputSelector = `[data-product-form-variant]`;
        this.form = this.querySelector(this.formSelector);
        if (this.form) this.variantInput = this.form.querySelector(this.variantInputSelector);
        this._cartApi = new (0, $f932825f9961cd15$export$2e2bcd8739ae039)();
    }
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this.form, "submit", this._handleFormSubmit);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this.form, "submit", this._handleFormSubmit);
    }
    _handleFormSubmit = (event)=>{
        event.preventDefault();
        const config = this._getQueryConfig();
        this.setDisable(true);
        this.setLoading(true);
        this._cartApi.add(config).then((state)=>{
            const parsedState = JSON.parse(state);
            this.setDisable(false);
            this.setLoading(false);
            if (parsedState.description) {
                if (!(0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification) return;
                (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification.show(parsedState.description, "warning");
                return;
            }
            if (this.cart) return this._cartApi.get();            
            else if (this.sidebar) this.updateSidebarCartByParsedState(parsedState);
            else this.updatePopupByParsedState(parsedState);
        }).then((response)=>{
            if (this.cart && response) {
                const html = (0, $e6a5d8115fb64fe3$export$8a49393be2d55148)(response);
                this.updateCartByHTML(html);
            }
        }).catch(()=>{
            if (!(0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification) return;
            (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification.show("Error in product form component", "warning");
        });
    };
    updateCartByHTML(html) {
        if (!this.cart) return;
        this.cart.updateByHTML(html);
        this.cart.updateEmptyStatus(false);
        this.showCallbackAfterCloseDialogWindow(()=>{
        // remove this
        });
    }
    updateSidebarCartByParsedState(parsedState) {
        if (!this.sidebar) return;
        this.sidebar.updateEmptyStatus(false);
        const openSidebarCartCallback = ()=>{
            if (!this.sidebar) return;
            this.sidebar.purchaseHandler(parsedState);
        };
        this.showCallbackAfterCloseDialogWindow(openSidebarCartCallback);
    }
    updatePopupByParsedState(parsedState) {
        const openPopupCallback = ()=>{
            if (!this.cartNotificationPopup) return;
            this.cartNotificationPopup.showProductFromParsedState(parsedState, parsedState.id);
        };
        this.showCallbackAfterCloseDialogWindow(openPopupCallback);
    }
    showCallbackAfterCloseDialogWindow(callback) {
        return (0, $eceaf86a082c33f7$export$1391212d75b2ee65)(0).then(()=>{
            if (!(0, $5ea14d7179693556$export$e53b747444795854).isOpen) callback();
            if ((0, $5ea14d7179693556$export$e53b747444795854).isOpen) (0, $5ea14d7179693556$export$e53b747444795854).hide().then(callback);
        });
    }
    _getFormData() {
        return JSON.parse((0, $35578a442c28da97$export$2bccf78e246a5305)(this.form));
    }
    _getQueryConfig() {
        const config = (0, $0cd7bcc90e4d304e$export$1811237fdf5ac5d)("javascript");
        const cartDrawerSectionId = this.sidebar ? this.sidebar.sectionId : "cart-drawer";
        const sections = [
            "cart-count",
            cartDrawerSectionId,
            "cart-notification-popup-content"
        ];
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        config.body = JSON.stringify({
            ...this._getFormData(),
            sections: sections,
            sections_url: window.location.pathname
        });
        return config;
    }
    setLoading(isLoading) {
        const submitButtons = this.querySelectorAll('button[type="submit"]');
        submitButtons.forEach((submitButton)=>{
            const submitButtonComponent = new (0, $39569d312fa19772$export$2e2bcd8739ae039)(submitButton);
            submitButtonComponent.setLoading(isLoading);
        });
    }
    setDisable(isDisable) {
        const submitButtons = this.querySelectorAll('button[type="submit"]');
        submitButtons.forEach((submitButton)=>{
            const submitButtonComponent = new (0, $39569d312fa19772$export$2e2bcd8739ae039)(submitButton);
            submitButtonComponent.setDisable(isDisable);
        });
    }
    setButtonText(text) {
        const submitButtons = this.querySelectorAll('button[type="submit"]');
        submitButtons.forEach((submitButton)=>{
            const submitButtonComponent = new (0, $39569d312fa19772$export$2e2bcd8739ae039)(submitButton);
            submitButtonComponent.setText(text);
        });
    }
}
var $c983ea34406e93d3$export$2e2bcd8739ae039 = $c983ea34406e93d3$var$ProductForm;



class $960285004fafbb25$var$ProductFormButton extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.button = this.querySelector("[data-product-form-button]");
        this.footer = document.querySelector(".shopify-section.shopify-section-footer");
        this.form = this.closest("product-form");
    }
    connectedCallback() {
        window.addEventListener("scroll", this._handleWindowScroll);
    }
    disconnectedCallback() {
        window.removeEventListener("scroll", this._handleWindowScroll);
    }
    _handleWindowScroll = ()=>{
        if (!this.button || !this.form) return;
        const scrollPosition = window.scrollY;
        const criticalPoint = this.form.offsetTop + this.form.offsetHeight;
        const footerOffsetTop = this.footer ? this.footer.offsetTop : 0;
        const isOverFooter = window.innerHeight + scrollPosition < footerOffsetTop;
        const isVisible = isOverFooter && scrollPosition > criticalPoint;
        this.toggleAttribute("visible", isVisible);
        document.body.toggleAttribute("is-product-form-button-fixed", isVisible);
    };
}
var $960285004fafbb25$export$2e2bcd8739ae039 = $960285004fafbb25$var$ProductFormButton;




class $803a7920da112a4a$var$ProductBlock extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.blockSelector = `[data-product-block-item]`;
        this.containerSelector = `[data-product-block-container]`;
        this.activeTemplate = this.querySelector(this.blockSelector);
        this.activeTemplateContainer = this.querySelector(this.containerSelector);
    }
    updateByVariantId(variantId) {
        const selectedTemplate = this.querySelector(`[data-product-block-template="${variantId}"]`);
        if (this.activeTemplate && this.activeTemplateContainer) {
            const newTemplate = (0, $e6a5d8115fb64fe3$export$8ea4fc17cec6f158)(selectedTemplate);
            if (newTemplate) {
                this.activeTemplate.remove();
                this.activeTemplate = newTemplate;
                this.activeTemplateContainer.appendChild(newTemplate);
            }
        }
    }
}
var $803a7920da112a4a$export$2e2bcd8739ae039 = $803a7920da112a4a$var$ProductBlock;




const { Shopify: $ff1cc270be8c5975$var$Shopify  } = window;
class $ff1cc270be8c5975$var$ProductModel extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._poster = this.querySelector('[id^="Deferred-Poster-"]');
    }
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._poster, "click", this._handlePosterClick);
        if (this._carousel) this._carousel.embla.on("select", this._handleCarouselSelect);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._poster, "click", this._handlePosterClick);
        if (this._carousel) this._carousel.embla.off("select", this._handleCarouselSelect);
    }
    _handlePosterClick = ()=>{
        this._loadContent();
    };
    _handleCarouselSelect = ()=>{
        if (this._carousel) this._setCarouselDraggable(true);
    };
    _loadContent() {
        if (!this.getAttribute("loaded")) {
            this._addModel();
            this.setAttribute("loaded", true);
            if (this._carousel) this._setCarouselDraggable(false);
        }
        $ff1cc270be8c5975$var$Shopify.loadFeatures([
            {
                name: "model-viewer-ui",
                version: "1.0",
                onLoad: this.setupModelViewerUI.bind(this)
            }
        ]);
    }
    _addModel() {
        const template = this.querySelector("template");
        if (!template || !template.content) return;
        const templateContent = template.content;
        const content = document.createElement("div");
        content.appendChild(templateContent.firstElementChild.cloneNode(true));
        const modelViewer = content.querySelector("model-viewer");
        this.appendChild(modelViewer);
    }
    setupModelViewerUI(errors) {
        if (errors) return;
        this.modelViewerUI = new $ff1cc270be8c5975$var$Shopify.ModelViewerUI(this.querySelector("model-viewer"));
    }
    _setCarouselDraggable(isDraggable) {
        const modelViewer = this.querySelector(".shopify-model-viewer-ui");
        this._carousel.dataset.draggable = isDraggable ? "true" : "false";
        this._carousel.reInit();
        if (isDraggable && modelViewer) {
            modelViewer.remove();
            this.removeAttribute("loaded");
        }
    }
    get _carousel() {
        return this.closest("carousel-component");
    }
}
var $ff1cc270be8c5975$export$2e2bcd8739ae039 = $ff1cc270be8c5975$var$ProductModel;
window.ProductModel = {
    loadShopifyXR () {
        $ff1cc270be8c5975$var$Shopify.loadFeatures([
            {
                name: "shopify-xr",
                version: "1.0",
                onLoad: this.setupShopifyXR.bind(this)
            }
        ]);
    },
    setupShopifyXR (errors) {
        if (errors) return;
        if (!window.ShopifyXR) {
            document.addEventListener("shopify_xr_initialized", ()=>this.setupShopifyXR());
            return;
        }
        document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON)=>{
            window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
            modelJSON.remove();
        });
        window.ShopifyXR.setupXRElements();
    }
};
window.addEventListener("DOMContentLoaded", ()=>{
    if ($ff1cc270be8c5975$var$Shopify.designMode) document.querySelectorAll("[data-shopify-xr-hidden]").forEach((element)=>element.classList.add("hidden"));
    if (window.ProductModel) window.ProductModel.loadShopifyXR();
});





class $3cf3c2a88f93aea3$var$CartItemCheckmark {
    constructor(element){
        this.element = element;
    }
    show() {
        this.element.classList.remove("hidden");
        (0, $eceaf86a082c33f7$export$1391212d75b2ee65)(2500).then(()=>{
            this.element.classList.add("hidden");
        });
    }
}
var $3cf3c2a88f93aea3$export$2e2bcd8739ae039 = $3cf3c2a88f93aea3$var$CartItemCheckmark;


class $f45bacd28df1c799$var$CartItemQuantity {
    constructor(element){
        this.element = element;
    }
    setDisable(isDisable) {
        this.element.setDisable(isDisable);
    }
}
var $f45bacd28df1c799$export$2e2bcd8739ae039 = $f45bacd28df1c799$var$CartItemQuantity;


class $11b6b278d8dd46cb$var$CartItemTotals {
    constructor(element){
        this.element = element;
    }
    setLoading(isLoading) {
        this.element.toggleAttribute("is-loading", isLoading);
    }
}
var $11b6b278d8dd46cb$export$2e2bcd8739ae039 = $11b6b278d8dd46cb$var$CartItemTotals;



class $58b56a50cb604a43$var$CartItem extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._checkmarkSelector = `[data-cart-item-checkmark]`;
        this._bodySelector = `[data-cart-item-body]`;
        this._totalsSelector = `[data-cart-item-totals]`;
        this._quantitySelector = `[data-cart-item-quantity]`;
        this._transitionDuration = (0, $e6a5d8115fb64fe3$export$5faba83c1624a4ba)(this);
        this.resizeObserver = new ResizeObserver(this._handleCartItemResize);
    }
    connectedCallback() {
        const body = this.querySelector(this._bodySelector);
        if (body) this.resizeObserver.observe(body);
    }
    disconnectedCallback() {
        this.resizeObserver.disconnect();
    }
    removeFromCart = ()=>{
        this.expand().then(()=>this.collapse()).then(()=>this.remove());
    };
    expand = ()=>{
        this._setMaxHeight(this.scrollHeight);
        return (0, $eceaf86a082c33f7$export$1391212d75b2ee65)(this._transitionDuration);
    };
    collapse = ()=>{
        this._setMaxHeight(0);
        return (0, $eceaf86a082c33f7$export$1391212d75b2ee65)(this._transitionDuration);
    };
    showCheckmark = ()=>{
        const checkmarkElement = this.querySelector(this._checkmarkSelector);
        if (checkmarkElement) {
            const checkmark = new (0, $3cf3c2a88f93aea3$export$2e2bcd8739ae039)(checkmarkElement);
            checkmark.show();
        }
    };
    setLoading = (isLoading)=>{
        const totalsElement = this.querySelector(this._totalsSelector);
        if (totalsElement) {
            const totals = new (0, $11b6b278d8dd46cb$export$2e2bcd8739ae039)(totalsElement);
            totals.setLoading(isLoading);
        }
    };
    _handleCartItemResize = ()=>{
        this._setMaxHeight(this.scrollHeight);
    };
    _setMaxHeight(maxHeight) {
        this.style.maxHeight = `${maxHeight}px`;
    }
    setQuantityDisabled(isDisable) {
        const quantityElement = this.querySelector(this._quantitySelector);
        if (quantityElement) {
            const quantity = new (0, $f45bacd28df1c799$export$2e2bcd8739ae039)(quantityElement);
            quantity.setDisable(isDisable);
        }
    }
}
var $58b56a50cb604a43$export$2e2bcd8739ae039 = $58b56a50cb604a43$var$CartItem;









class $cfda6728b6268b3d$var$Cart extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._cartApi = new (0, $f932825f9961cd15$export$2e2bcd8739ae039)();
    }
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "change", this._handleCartChange);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "change", this._handleCartItemChange);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "change", this._handleCartChange);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "change", this._handleCartItemChange);
    }
    _handleCartItemChange = (event)=>{
        const cartItem = this.querySelector(`#CartItem-${+event.target.dataset.index}`);
        if (cartItem) cartItem.setLoading(true);
    };
    _handleCartChange = (0, $e8126b7100a99238$exports.debounce)((event)=>{
        this.updateItem(+event.target.dataset.index, event.target.value);
    }, 500);
    getConfigByItemIndexAndQuantity(itemIndex, quantity) {
        const config = {
            ...(0, $0cd7bcc90e4d304e$export$1811237fdf5ac5d)(),
            body: JSON.stringify({
                line: itemIndex + 1,
                quantity: quantity
            })
        };
        return config;
    }
    updateItem(itemIndex, quantity) {
        const config = this.getConfigByItemIndexAndQuantity(itemIndex, quantity);
        const cartItem = this.querySelector(`#CartItem-${itemIndex}`);
        if (!cartItem) return;
        const newQuantity = +quantity;
        const currentQuantity = +(cartItem.dataset.quantity || 0);
        if (currentQuantity === newQuantity) {
            cartItem.setLoading(false);
            return;
        }
        if (newQuantity === 0) {
            this.updateEmptyStatus(this._cartItemCount === 1);
            cartItem.removeFromCart();
        }
        this.setButtonLoading(true);
        cartItem.setQuantityDisabled(true);
        this._cartApi.change(config).then(()=>{
            return this._cartApi.get();
        }).then((response)=>{
            const html = (0, $e6a5d8115fb64fe3$export$8a49393be2d55148)(response);
            this.setButtonLoading(false);
            cartItem.setQuantityDisabled(false);
            cartItem.setLoading(false);
            this.updateByHTML(html);
        }).catch(()=>{
            this._showError();
        });
    }
    _showError() {
        if (!(0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification) return;
        const { cartStrings: cartStrings  } = window;
        (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification.show(cartStrings.error, "warning");
    }
    updateEmptyStatus(isEmpty) {
        this._updateCartEmptyStatus(isEmpty);
        this._updateSubtotalEmptyStatus(isEmpty);
    }
    _updateCartEmptyStatus(isEmpty) {
        this.classList.toggle("is-empty", isEmpty);
    }
    _updateSubtotalEmptyStatus(isEmpty) {
        const subtotal = document.getElementById(this.sectionIds.local.subtotal);
        if (subtotal) subtotal.classList.toggle("is-empty", isEmpty);
    }
    updateByHTML(html) {
        this.updateFreeShippingBarByHTML(html);
        const targets = [
            `#${this.sectionIds.local.cartItems} [data-cart-page-items]`,
            "#CartCount",
            "#StickyCartCount",
            `#${this.sectionIds.local.subtotal} [data-cart-page-subtotal-price]`
        ];
        targets.forEach((selector)=>{
            const target = document.querySelector(selector);
            const newTarget = html.querySelector(selector);
            if (target && newTarget) target.innerHTML = newTarget.innerHTML;
        });
    }
    updateFreeShippingBarByHTML(html) {
        const selector = `#${this.sectionIds.local.cartItems} [data-cart-page-free-shipping-bar] cart-free-shipping-bar`;
        const bar = document.querySelector(selector);
        const newBar = html.querySelector(selector);
        if (bar && newBar) {
            const customElementContainer = (0, $eceaf86a082c33f7$export$402b71a6ab88771a)(newBar);
            const cartTotal = newBar.dataset.cartTotal || 0;
            bar.updateProgressByCartTotal(+cartTotal);
            (0, $eceaf86a082c33f7$export$6b8b061b59c6fc66)(customElementContainer);
        }
    }
    setButtonLoading(isLoading) {
        const subtotal = document.getElementById(this.sectionIds.local.subtotal);
        if (subtotal) {
            const button = subtotal.querySelector("[data-cart-page-checkout-button]");
            if (button) {
                button.toggleAttribute("disabled", isLoading);
                button.classList.toggle("loading", isLoading);
            }
        }
    }
    get _cartItemCount() {
        const cartItems = this.querySelectorAll("cart-item");
        return cartItems.length;
    }
    get sectionIds() {
        return {
            local: {
                subtotal: "CartPage-SubtotalSection",
                cartItems: "CartPage-CartItemsSection"
            }
        };
    }
}
var $cfda6728b6268b3d$export$2e2bcd8739ae039 = $cfda6728b6268b3d$var$Cart;










class $0e7c3d37876a0df5$var$SidebarCart extends (0, $cc5469d7bf7c0ec5$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.sectionId = this.dataset.sectionId || "cart-drawer";
        this._sections = [
            "cart-count",
            this.sectionId
        ];
        this.resultsSelector = `[data-sidebar-cart-results]`;
        this.viewportSelector = `[data-sidebar-cart-viewport]`;
        this.headerSelector = "[data-sidebar-cart-header]";
        this.footerSelector = "[data-sidebar-cart-footer]";      
        this.viewport = this.element.querySelector(this.viewportSelector);
        this.results = this.element.querySelector(this.resultsSelector);
        this.header = this.element.querySelector(this.headerSelector);
        this.footer = this.element.querySelector(this.footerSelector);
        this._cartApi = new (0, $f932825f9961cd15$export$2e2bcd8739ae039)();
        this._resizeObserver = new ResizeObserver(this._handleContentResultsResize);
        document.addEventListener('cart:updated', async (state)=> {
            const parsedState = JSON.parse(state.detail.data);
            this.updateCartDrawer(parsedState);
        }); 
     
    }
    connectedCallback() {
        super.connectedCallback();
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "change", this._handleCartChange);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "change", this._handleCartItemChange);
        if (this.viewport) this.viewport.addEventListener("scroll", this._handleViewportScroll);
        if (this.results) this._resizeObserver.observe(this.results);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "change", this._handleCartChange);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "change", this._handleCartItemChange);
        if (this.viewport) this.viewport.removeEventListener("scroll", this._handleViewportScroll);
        this._resizeObserver.disconnect();
    }
    _handleCartItemChange = (event)=>{
        const cartItem = this.querySelector(`#CartItem-${+event.target.dataset.index}`);
        if (cartItem) cartItem.setLoading(true);
    };
    _handleCartChange = (0, $e8126b7100a99238$exports.debounce)((event)=>{
        this.updateItem(+event.target.dataset.index, event.target.value);
    }, 500);
    _handleViewportScroll = ()=>{
        if (!this.viewport) return;
        const isContentOverflow = this.checkContentOverflow();
        const isScrolled = this.viewport.scrollTop > 0;
        this.toggleAttribute("header-shadow-visible", isContentOverflow && isScrolled);
    };
    updateItem(itemIndex, quantity) {
        const cartItem = this.querySelector(`#CartItem-${itemIndex}`);
        const checkoutButtonElement = this.element.querySelector("[data-cart-checkout-button]");
        if (!cartItem || !checkoutButtonElement) return;
        const config = this._getQueryConfig(itemIndex, quantity);
        const checkoutButton = new (0, $39569d312fa19772$export$2e2bcd8739ae039)(checkoutButtonElement);
        const newQuantity = +quantity;
        const currentQuantity = +(cartItem.dataset.quantity || 0);
        if (currentQuantity === newQuantity) {
            cartItem.setLoading(false);
            return;
        }
        checkoutButton.setLoading(true);
        checkoutButton.setDisable(true);
        cartItem.setQuantityDisabled(true);
        if (newQuantity === 0) {
            this.updateEmptyStatus(this._cartItemCount === 1);
            cartItem.removeFromCart();
        }
        this._cartApi.change(config).then((state)=>{
            const parsedState = JSON.parse(state);
            checkoutButton.setLoading(false);
            checkoutButton.setDisable(false);
            cartItem.setLoading(false);
            cartItem.setQuantityDisabled(false);
            this.updateByParsedState(parsedState);
        }).catch(()=>{
            this._showError();
        });
    }
    _handleContentResultsResize = ()=>{
        this.updateViewport();
    };
    updateViewport() {
        const isContentOverflow = this.checkContentOverflow();
        this.toggleAttribute("footer-shadow-visible", isContentOverflow);
    }
    checkContentOverflow() {
        if (!this.results || !this.viewport) return false;
        return this.results.offsetHeight > this.viewport.offsetHeight;
    }
    _showError() {
        const notificationElement = this.querySelector("#SidebarCartNotification");
        if (notificationElement) {
            const notification = new (0, $9851c588d75ce610$export$2e2bcd8739ae039)(notificationElement);
            const { cartStrings: cartStrings  } = window;
            notification.show(cartStrings.error, "warning");
        }
    }
    updateByParsedState(parsedState) {
        const html = (0, $e6a5d8115fb64fe3$export$8a49393be2d55148)(parsedState.sections[this.sectionId]);
        const newTemplate = html.querySelector("#CartInSidebar");
        const node = (0, $e6a5d8115fb64fe3$export$8ea4fc17cec6f158)(newTemplate);
        const customElementContainer = (0, $eceaf86a082c33f7$export$402b71a6ab88771a)(node);
        this.mount();
        this.updateHeaderFromNode(node);
        this.updateFreeShippingBarFromNode(node);
        this.updateCartItemsFromNode(node);
        this.updateFooterFromNode(node);
        this._updateCartCountInHeader(parsedState);
        (0, $eceaf86a082c33f7$export$6b8b061b59c6fc66)(customElementContainer);
    }
    updateCartDrawer(parsedState) {
        const html = (0, $e6a5d8115fb64fe3$export$8a49393be2d55148)(parsedState.sections[this.sectionId]);
        const newTemplate = html.querySelector("#CartInSidebar");
        const node = (0, $e6a5d8115fb64fe3$export$8ea4fc17cec6f158)(newTemplate);
        const customElementContainer = (0, $eceaf86a082c33f7$export$402b71a6ab88771a)(node);
        this.mount();
        this.updateEmptyStatus(false);
        this.updateHeaderFromNode(node);
        this.updateFreeShippingBarFromNode(node);
        this.updateCartItemsFromNode(node);
        this.updateFooterFromNode(node);
        this._updateCartCountInHeader(parsedState);
        (0, $eceaf86a082c33f7$export$6b8b061b59c6fc66)(customElementContainer);       
        this.button = document.querySelector('[data-sidebar-id="sidebar-component-for-cart"]');
        const sidebarId = this.button.dataset.sidebarId || "";
        const sidebar = document.querySelector(`#${sidebarId}`);
        if (this.button) {
            if (sidebar) {
                sidebar.toggle();
                if (sidebar) this.button.setAttribute("data-aria-expanded", sidebar.isOpen ? "true" : "false");
            }
        }
    }
    purchaseHandler(parsedState) {
        const html = (0, $e6a5d8115fb64fe3$export$8a49393be2d55148)(parsedState.sections[this.sectionId]);
        const newTemplate = html.querySelector("#CartInSidebar");
        const node = (0, $e6a5d8115fb64fe3$export$8ea4fc17cec6f158)(newTemplate);
        const customElementContainer = (0, $eceaf86a082c33f7$export$402b71a6ab88771a)(node);
        this.mount();
        this.updateHeaderFromNode(node);
        this.updateCartItemsFromNode(node);
        this.updateFooterFromNode(node);
        this._updateCartCountInHeader(parsedState);
        (0, $eceaf86a082c33f7$export$6b8b061b59c6fc66)(customElementContainer);
        const cartItem = this.element.querySelector(`cart-item[data-variant-id="${parsedState.id}"]`);
        if (!cartItem) return;
        if (parsedState.quantity === 1) cartItem.collapse().then(()=>this.open()).then(()=>cartItem.expand()).then(()=>{
            this.updateFreeShippingBarFromNode(node);
            cartItem.showCheckmark();
        });
        else this.open().then(()=>{
            this.updateFreeShippingBarFromNode(node);
            cartItem.showCheckmark();
        });
    }
    updateHeaderFromNode(node) {
        this.updateElementBySelectorFromNode("[data-sidebar-cart-header]", node);
    }
    updateEmptyStatus(isEmpty) {
        this.toggleAttribute("is-empty", isEmpty);
    }
    updateFooterFromNode(node) {
        this.updateElementBySelectorFromNode("[data-sidebar-cart-footer]", node);
    }
    updateCartItemsFromNode(node) {
        this.updateElementBySelectorFromNode("[data-sidebar-cart-items]", node);
    }
    updateFreeShippingBarFromNode(node) {
        const selector = "[data-sidebar-cart-free-shipping-bar] cart-free-shipping-bar";
        const bar = this.element.querySelector(selector);
        const newBar = node.querySelector(selector);
        if (bar && newBar) {
            const cartTotal = newBar.dataset.cartTotal || 0;
            bar.updateProgressByCartTotal(+cartTotal);
        }
    }
    updateElementBySelectorFromNode(selector, node) {
        const newElement = node.querySelector(selector);
        const element = this.element.querySelector(selector);
        if (element && newElement) element.innerHTML = newElement.innerHTML;
    }
    _updateCartCountInHeader(parsedState) {
        const html = (0, $e6a5d8115fb64fe3$export$8a49393be2d55148)(parsedState.sections["cart-count"]);
        const count = document.getElementById("CartCount");
        const stickyCount = document.getElementById("StickyCartCount");
        const newCount = html.querySelector("#CartCount");
        if (stickyCount && newCount) stickyCount.innerHTML = newCount.innerHTML;
        if (count && newCount) count.innerHTML = newCount.innerHTML;
    }
    _getQueryConfig(itemIndex, quantity) {
        return {
            ...(0, $0cd7bcc90e4d304e$export$1811237fdf5ac5d)(),
            body: JSON.stringify({
                line: itemIndex + 1,
                quantity: quantity,
                sections: this._sections,
                sections_url: window.location.pathname
            })
        };
    }
    get _cartItemCount() {
        const cartItems = this.element.querySelectorAll("cart-item");
        return cartItems.length;
    }
}
var $0e7c3d37876a0df5$export$2e2bcd8739ae039 = $0e7c3d37876a0df5$var$SidebarCart;



const { Shopify: $dccc758ca64395c2$var$Shopify  } = window;
class $dccc758ca64395c2$var$CartFreeShippingBar extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.messageNodeSelector = "[data-cart-free-shipping-bar-message]";
    }
    connectedCallback() {
        const cartTotal = this.dataset.cartTotal || 0;
        this.updateProgressByCartTotal(+cartTotal);
    }
    updateProgressByCartTotal(cartTotal) {
        const currencyFormat = this.dataset.currencyFormat || "";
        const threshold = +(this.dataset.threshold || 0);
        const currencyRate = +$dccc758ca64395c2$var$Shopify.currency.rate;
        const progressMessage = this.dataset.progressMessage || "";
        const achievedMessage = this.dataset.achievedMessage || "";
        const thresholdInStoreCurrency = threshold * currencyRate;
        const valueLeft = +(thresholdInStoreCurrency - cartTotal).toFixed(2);
        const moneyPerPercent = thresholdInStoreCurrency / 100;
        if (valueLeft > 0) {
            const preparedValueLeft = currencyFormat.replace(/{{.+?}}/g, `${valueLeft}`);
            this.setMessage(progressMessage.replace("[value]", preparedValueLeft));
            this.setProgress(cartTotal / moneyPerPercent);
        } else {
            this.setMessage(achievedMessage);
            this.setProgress(100);
        }
    }
    setProgress = (value)=>{
        this.style.setProperty(`--gsc-free-shipping-progress`, `${value}%`);
    };
    setMessage = (message)=>{
        const messageNode = this.querySelector(this.messageNodeSelector);
        if (messageNode) messageNode.innerHTML = message;
    };
}
var $dccc758ca64395c2$export$2e2bcd8739ae039 = $dccc758ca64395c2$var$CartFreeShippingBar;



class $1a08cd2f8a220c49$var$ProductMedia extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.setReady();
    }
    updateFirstMediaByVariant(variant, isForceAnimation = false) {
        if (variant && variant.featured_media) {
            const media = this.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
            if (media) media.scrollIntoView({
                behavior: isForceAnimation ? "auto" : "smooth"
            });
        }
    }
    setReady() {
        this.setAttribute("ready", "");
    }
}
var $1a08cd2f8a220c49$export$2e2bcd8739ae039 = $1a08cd2f8a220c49$var$ProductMedia;



class $12601885a80a3c0b$var$ProductMediaCarousel extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.carouselSelector = `[data-product-media-carousel-component]`;
    }
    connectedCallback() {
        this.setReady();
    }
    updateFirstMediaByVariant(variant, isForceAnimation = false) {
        const carousel = this.querySelector(this.carouselSelector);
        if (variant && variant.featured_media && carousel) {
            const slides = carousel.embla.slideNodes();
            const targetIndex = slides.findIndex((slide)=>{
                if (!slide.dataset.mediaId) return false;
                return +slide.dataset.mediaId === +variant.featured_media.id;
            });
            carousel.embla.scrollTo(targetIndex, isForceAnimation);
        }
    }
    setReady() {
        this.setAttribute("ready", "");
    }
}
var $12601885a80a3c0b$export$2e2bcd8739ae039 = $12601885a80a3c0b$var$ProductMediaCarousel;






class $fa06fe8830349112$var$VariantPicker extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._pickupAvailability = document.getElementById(`product-pickup-availability-${this.dataset.productId}-${this.dataset.section}`);
        this._elements = [
            "sticky-product-buy-btn",
            "product-buy-btn",
            "product-quantity"
        ];
    }
    connectedCallback() {
        this._updateVariant();
        setTimeout(()=>{
            this._updateOptionsAvailable();
            this.setFocusListeners();
        }, 100);
        if (this.dataset.selectedVariantId) this._updateFirstMediaByVariant(this.variant, true);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "change", this._handleVariantChange);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "change", this._handleVariantChange);
    }
    _handleVariantChange = ()=>{
        this._updateForm();
        this._setInventoryStatusAvailable(this.variant);
        if (!this.variant) {
            this._setButtonsUnavailable();
            return;
        }
        this._form.setDisable(true);
        this._form.setLoading(true);
        if (this._pickupAvailability) this._updatePickupAvailability();
        this._updateURL();
        this._updateVariantInput();
        this._updateProduct();
        this._updateFirstMediaByVariant(this.variant);
    };
    _updateLabels() {
        const inputContainers = this.querySelectorAll("[data-variant-picker-option-inputs]");
        const labelContainers = this.querySelectorAll("[data-variant-picker-option-labels]");
        inputContainers.forEach((inputContainer, idx)=>{
            const labels = [
                ...labelContainers[idx].querySelectorAll("label")
            ];
            const inputs = [
                ...inputContainer.querySelectorAll("input")
            ];
            const checkedInput = this.getCheckedInput(inputs);
            const dropdownLabel = labelContainers[idx].querySelector("[data-dropdown-variant-picker-label]");
            labels.forEach((label)=>{
                const isMatched = label.getAttribute("for") === checkedInput.id;
                if (dropdownLabel && isMatched) {
                    const dropdown = dropdownLabel.closest("dropdown-opener");
                    dropdownLabel.innerHTML = label.innerHTML;
                    dropdown.trigger();
                }
                label.classList.toggle("selected", isMatched);
            });
        });
    }
    _setInventoryStatusAvailable(isAvailable) {
        const productStockInner = document.getElementById(`product-stock-inner-${this.dataset.productId}-${this.dataset.section}`);
        if (productStockInner) productStockInner.classList.toggle("hidden", !isAvailable);
    }
    _setButtonsUnavailable() {
        this._form.setDisable(true);
        this._form.setText(window.variantStrings.unavailable);
    }
    _updateVariant() {
        const options = this.querySelectorAll("[data-variant-picker-option-inputs]");
        const variants = this._getVariants();
        const selectedOptions = [
            ...options
        ].map((option)=>{
            const inputs = [
                ...option.querySelectorAll("input")
            ];
            const found = this.getCheckedInput(inputs);
            return found.value;
        });
        this.variant = variants.find(({ options: options  })=>{
            return !options.map((option, index)=>selectedOptions[index] === option).includes(false);
        });
    }
    setFocusListeners() {
        if (this.dataset.type === "dropdown") {
            const labels = [
                ...this.querySelectorAll("float-element")
            ].map((dropdown)=>{
                return [
                    ...dropdown.element.querySelectorAll("label")
                ];
            }).reduce((acc, labels)=>[
                    ...acc,
                    ...labels
                ], []);
            this.setListenersForLabels(labels);
        } else {
            const labels = [
                ...this.querySelectorAll("label")
            ];
            this.setListenersForLabels(labels);
        }
    }
    _handleLabelFocus = (e)=>{
        const inputId = e.target.getAttribute("for");
        const input = this.querySelector(`input[id="${inputId}"]`);
        input.dispatchEvent(new MouseEvent("click", {
            button: 0,
            which: 1
        }));
        document.addEventListener("keydown", this._handleLabelKeydown);
    };
    setListenersForLabels(labels) {
        labels.forEach((label)=>{
            label.addEventListener("focus", this._handleLabelFocus);
        });
    }
    removeListenersForLabels(labels) {
        labels.forEach((label)=>{
            label.addEventListener("focus", this._handleLabelFocus);
        });
    }
    _handleLabelKeydown = (e)=>{
        const labelContainer = e.target.closest("[data-variant-picker-option-labels]");
        const isArrowKey = e.key === "ArrowLeft" || e.key === "ArrowRight" || e.key === "ArrowUp" || e.key === "ArrowDown";
        if (!isArrowKey) return;
        if (!labelContainer) {
            document.removeEventListener("keydown", this._handleLabelKeydown);
            return;
        }
        const labels = [
            ...labelContainer.querySelectorAll("label")
        ];
        const index = labels.findIndex((label)=>label === e.target);
        const currentLabel = labels[index];
        const firstLabel = labels[0];
        const lastLabel = labels[labels.length - 1];
        const nextLabel = labels[index + 1];
        const prevLabel = labels[index - 1];
        if (labels.length !== 1) e.preventDefault();
        const setActiveLabel = (newLabel)=>{
            currentLabel.removeAttribute("tabindex");
            newLabel.setAttribute("tabindex", 0);
            newLabel.focus();
        };
        const changeActiveLabelOnNext = ()=>{
            const label = nextLabel || firstLabel;
            setActiveLabel(label);
        };
        const changeActiveLabelOnPrev = ()=>{
            const label = prevLabel || lastLabel;
            setActiveLabel(label);
        };
        const callback = {
            ArrowLeft: changeActiveLabelOnPrev,
            ArrowRight: changeActiveLabelOnNext,
            ArrowUp: changeActiveLabelOnPrev,
            ArrowDown: changeActiveLabelOnNext
        }[e.key];
        callback();
    };
    _updateOptionsAvailable() {
        const options = this.querySelectorAll("[data-variant-picker-option-inputs]");
        const getOptionsByIndex = (index)=>{
            return options[index] ? [
                ...options[index].querySelectorAll("input")
            ] : null;
        };
        const firstOptions = getOptionsByIndex(0);
        const secondOptions = getOptionsByIndex(1);
        const thirdOptions = getOptionsByIndex(2);
        const variants = this._getVariants();
        const getVariantsByOption = (...prevOptions)=>{
            return variants.reduce((result, variant)=>{
                const isIncludePrevOptions = prevOptions ? prevOptions.every((prevOption)=>variant.options.includes(prevOption.value)) : true;
                return variant.available && isIncludePrevOptions ? [
                    ...result,
                    variant.options
                ] : result;
            }, []);
        };
        const getDropdownElementBySelector = (selector)=>{
            return [
                ...this.querySelectorAll("float-element")
            ].find((dropdown)=>{
                return dropdown.element.querySelector(selector);
            }).element.querySelector(selector);
        };
        const setOptions = (options, possibleVariants)=>{
            for (const option of options){
                const value = option.value;
                let available = false;
                possibleVariants.forEach((possibleVariant)=>{
                    if (possibleVariant.includes(value)) available = true;
                });
                const labelSelector = `label[for="${option.id}"]`;
                const hasLabel = this.querySelector(labelSelector);
                const label = hasLabel ? this.querySelector(labelSelector) : getDropdownElementBySelector(labelSelector);
                label.toggleAttribute("no-available", !available);
            }
        };
        setOptions(firstOptions, getVariantsByOption());
        if (secondOptions) {
            const firstSelectedOption = this.getCheckedInput(firstOptions);
            setOptions(secondOptions, getVariantsByOption(firstSelectedOption));
        }
        if (thirdOptions) {
            const firstSelectedOption = this.getCheckedInput(firstOptions);
            const secondSelectedOption = this.getCheckedInput(secondOptions);
            setOptions(thirdOptions, getVariantsByOption(firstSelectedOption, secondSelectedOption));
        }
    }
    _getVariants() {
        const variantsJSON = this.querySelector("[data-variant-picker-variants]");
        const variants = JSON.parse(variantsJSON.textContent);
        return variants;
    }
    _updateFirstMediaByVariant(variant, isForceAnimation) {
        const mediaList = document.querySelectorAll(`#product-media-${this.dataset.productId}-${this.dataset.section}`);
        mediaList.forEach((media)=>media.updateFirstMediaByVariant(variant, isForceAnimation));
    }
    _updateForm() {
        this._updateLabels();
        this._updateVariant();
        this._updateOptionsAvailable();
    }
    _updateURL() {
        if (this.variant && this.dataset.updateUrl === "true") {
            const url = `${this.dataset.url}?variant=${this.variant.id}`;
            window.history.replaceState({}, "", url);
        }
    }
    _updateVariantInput() {
        const input = this._form.variantInput;
        input.value = this.variant.id;
        input.dispatchEvent(new Event("change", {
            bubbles: true
        }));
    }
    _updatePickupAvailability() {
        this._pickupAvailability.updateVariantId(this.variant.id);
        this._pickupAvailability.fetchAvailability();
    }
    _updateProduct() {
        const queryUrl = `${this.dataset.url}?variant=${this.variant.id}&section_id=${this.dataset.sectionIdWithoutPrefix}`;
        this._updateBlocksByVariantId(this.variant.id);
        fetch(queryUrl).then((response)=>response.text()).then((responseText)=>{
            const html = (0, $e6a5d8115fb64fe3$export$8a49393be2d55148)(responseText);
            const isAvailable = this.variant.available;
            this._form.setDisable(!isAvailable);
            this._form.setLoading(false);
            this._updateElements(html);
        }).catch(()=>{
            if (!(0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification) return;
            (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification.show("Error in variant picker component", "warning");
        });
    }
    _updateElements(html) {
        this._elements.forEach((block)=>{
            const id = `${block}-${this.dataset.productId}-${this.dataset.section}`;
            const target = document.getElementById(id);
            if (target) target.innerHTML = html.getElementById(id).innerHTML;
        });
    }
    _updateBlocksByVariantId(variantId) {
        const blocks = [
            "product-price",
            "product-sku",
            "product-stock"
        ];
        blocks.forEach((block)=>{
            const target = document.getElementById(`${block}-${this.dataset.productId}-${this.dataset.section}`);
            if (target) target.updateByVariantId(variantId);
        });
    }
    getCheckedInput(inputs) {
        return inputs.find(({ checked: checked  })=>checked);
    }
    get _form() {
        return document.getElementById(`product-form-component-${this.dataset.productId}-${this.dataset.section}`);
    }
}
var $fa06fe8830349112$export$2e2bcd8739ae039 = $fa06fe8830349112$var$VariantPicker;



class $c54f7118f91dafe6$var$ColorSwatchesPicker extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.activeValueSelector = "[data-color-swatches-picker-active-value]";
        this.activeValue = this.querySelector(this.activeValueSelector);
        this.labelSelector = "[data-color-swatches-picker-label]";
        this.labels = [
            ...this.querySelectorAll(this.labelSelector)
        ];
    }
    connectedCallback() {
        this.addEventListener("click", this._handleClick);
        this.labels.forEach((label)=>{
            label.addEventListener("mouseenter", this._handleMouseEnter);
            label.addEventListener("mouseleave", this._handleMouseLeave);
        });
    }
    disconnectedCallback() {
        this.removeEventListener("click", this._handleClick);
        this.labels.forEach((label)=>{
            label.removeEventListener("mouseenter", this._handleMouseEnter);
            label.removeEventListener("mouseleave", this._handleMouseLeave);
        });
    }
    _handleClick = ()=>{
        this.updateSelected();
    };
    _handleMouseEnter = (event)=>{
        this.updateActiveValue(event.target.dataset.value);
    };
    _handleMouseLeave = ()=>{
        this.updateSelected();
    };
    updateSelected() {
        const selectedLabel = this.querySelector(`${this.labelSelector}.selected`);
        if (selectedLabel) {
            const value = selectedLabel.getAttribute("data-value") || "";
            this.updateActiveValue(value);
        }
    }
    updateActiveValue(value) {
        if (this.activeValue) this.activeValue.innerHTML = value;
    }
}
var $c54f7118f91dafe6$export$2e2bcd8739ae039 = $c54f7118f91dafe6$var$ColorSwatchesPicker;





class $57f3cd3e7e93b527$var$ProductModal extends (0, $ec846921809d9add$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.selectors = {
            carousel: `[data-product-modal-carousel]`,
            carouselButtons: `[data-product-modal-carousel-button]`,
            carouselSlide: `[data-product-modal-slide]`,
            carouselSelectedSlideNumber: `[data-product-modal-selected-slide-number]`,
            carouselSlideNumber: `[data-product-modal-slide-number]`,
            zoomCursor: `zoom-cursor`
        };
        if (this.element) {
            this.carousel = this.element.querySelector(this.selectors.carousel);
            this._slides = [
                ...this.element.querySelectorAll(this.selectors.carouselSlide)
            ];
            this._selectedSlideNumber = this.element.querySelector(this.selectors.carouselSelectedSlideNumber);
            this._slideNumber = this.element.querySelector(this.selectors.carouselSlideNumber);
        }
        this._zoomCursor = document.querySelector(this.selectors.zoomCursor);
        this.mediaIndexMap = this._createMediaIndexMap();
        this.isZoomed = false;
    }
    _handleKeydown = (e)=>{
        const key = e.key || e.keyCode;
        const isEscape = key === (0, $0f1057c27003f13c$export$3f0d637ce77a8721).ESCAPE_STRING_KEY || key === (0, $0f1057c27003f13c$export$3f0d637ce77a8721).ESCAPE_NUMBER_KEY;
        if (isEscape) this.isZoomed ? this.zoomedImage.reset() : this.hide();
    };
    _handleCarouselInit = ()=>{
        this._updateCarouselDraggableState();
    };
    _handleCarouselSelect = ()=>{
        this.updateSelectedSlideNumber();
    };
    openAndShowMediaById(mediaId) {
        this.show();
        if (!this.carousel) return;
        const mediaIndex = this.mediaIndexMap[mediaId];
        this.carousel.embla.scrollTo(mediaIndex, true);
        this.updateSelectedSlideNumber();
    }
    _initCarousel() {
        if (!this.carousel) return;
        this.carousel.setFocus();
        this.carousel.embla.on("select", this._handleCarouselSelect);
        this.carousel.embla.on("init", this._handleCarouselInit);
    }
    _resetCarousel() {
        if (!this.carousel) return;
        this.carousel.removeFocus();
        this.carousel.embla.off("select", this._handleCarouselSelect);
        this.carousel.embla.off("init", this._handleCarouselInit);
    }
    hide() {
        this._resetCarousel();
        super.hide();
        this.isZoomed = false;
        this.updateModal();
        this.emit("hide", {});
    }
    show() {
        super.show();
        this._initCarousel();
    }
    updateSelectedSlideNumber() {
        if (!this._selectedSlideNumber || !this.carousel) return;
        const selectedIndex = this.carousel.embla.selectedScrollSnap();
        const newSlideNumber = selectedIndex + 1;
        this._selectedSlideNumber.innerHTML = `${newSlideNumber}`;
    }
    updateModal() {
        this._updateCarouselDraggableState();
        this._updateZoomCursorState();
        this._updateZoomState();
    }
    _createMediaIndexMap() {
        return this._slides.reduce((acc, slide, index)=>{
            if (!slide.dataset.mediaId) return acc;
            return {
                ...acc,
                [slide.dataset.mediaId]: index
            };
        }, {});
    }
    _updateCarouselDraggableState() {
        if (!this.carousel) return;
        const isMobile = (0, $5d3d77426481432d$export$e7a5aad9bb00dd62)();
        if (!isMobile) {
            this.carousel.reInit({
                draggable: false
            });
            return;
        }
        this.carousel.reInit({
            draggable: !this.isZoomed
        });
    }
    _updateZoomCursorState() {
        if (!this._zoomCursor) return;
        this._zoomCursor.updateState(this.isZoomed);
    }
    _updateZoomState() {
        this.toggleAttribute("zoom-enabled", this.isZoomed);
    }
}
var $57f3cd3e7e93b527$export$2e2bcd8739ae039 = $57f3cd3e7e93b527$var$ProductModal;




class $ca49e36245c31056$var$ProductModalImageWrap extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._image = this.querySelector("img");
        this._modal = this.closest("product-modal");
        this._carousel = this._modal.carousel;
        this._preloader = this.querySelector("[data-product-modal-image-preloader]");
        this._currentScale = 1;
        this._isDragging = false;
        this._offsetX = 0;
        this._offsetY = 0;
        this._startDragPoint = {
            x: 0,
            y: 0
        };
        this._maxScale = 3;
        this._minScale = 1;
        this._isTapped = false;
        this._tapTimeout = 300;
        this._lastGesture = null;
        this.setZoomCursorVisible(true);
    }
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$b9291b92670abfe3).observe(this._preloader);
        this._image.addEventListener("mousedown", this._handleMouseDown);
        this._image.addEventListener("mouseup", this._handleMouseUp);
        this._image.addEventListener("mousemove", this._handleMouseMove);
        this._image.addEventListener("touchstart", this._handleTouchStart);
        this._image.addEventListener("touchend", this._handleTouchEnd);
        this._image.addEventListener("touchmove", this._handleTouchMove);
        this._image.addEventListener("load", this._handleImageLoad);
        customElements.upgrade(this._modal) // https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/upgrade
        ;
        this._modal.subscribe("hide", this._handleModalHide);
        this._carousel.embla.on("select", this._handleCarouselSelect);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$b9291b92670abfe3).unobserve(this._preloader);
        this._image.removeEventListener("mousedown", this._handleMouseDown);
        this._image.removeEventListener("mouseup", this._handleMouseUp);
        this._image.removeEventListener("mousemove", this._handleMouseMove);
        this._image.removeEventListener("touchstart", this._handleTouchStart);
        this._image.removeEventListener("touchend", this._handleTouchEnd);
        this._image.removeEventListener("touchmove", this._handleTouchMove);
        this._image.removeEventListener("load", this._handleImageLoad);
        this._modal.unsubscribe("hide", this._handleModalHide);
        this._carousel.embla.off("select", this._handleCarouselSelect);
    }
    _handleImageLoad = ()=>{
        this.setPreloaderVisible(false);
    };
    _handleModalHide = ()=>{
        this.reset();
    };
    _handleCarouselSelect = ()=>{
        this.reset();
    };
    _handleTouchStart = (event)=>{
        event.preventDefault();
        this.fingers = event.touches.length;
        this.firstMove = true;
        this.detectDoubleTap(event);
    };
    _handleTouchMove = (event)=>{
        event.preventDefault();
        if (!this._isDoubleTapped) {
            if (this.firstMove) {
                this.updateGesture(event);
                this.startMoveTouches = event.touches.length;
            } else if (this._lastGesture) switch(this._lastGesture){
                case "zoom":
                    if (this.startMoveTouches === 2 && event.touches.length === 2) this.pinch(event);
                    break;
                case "drag":
                    if (this.startMoveTouches === 1 && event.touches.length === 1) {
                        const { clientX: clientX , clientY: clientY  } = event.targetTouches[0];
                        this.drag(clientX, clientY);
                    }
                    break;
            }
            else this.setGesture("none", event);
            this.firstMove = false;
        }
    };
    _handleTouchEnd = (event)=>{
        event.preventDefault();
        this.fingers = event.touches.length;
        this.updateGesture(event);
    };
    _handleMouseDown = (event)=>{
        event.preventDefault();
        this.startDrag(event.clientX, event.clientY);
        this.setDragging(true);
    };
    _handleMouseUp = (event)=>{
        this.setDragging(false);
        const time = this._modal.isZoomed ? 75 : 0;
        this.zoomTimeoutId = setTimeout(()=>{
            this.touchZoom(event.clientX, event.clientY);
        }, time);
    };
    _handleMouseMove = (event)=>{
        event.preventDefault();
        clearTimeout(this.zoomTimeoutId);
        if (this._isDragging && this._modal.isZoomed) {
            const { clientX: clientX , clientY: clientY  } = event;
            this.drag(clientX, clientY);
        }
    };
    detectDoubleTap(event) {
        if (this._isTappedTimeout && this.fingers === 1) {
            clearTimeout(this._isTappedTimeout);
            this._isTappedTimeout = null;
            this._isDoubleTapped = true;
            this.touchZoom(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
            switch(this._lastGesture){
                case "zoom":
                    this.setPinchScaling(false);
                    break;
                case "drag":
                    this.setDragging(false);
                    break;
            }
        } else this._isTappedTimeout = setTimeout(()=>{
            this._isTappedTimeout = null;
            this._isDoubleTapped = false;
        }, this._tapTimeout);
    }
    updateGesture(event) {
        if (this.fingers === 2) this.setGesture("zoom");
        else if (this.fingers === 1) this.setGesture("drag", event);
        else this.setGesture("none", event);
    }
    setGesture(newGesture, event) {
        if (this._lastGesture !== newGesture) {
            if (this._lastGesture && !newGesture) switch(this._lastGesture){
                case "zoom":
                    this.setPinchScaling(false);
                    break;
                case "drag":
                    this.setDragging(false);
                    break;
            }
            switch(newGesture){
                case "zoom":
                    this.setPinchScaling(true);
                    break;
                case "drag":
                    this.startDrag(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
                    this.setDragging(true);
                    break;
                case "none":
                    this.setDragging(false);
                    this.setPinchScaling(false);
                    break;
            }
        }
        this._lastGesture = newGesture;
    }
    pinch(event) {
        const distanceBetweenTouches = this.getDistanceBetweenTouches(event);
        const isZoomIn = distanceBetweenTouches > this.lastDistanceBetweenTouches;
        const factor = isZoomIn ? 0.125 : -0.125;
        const newScale = this.getNewScale(this.currentScale + factor);
        const midPoint = this.getTouchCenter(event);
        const xs = (midPoint.x - this._offsetX) / this.currentScale;
        const ys = (midPoint.y - this._offsetY) / this.currentScale;
        this.lastDistanceBetweenTouches = distanceBetweenTouches;
        if (!isZoomIn && newScale === 1) {
            this.reset();
            return;
        }
        this.setTransform({
            scale: newScale,
            offsetX: midPoint.x - xs * newScale,
            offsetY: midPoint.y - ys * newScale
        });
    }
    getDistanceBetweenTouches(event) {
        return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
    }
    startDrag(clientX, clientY) {
        this._startDragPoint = {
            x: clientX - this._offsetX,
            y: clientY - this._offsetY
        };
        this.dragStartPointX = clientX;
        this.dragStartPointY = clientY;
    }
    drag(clientX, clientY) {
        const isRightDrag = this.dragStartPointX > clientX;
        const isBottomDrag = this.dragStartPointY > clientY;
        const newScale = this.getNewScale(this.currentScale);
        let newOffsetX = clientX - this._startDragPoint.x;
        let newOffsetY = clientY - this._startDragPoint.y;
        const isIntersectBounds = this.getIntersectBounds({
            isRightDrag: isRightDrag,
            isBottomDrag: isBottomDrag
        });
        if (isIntersectBounds.right || isIntersectBounds.left) newOffsetX = this._offsetX;
        if (isIntersectBounds.bottom || isIntersectBounds.top) newOffsetY = this._offsetY;
        this.setTransform({
            scale: newScale,
            offsetX: newOffsetX,
            offsetY: newOffsetY
        });
    }
    getIntersectBounds({ isRightDrag: isRightDrag , isBottomDrag: isBottomDrag  }) {
        const imageRect = this._image.getBoundingClientRect();
        const delta = 8;
        const deltaX = isRightDrag ? -1 * delta : delta;
        const deltaY = isBottomDrag ? -1 * delta : delta;
        const right = isRightDrag && imageRect.right + deltaX < window.innerWidth;
        const left = !isRightDrag && imageRect.left + deltaX > 0;
        const bottom = isBottomDrag && imageRect.bottom + deltaY < window.innerHeight;
        const top = !isBottomDrag && imageRect.top + deltaY > 0;
        return {
            right: right,
            left: left,
            bottom: bottom,
            top: top
        };
    }
    getTouchCenter(event) {
        const sum = (a, b)=>a + b;
        const touches = [
            ...event.touches
        ];
        const touchCount = touches.length;
        return {
            x: touches.map((touch)=>touch.pageX).reduce(sum) / touchCount,
            y: touches.map((touch)=>touch.pageY).reduce(sum) / touchCount
        };
    }
    setTransform({ offsetX: offsetX , offsetY: offsetY , scale: scale  }) {
        this.style.transform = `translate3d(${offsetX}px, ${offsetY}px, 0) scale3d(${scale}, ${scale}, 1)`;
        this._offsetX = offsetX;
        this._offsetY = offsetY;
        this.currentScale = scale;
    }
    touchZoom(clientX, clientY) {
        const xs = (clientX - this._offsetX) / this.currentScale;
        const ys = (clientY - this._offsetY) / this.currentScale;
        let newScale;
        let newOffsetX;
        let newOffsetY;
        if (this._modal.isZoomed) {
            newScale = this.getNewScale(1);
            newOffsetX = 0;
            newOffsetY = 0;
        } else {
            newScale = this.getNewScale(3);
            newOffsetX = clientX - xs * newScale;
            newOffsetY = clientY - ys * newScale;
        }
        this.style.cursor = this._modal.isZoomed ? "" : "grab";
        this.setZoomCursorVisible(this._modal.isZoomed);
        this.setTransform({
            scale: newScale,
            offsetX: newOffsetX,
            offsetY: newOffsetY
        });
    }
    reset() {
        this.setTransform({
            scale: 1,
            offsetX: 0,
            offsetY: 0
        });
    }
    getNewScale(newScale) {
        return Math.max(this._minScale, Math.min(this._maxScale, newScale));
    }
    setPinchScaling(isPinchScaling) {
        this.toggleAttribute("is-pinch-scaling", isPinchScaling);
        this._isPinchScaling = isPinchScaling;
    }
    setDragging(isDragging) {
        this.toggleAttribute("is-dragging", isDragging);
        this._isDragging = isDragging;
    }
    setZoomCursorVisible(isVisible) {
        this._image.toggleAttribute("data-zoom-cursor-target", isVisible);
    }
    setModalZoom(isZoomed) {
        this._modal.isZoomed = isZoomed;
        if (this._modal.isZoomed) this._modal.zoomedImage = this;
        this._modal.updateModal();
    }
    setPreloaderVisible(isVisible) {
        this._preloader.classList.toggle("hidden", !isVisible);
        this._image.toggleAttribute("is-loaded", !isVisible);
    }
    set currentScale(value) {
        if (this._currentScale !== value) {
            this.setModalZoom(value > 1);
            this._currentScale = value;
        }
    }
    get currentScale() {
        return this._currentScale;
    }
}
var $ca49e36245c31056$export$2e2bcd8739ae039 = $ca49e36245c31056$var$ProductModalImageWrap;



class $5b5aa89713cb7074$var$ProductModalOpener extends (0, $baa3d328c6b64361$export$2e2bcd8739ae039) {
    showModal() {
        if (!this.dataset.modal) return;
        const modal = document.querySelector(this.dataset.modal);
        if (!modal) return;
        modal.openAndShowMediaById(this.dataset.mediaId);
    }
}
var $5b5aa89713cb7074$export$2e2bcd8739ae039 = $5b5aa89713cb7074$var$ProductModalOpener;





class $8fc4aeb5718116b8$var$ProductRecommendations extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._intersectionObserver = new IntersectionObserver(this._handleIntersectionObserve, {
            rootMargin: "0px 0px 200px 0px"
        });
    }
    connectedCallback() {
        this._intersectionObserver.observe(this);
    }
    disconnectedCallback() {
        this._intersectionObserver.disconnect();
    }
    _handleIntersectionObserve = (entries, observer)=>{
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        const url = this.dataset.url;
        if (url) fetch(url).then((response)=>response.text()).then((text)=>{
            const html = (0, $e6a5d8115fb64fe3$export$8a49393be2d55148)(text);
            this._updateByHTML(html);
        }).catch(()=>{
            if (!(0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification) return;
            (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification.show("Error in product recommendations component", "warning");
        });
    };
    _updateByHTML(html) {
        const recommendations = html.querySelector("product-recommendations");
        if (recommendations) this.innerHTML = recommendations.innerHTML;
    }
}
var $8fc4aeb5718116b8$export$2e2bcd8739ae039 = $8fc4aeb5718116b8$var$ProductRecommendations;




const { routes: $2a1afe451ee81b88$var$routes  } = window;
class $2a1afe451ee81b88$var$PredictiveSearchAPI {
    get(params) {
        const query = this._prepareQuery(params);
        return fetch(query).then((response)=>response.text());
    }
    _prepareQuery(params) {
        const { searchQuery: searchQuery , sectionId: sectionId  } = params;
        const baseUrl = $2a1afe451ee81b88$var$routes.predictive_search_url;
        const limitParam = "resources[limit]=999";
        const sectionParam = `section_id=${sectionId}`;
        return `${baseUrl}?q=${searchQuery}&${limitParam}&${sectionParam}`;
    }
}
var $2a1afe451ee81b88$export$2e2bcd8739ae039 = $2a1afe451ee81b88$var$PredictiveSearchAPI;





class $56b1f5edcb7cb412$var$SearchSidebarFormWrapper extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._cache = {};
        this.sidebar = this.closest("#SearchSidebar");
        this.inputComponentSelector = `[data-sidebar-search-input-component]`;
        this.contentResults = `[data-sidebar-search-content-results]`;
        this.footerSelector = `[data-sidebar-search-footer]`;
        this.itemSelector = `[data-sidebar-search-item]`;
        if (this.sidebar) this._results = this.sidebar.element.querySelector(this.contentResults);
        this._predictiveSearchAPI = new (0, $2a1afe451ee81b88$export$2e2bcd8739ae039)();
    }
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._inputComponent, "input", this._handleInputChange);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._inputComponent, "input", this._handleInputChange);
    }
    _handleInputChange = (0, $e8126b7100a99238$exports.debounce)(()=>{
        if (this._searchQuery) this._renderResults();
        else this._resetResults();
    }, 500);
    _renderResults() {
        this._cache[this._searchQuery] ? this._renderFromCache(this._searchQuery) : this._renderFromUrl(this._searchQuery);
    }
    _resetResults() {
        if (!this.sidebar) return;
        this._updateResultsFromHTML(this.sidebar.defaultStateElement);
    }
    _renderFromCache(queryKey) {
        try {
            this._updateResultsFromHTML(this._cache[queryKey]);
        } catch (error) {
            if (!(0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification) return;
            (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification.show("Error in search component when try update from cache", "warning");
        }
    }
    _renderFromUrl(queryKey) {
        const sectionId = this.sidebar?.dataset.sectionId || "search-sidebar";
        this._predictiveSearchAPI.get({
            searchQuery: this._searchQuery,
            sectionId: sectionId
        }).then((text)=>{
            const html = (0, $e6a5d8115fb64fe3$export$8a49393be2d55148)(text);
            this._cache[queryKey] = html;
            this._updateResultsFromHTML(html);
        }).catch(()=>{
            if (!(0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification) return;
            (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification.show("Error in search component", "warning");
        });
    }
    _updateResultsFromHTML(html) {
        const newModal = html.getElementById("SearchSidebar");
        if (newModal) {
            const template = newModal.querySelector("template");
            const element = (0, $e6a5d8115fb64fe3$export$8ea4fc17cec6f158)(template);
            const newResults = element.querySelector(this.contentResults);
            this.updateResultsHTML(newResults.innerHTML);
            this.updateFooterVisible();
        }
    }
    updateResultsHTML(newResultsHTML) {
        if (!this._results) return;
        this._results.innerHTML = newResultsHTML;
    }
    updateFooterVisible() {
        if (this.sidebar) {
            const footer = this.sidebar.element.querySelector(this.footerSelector);
            const renderedItems = this.sidebar.element.querySelectorAll(this.itemSelector);
            if (footer) footer.classList.toggle("hidden", renderedItems.length === 0);
        }
    }
    get _searchQuery() {
        if (!this._inputComponent) return "";
        return this._inputComponent.value.trim();
    }
    get _inputComponent() {
        if (!this.sidebar) return null;
        return this.sidebar.querySelector(this.inputComponentSelector);
    }
}
var $56b1f5edcb7cb412$export$2e2bcd8739ae039 = $56b1f5edcb7cb412$var$SearchSidebarFormWrapper;




class $387c0d5d6691d2fe$var$CartRemoveButton extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "focus", this._handleButtonFocus);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "blur", this._handleButtonBlur);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "click", this._handleButtonClick);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "focus", this._handleButtonFocus);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "blur", this._handleButtonBlur);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "click", this._handleButtonClick);
    }
    _handleButtonClick = ()=>{
        this.update();
    };
    update() {
        const cart = this.closest("cart-component, sidebar-cart");
        const cartItemIndex = this.dataset.index;
        if (cart && cartItemIndex) cart.updateItem(+cartItemIndex, 0);
    }
    _handleButtonFocus = ()=>{
        this.addEventListener("keydown", this._handleKeyDown);
    };
    _handleButtonBlur = ()=>{
        this.removeEventListener("keydown", this._handleKeyDown);
    };
    _handleKeyDown = (event)=>{
        const isEnterKey = (0, $eceaf86a082c33f7$export$793b145c7f680179)(event.key || event.keyCode);
        if (isEnterKey) {
            event.preventDefault();
            this.update();
        }
    };
}
var $387c0d5d6691d2fe$export$2e2bcd8739ae039 = $387c0d5d6691d2fe$var$CartRemoveButton;




class $b37a9897533b25a7$var$ClipboardButton extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "click", this._handleButtonClick);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "click", this._handleButtonClick);
    }
    _handleButtonClick = ()=>{
        this._copy();
    };
    _copy = ()=>{
        const value = this.dataset.value;
        if (value && navigator.clipboard) navigator.clipboard.writeText(value).then(()=>{
            this._showTooltip();
        });
    };
    _showTooltip() {
        const tooltipId = this.dataset.tooltipId;
        if (!tooltipId) return;
        const tooltip = document.querySelector(`#${tooltipId}`);
        if (tooltip) {
            tooltip.show();
            (0, $eceaf86a082c33f7$export$1391212d75b2ee65)(1000).then(()=>{
                tooltip.hide();
            });
        }
    }
}
var $b37a9897533b25a7$export$2e2bcd8739ae039 = $b37a9897533b25a7$var$ClipboardButton;





class $a1893a91fba3125e$var$ClipboardButtonTooltip extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        const template = this.querySelector("template");
        this.element = (0, $e6a5d8115fb64fe3$export$8ea4fc17cec6f158)(template);
        this._arrow = this.element.querySelector("[data-float-element-arrow]");
    }
    disconnectedCallback() {
        this._unmount();
    }
    _update = ()=>{
        if (!this._target) return;
        (0, $ea29d606feab1cd3$export$48a53dcb22e581d0)(this._target, this, this._getOptions()).then((data)=>{
            this._updatePosition(data);
            this._updateArrow(data);
        });
    };
    _updatePosition({ x: x , y: y  }) {
        Object.assign(this.style, {
            left: `${x}px`,
            top: `${y}px`
        });
    }
    _getOptions() {
        return {
            placement: this._placement,
            middleware: this._getMiddleware(),
            strategy: "absolute"
        };
    }
    _getMiddleware() {
        const alignmentAxisOffset = this.dataset.alignmentAxisOffset || 0;
        const mainAxisOffset = this.dataset.mainAxisOffset || 0;
        const middleware = [
            (0, $983343fd387df40f$export$cc800923e997bb8)({
                alignmentAxis: +alignmentAxisOffset,
                mainAxis: +mainAxisOffset
            }),
            (0, $983343fd387df40f$export$8a83211c878a3f1f)(),
            (0, $983343fd387df40f$export$fba63a578e423eb)()
        ];
        if (this._arrow) middleware.push((0, $983343fd387df40f$export$f2120bbfa5450bd2)({
            element: this._arrow
        }));
        return middleware;
    }
    _updateArrow({ placement: placement , middlewareData: middlewareData  }) {
        if (!this._arrow) return;
        const { x: arrowX , y: arrowY  } = middlewareData.arrow;
        const staticSide = {
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
        }[placement.split("-")[0]];
        Object.assign(this._arrow.style, {
            left: arrowX != null ? `${arrowX}px` : "",
            top: arrowY != null ? `${arrowY}px` : "",
            right: "",
            bottom: "",
            [staticSide]: "-5px"
        });
    }
    _mount() {
        if (!this.contains(this.element)) this.appendChild(this.element);
    }
    _unmount() {
        if (this.element) this.element.remove();
    }
    show = ()=>{
        this._mount();
        this._setVisible(true);
        this._update();
        this.emit("show", {});
    };
    hide = ()=>{
        this._setVisible(false);
        this._unmount();
        this.emit("hide", {});
    };
    _setVisible(isVisible) {
        this.setAttribute("aria-hidden", isVisible ? "false" : "true");
    }
    get _target() {
        return document.querySelector(`[data-clipboard-button-tooltip-target-id="${this.id}"]`);
    }
    get _placement() {
        return this.dataset.placement || "bottom-end";
    }
}
var $a1893a91fba3125e$export$2e2bcd8739ae039 = $a1893a91fba3125e$var$ClipboardButtonTooltip;






class $e018bc5cacae9238$var$ProductCard extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._resizeObserver = new ResizeObserver(this._handleResize);
        this._lastButtonsWidth = 0;
        this._quickViewBtnSelector = `[data-product-card-quick-view-button]`;
        this._preloaderSelector = `[data-product-card-preloader]`;
        this._imagesSelector = `[data-product-card-media-container]`;
        this._buttonsSelector = `[data-product-card-buttons]`;
        this._imageListSelector = `[data-product-card-featured-image]`;
        this._mediaTabsSelector = `[data-product-card-media-tabs]`;
        this._colorSwatchesSelector = `[data-product-card-color-swatches]`;
        this._quickViewBtn = this.querySelector(this._quickViewBtnSelector);
        this._preloader = this.querySelector(this._preloaderSelector);
        this._images = this.querySelector(this._imagesSelector);
        this._buttons = this.querySelector(this._buttonsSelector);
        this._imageList = [
            ...this.querySelectorAll(this._imageListSelector)
        ];
        this._mediaTabs = this.querySelector(this._mediaTabsSelector);
        this._colorSwatches = this.querySelector(this._colorSwatchesSelector);
        this.imagesLoaded = 0;
    }
    connectedCallback() {
        if (this._imageList) this._imageList.forEach((image)=>{
            image.addEventListener("load", this.handleImageLoad);
        });
        if (this._buttons) this._setButtonsOverflow();
        this._resizeObserver.observe(this);
        if (this._preloader) (0, $eceaf86a082c33f7$export$b9291b92670abfe3).observe(this._preloader);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "mouseenter", this._handleMouseEnter);
        if (this._quickViewBtn) (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._quickViewBtn, "click", this._handleQuickViewBtnClick);
    }
    disconnectedCallback() {
        this._resizeObserver.unobserve(this);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "mouseenter", this._handleMouseEnter);
        if (this._quickViewBtn) (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._quickViewBtn, "click", this._handleQuickViewBtnClick);
    }
    _handleMouseEnter = ()=>{
        const url = this.dataset.url;
        const id = this.dataset.id;
        if (url && id) (0, $5ea14d7179693556$export$e53b747444795854).requestProductFromUrl(url, id);
    };
    _handleQuickViewBtnClick = ()=>{
        const url = this.dataset.url;
        if (url) (0, $5ea14d7179693556$export$e53b747444795854).openAndRenderProductByUrl(url);
    };
    _handleResize = (0, $e8126b7100a99238$exports.debounce)(()=>{
        if (this._buttons) this._setButtonsOverflow();
        if (this._mediaTabs) this._mediaTabs.update();
        if (this._colorSwatches) this._colorSwatches.update();
    }, 500);
    handleImageLoad = ()=>{
        this.imagesLoaded += 1;
        if (this.imagesLoaded === this._imageList?.length) {
            this._hidePreloader();
            this._showImages();
        }
    };
    _setButtonsOverflow() {
        if (!this._buttons) return;
        const buttonsWidth = this._getButtonsWidth();
        const isOverflowed = this._buttons.offsetWidth < buttonsWidth;
        if (isOverflowed) this._lastButtonsWidth = this._buttons.offsetWidth;
        this._buttons.classList.toggle("product-card__btns--overflowed", isOverflowed);
    }
    _getButtonsWidth() {
        const buttonList = [
            ...this.querySelectorAll("[data-product-card-button]")
        ];
        const TEXT_MARGIN_LEFT = 8;
        const ICON_WIDTH = 20;
        const HORIZONTAL_PADDING = 10;
        const BUTTONS_COLUMN_GAP = 8;
        const buttonsWidth = buttonList.reduce((result, button)=>{
            const text = button.querySelector(`[data-product-card-button-text]`);
            const textOffsetWidth = text ? text.offsetWidth : 0;
            const textWidth = textOffsetWidth + TEXT_MARGIN_LEFT;
            const buttonWidth = ICON_WIDTH + textWidth + HORIZONTAL_PADDING;
            return result + buttonWidth + BUTTONS_COLUMN_GAP;
        }, buttonList.length > 1 ? BUTTONS_COLUMN_GAP : 0);
        return buttonsWidth;
    }
    _hidePreloader() {
        if (!this._preloader) return;
        this._preloader.classList.add("hidden");
    }
    _showImages() {
        if (!this._images) return;
        this._images.setAttribute("visible", "");
    }
}
var $e018bc5cacae9238$export$2e2bcd8739ae039 = $e018bc5cacae9238$var$ProductCard;





class $d29031730d5d0f2b$var$MaxLinesComponent extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._resizeObserver = new ResizeObserver(this._handleResize);
        this.targetSelector = `[data-quote-line-clamp-target]`;
        this.lineClampSelector = `[data-quote-line-clamp]`;
        this._lineClamp = this.querySelector(this.lineClampSelector);
        this._target = this.querySelector(this.targetSelector);
    }
    connectedCallback() {
        this._setMaxLines();
        if (this._lineClamp) this._resizeObserver.observe(this);
    }
    disconnectedCallback() {
        if (this._lineClamp) this._resizeObserver.disconnect();
    }
    _handleResize = (0, $e8126b7100a99238$exports.debounce)(()=>{
        this._setMaxLines();
    }, 500);
    _setMaxLines() {
        const maxLines = this._getMaxLines();
        if (maxLines && this._target) {
            this._target.style.setProperty("--gsc-max-lines", `${maxLines}`);
            this.setAttribute("data-line-clamp-setter-is-ready", "");
        }
    }
    _getMaxLines() {
        if (!this._lineClamp || !this._target) return 0;
        const lineHeight = (0, $e6a5d8115fb64fe3$export$d107df9a86338a09)(this._target, "lineHeight");
        const marginBottom = (0, $e6a5d8115fb64fe3$export$d107df9a86338a09)(this._target, "marginBottom");
        const marginTop = (0, $e6a5d8115fb64fe3$export$d107df9a86338a09)(this._target, "marginTop");
        const contentHeight = this._lineClamp.offsetHeight - parseFloat(marginBottom) - parseFloat(marginTop);
        const maxLines = Math.floor(contentHeight / parseFloat(lineHeight));
        return maxLines;
    }
}
var $d29031730d5d0f2b$export$2e2bcd8739ae039 = $d29031730d5d0f2b$var$MaxLinesComponent;




class $b13b72248522e8df$var$CountrySelector extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._input = this.querySelector("input");
        this._dropdown = this.querySelector("float-element");
        this._dropdownBtnLabel = this.querySelector(".dropdown__toggle-label");
        this._createItems();
        this._items = [
            ...this.querySelectorAll(".dropdown__item")
        ];
    }
    connectedCallback() {
        this._items.forEach((item)=>{
            (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(item, "click", this._handleItemClick);
        });
    }
    disconnectedCallback() {
        this._items.forEach((item)=>{
            (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(item, "click", this._handleItemClick);
        });
    }
    _handleItemClick = (event)=>{
        if (!this._input || !this._dropdownBtnLabel || !this._dropdown) return;
        this._input.setAttribute("value", event.target.dataset.value);
        this._setActiveItem(event.target.dataset.value);
        this._dropdownBtnLabel.innerHTML = event.target.dataset.value;
        this._dropdown.hide();
    };
    _setActiveItem(activeCountryValue) {
        this._items.forEach((item)=>{
            item.classList.toggle("active", item.dataset.value === activeCountryValue);
        });
    }
    _createItems() {
        const options = this.querySelectorAll("option");
        options.forEach((option)=>{
            if (!this._dropdown) return;
            const item = document.createElement("div");
            item.classList.add("dropdown__item");
            item.dataset.value = option.value;
            item.dataset.provinces = option.dataset.provinces;
            item.innerHTML = option.innerHTML;
            this._dropdown.appendChild(item);
        });
    }
}
var $b13b72248522e8df$export$2e2bcd8739ae039 = $b13b72248522e8df$var$CountrySelector;




class $e9aeff4d9b646381$var$SearchField extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._inputSelector = `[data-search-field-input]`;
        this._resetBtnSelector = `[data-search-field-reset-button]`;
        this._input = this.querySelector(this._inputSelector);
        this._resetBtn = this.querySelector(this._resetBtnSelector);
    }
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._input, "input", this._handleInputChange);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(window, "click", this._handleWindowClick);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._resetBtn, "click", this._handleResetBtnClick);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._input, "input", this._handleInputChange);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(window, "click", this._handleWindowClick);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._resetBtn, "click", this._handleResetBtnClick);
    }
    _handleWindowClick = (event)=>{
        const target = event.target;
        const isInputChild = target.closest("search-input");
        const isInput = this._input === target;
        const isOutsideClick = !isInput && !isInputChild;
        if (isOutsideClick) this._updateResetButtonVisible();
    };
    _handleInputChange = ()=>{
        this._updateResetButtonVisible();
    };
    _handleResetBtnClick = (event)=>{
        event.preventDefault();
        this.reset();
    };
    reset() {
        if (this._input) {
            const event = new Event("input", {
                bubbles: true
            });
            this._input.value = "";
            this._input.dispatchEvent(event);
            this._input.focus();
        }
    }
    _updateResetButtonVisible() {
        if (this._resetBtn) {
            const hasValue = this._hasInputValue();
            this._resetBtn.classList.toggle("hidden", !hasValue);
        }
    }
    _hasInputValue() {
        if (!this._input) return false;
        return this._input.value.trim().length > 0;
    }
    get value() {
        if (!this._input) return "";
        return this._input.value;
    }
}
var $e9aeff4d9b646381$export$2e2bcd8739ae039 = $e9aeff4d9b646381$var$SearchField;




class $9fd764f29eaa8c8e$var$PasswordField extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._inputSelector = `[data-password-field-input]`;
        this._buttonSelector = `[data-password-field-button]`;
        this._input = this.querySelector(this._inputSelector);
        this._button = this.querySelector(this._buttonSelector);
    }
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._button, "click", this._handleButtonClick);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._button, "click", this._handleButtonClick);
    }
    _handleButtonClick = ()=>{
        this._togglePasswordVisible();
    };
    _togglePasswordVisible() {
        if (this._input) {
            const isPasswordHidden = this._input.getAttribute("type") === "password";
            const type = isPasswordHidden ? "text" : "password";
            this._input.setAttribute("type", type);
            this._setButton(isPasswordHidden);
        }
    }
    _setButton(isPasswordHidden) {
        if (this._button) this._button.toggleAttribute("password-visible", isPasswordHidden);
    }
}
var $9fd764f29eaa8c8e$export$2e2bcd8739ae039 = $9fd764f29eaa8c8e$var$PasswordField;





class $153b9a55408e9d60$var$ZoomCursor extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.zoomTargetSelector = `[data-zoom-cursor-target]`;
        this.mutationObserver = new MutationObserver(this._handleMutations);
    }
    connectedCallback() {
        this._autoCheckTargets();
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(window, "mousemove", this._handleMouseMove);
        this.mutationObserver.disconnect();
        clearInterval(this.checkTargetsIntervalID);
    }
    _handleMutations = (mutations)=>{
        mutations.forEach((mutation)=>{
            if (mutation.type === "attributes") {
                const isZoomTarget = mutation.target.matches(this.zoomTargetSelector);
                this._setVisible(isZoomTarget);
            }
        });
    };
    _handleMouseMove = (event)=>{
        const target = event.target;
        const isZoomTarget = !!target.closest(this.zoomTargetSelector);
        const isMobile = (0, $5d3d77426481432d$export$e7a5aad9bb00dd62)();
        if (this._isVisible) {
            this.style.top = `${event.clientY}px`;
            this.style.left = `${event.clientX}px`;
        }
        if (!isMobile) {
            this._setVisible(isZoomTarget);
            if (isZoomTarget) this.mutationObserver.observe(target, {
                attributes: true
            });
        }
    };
    _setVisible(isVisible) {
        this.toggleAttribute("visible", isVisible);
        document.body.style.cursor = isVisible ? "none" : "";
    }
    updateState(isZoomed) {
        this.toggleAttribute("zoomed", isZoomed);
    }
    _autoCheckTargets() {
        this.checkTargetsIntervalID = setInterval(()=>{
            const targets = document.querySelectorAll(this.zoomTargetSelector);
            if (targets.length && !this.isHandlerSetted) {
                (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(window, "mousemove", this._handleMouseMove);
                this.isHandlerSetted = true;
            }
        }, 1000);
    }
    get _isVisible() {
        return this.hasAttribute("visible");
    }
}
var $153b9a55408e9d60$export$2e2bcd8739ae039 = $153b9a55408e9d60$var$ZoomCursor;







class $ecd8a9de0e45f730$var$Shop extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._cache = {};
        this._searchParamsInitial = window.location.search.slice(1);
        this._searchParamsPrev = window.location.search.slice(1);
        this.sortQuery = "";
        this.filterQuery = "";
    }
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(window, "popstate", this._handleHistoryChange);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(window, "popstate", this._handleHistoryChange);
    }
    _handleHistoryChange = ({ state: { searchParams: searchParams  }  })=>{
        const newSearchParams = searchParams || this._searchParamsInitial;
        if (newSearchParams !== this._searchParamsPrev) this.updateBySearchParams(newSearchParams);
    };
    _formatParams(searchParams) {
        this._searchParamsPrev = searchParams;
        const baseParams = this.dataset.baseParams || "";
        return `${baseParams}${searchParams}`;
    }
    updateBySearchParams(searchParams) {
        this.updateShopBySearchParams(searchParams);
        this.updateFiltersBySearchParams(searchParams);
    }
    updateShopBySearchParams(searchParams) {
        const url = this._createUrl(searchParams);
        this._cache[url] ? this._updateElements(this._cache[url]) : this._getFromUrl(url).then((html)=>this._updateElements(html));
        this._updateURL(searchParams, url);
    }
    updateFiltersBySearchParams(searchParams) {
        const url = this._createUrl(searchParams);
        const mobileFilter = document.querySelector("#SidebarFiltersMobile");
        const desktopFilter = document.querySelector("#SidebarFiltersDesktop");
        if (mobileFilter && desktopFilter) {
            const filters = [
                mobileFilter,
                desktopFilter
            ];
            filters.forEach((filter)=>{
                filter.loadingOverlay.show();
            });
            const updateFilters = (html)=>{
                filters.forEach((filter)=>{
                    filter.updateHTML(html);
                    filter.loadingOverlay.hide();
                });
            };
            this._cache[url] ? updateFilters(this._cache[url]) : this._getFromUrl(url).then((html)=>updateFilters(html));
        }
    }
    _getFromUrl(url) {
        const loadingOverlayElement = this.querySelector("#ShopProductsOverlay");
        const loadingOverlay = loadingOverlayElement ? new (0, $5c99123a7789bac3$export$2e2bcd8739ae039)(loadingOverlayElement) : null;
        if (loadingOverlay) loadingOverlay.show();
        const preparedUrl = `${url}&section_id=${this.dataset.sectionId}`;
        return fetch(preparedUrl).then((response)=>response.text()).then((responseText)=>{
            const html = (0, $e6a5d8115fb64fe3$export$8a49393be2d55148)(responseText);
            this._cache[url] = html;
            if (loadingOverlay) loadingOverlay.hide();
            return html;
        }).catch(()=>{
            if (!(0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification) return;
            (0, $0958b1945ad703ab$export$e1122b4c4bd5b838).notification.show("Error in shop component", "warning");
        });
    }
    _updateURL(searchParams, url) {
        history.pushState({
            searchParams: searchParams
        }, "", url);
    }
    _createUrl(searchParams) {
        const params = this._formatParams(searchParams) || "";
        const url = `${window.location.pathname}?${params}`;
        return url;
    }
    _updateElements(html) {
        const elements = [
            "ShopProducts",
            "ShopProductCount",
            "ShopSortList",
            "ShopActiveFilters"
        ];
        elements.forEach((elementId)=>{
            const element = document.getElementById(elementId);
            const newElement = html.getElementById(elementId);
            if (element && newElement) element.innerHTML = newElement.innerHTML;
        });
    }
    resetQueries() {
        this.sortQuery = "";
        this.filterQuery = "";
    }
}
var $ecd8a9de0e45f730$export$2e2bcd8739ae039 = $ecd8a9de0e45f730$var$Shop;



class $67917ca7a79c9799$var$ShopActiveFilters extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.optionsSelector = `[data-shop-active-filters-options]`;
        this.removeBtnSelector = `[data-shop-active-filters-remove-btn]`;
    }
    reset() {
        this.innerHTML = "";
    }
    setDisable() {
        if (this.options) this.options.setAttribute("disabled", "");
    }
    get options() {
        return this.querySelector(this.optionsSelector);
    }
    get buttons() {
        return [
            ...this.querySelectorAll(this.removeBtnSelector)
        ];
    }
}
var $67917ca7a79c9799$export$2e2bcd8739ae039 = $67917ca7a79c9799$var$ShopActiveFilters;






class $408040aef0dbab1c$var$SidebarFilters extends (0, $cc5469d7bf7c0ec5$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.form = this.element.querySelector("[data-filters-form]");
    }
    connectedCallback() {
        super.connectedCallback();
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this.form, "scroll", this._handleFormScroll);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "change", this._handleInputChange);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "click", this._handleClick);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this.form, "scroll", this._handleFormScroll);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "change", this._handleInputChange);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "click", this._handleClick);
    }
    _handleFormScroll = ()=>{
        if (this.form) {
            const isScrolled = this.form.scrollTop > 0;
            this.toggleAttribute("header-shadow-visible", isScrolled);
        }
    };
    _handleClick = (event)=>{
        const target = event.target;
        const label = target.closest("[data-filters-checkbox]");
        if (label) label.setAttribute("selected", "");
    };
    _handleInputChange = (event)=>{
        const target = event.target;
        if (target.tagName === "INPUT") this._change();
    };
    _change() {
    // re-define in children
    }
    _createFilterQuery() {
        if (this._form && this._shop) {
            const formData = new FormData(this._form);
            const filterQuery = new URLSearchParams(formData).toString();
            this._shop.filterQuery = filterQuery;
        }
    }
    updateHTML(html) {
        const filterId = this.getAttribute("id");
        const newFilter = filterId ? html.getElementById(filterId) : null;
        const newTemplate = newFilter ? newFilter.querySelector("template") : null;
        if (newTemplate) {
            const newElement = (0, $e6a5d8115fb64fe3$export$8ea4fc17cec6f158)(newTemplate);
            this.updateFormFromElement(newElement);
            this.updateHeaderFromElement(newElement);
        }
    }
    updateHeaderFromElement(newElement) {
        const header = this.element.querySelector("[data-filters-header]");
        const newHeader = newElement.querySelector("[data-filters-header]");
        if (header && newHeader) header.innerHTML = newHeader.innerHTML;
    }
    updateFormFromElement(newElement) {
        const form = this.element.querySelector("[data-filters-form]");
        const newForm = newElement.querySelector("[data-filters-form]");
        if (form && newForm) form.innerHTML = newForm.innerHTML;
    }
    get _form() {
        return this.element.querySelector("form");
    }
    get _shop() {
        return this.element.closest("shop-component");
    }
    get _searchParams() {
        if (!this._shop) return "";
        return [
            this._shop.filterQuery,
            this._shop.sortQuery
        ].join("&");
    }
    get loadingOverlay() {
        const preloader = this.element.querySelector("[data-filters-loading-overlay]");
        if (!preloader) return null;
        return new (0, $5c99123a7789bac3$export$2e2bcd8739ae039)(preloader);
    }
}
var $408040aef0dbab1c$export$2e2bcd8739ae039 = $408040aef0dbab1c$var$SidebarFilters;


class $2b77ef3fe1ae89fb$var$SidebarFiltersDesktop extends (0, $408040aef0dbab1c$export$2e2bcd8739ae039) {
    _change() {
        if (this._shop) {
            this._createFilterQuery();
            this._shop.updateBySearchParams(this._searchParams);
        }
    }
}
var $2b77ef3fe1ae89fb$export$2e2bcd8739ae039 = $2b77ef3fe1ae89fb$var$SidebarFiltersDesktop;



class $7dfa4d358287d221$var$DesktopFiltersButton extends (0, $19960a3413ca07cd$export$2e2bcd8739ae039) {
}
var $7dfa4d358287d221$export$2e2bcd8739ae039 = $7dfa4d358287d221$var$DesktopFiltersButton;




class $1214535009ee2c26$var$SidebarFiltersMobile extends (0, $408040aef0dbab1c$export$2e2bcd8739ae039) {
    _change() {
        if (this._shop) {
            this._createFilterQuery();
            this._shop.updateFiltersBySearchParams(this._searchParams);
            this._setButtonForReset();
        }
    }
    _setButtonForReset() {
        const button = this.element.querySelector("filter-remove-btn");
        if (button) {
            const isHidden = button.classList.contains("hidden");
            if (isHidden) (0, $e6a5d8115fb64fe3$export$998191bfdf710c72)(button);
        }
    }
}
var $1214535009ee2c26$export$2e2bcd8739ae039 = $1214535009ee2c26$var$SidebarFiltersMobile;




class $d084b2636063bd3f$var$MobileFiltersButton extends (0, $19960a3413ca07cd$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.defaultHeight = this.offsetHeight;
    }
    connectedCallback() {
        super.connectedCallback();
        this._setExtended();
        window.addEventListener("scroll", this._handleWindowScroll);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener("scroll", this._handleWindowScroll);
    }
    _handleWindowScroll = ()=>{
        this.updateButtonFixedState();
        this.updateButtonExtendState();
    };
    updateButtonFixedState() {
        const footer = document.querySelector(".shopify-section.shopify-section-footer");
        const footerOffsetTop = footer ? footer.offsetTop : 0;
        const rect = this.getBoundingClientRect();
        const criticalPoint = -rect.top;
        const isUnderFooter = window.innerHeight + window.scrollY < footerOffsetTop;
        const isHidden = criticalPoint > 0 && isUnderFooter;
        const isPrepare = criticalPoint > 50 && isUnderFooter;
        const isFixed = criticalPoint > 100 && isUnderFooter;
        this.toggleAttribute("is-hidden-before-fixed", isHidden);
        this.toggleAttribute("is-prepare-before-fixed", isPrepare);
        this.toggleAttribute("is-fixed", isFixed);
        document.body.toggleAttribute("is-filters-button-fixed", isFixed);
    }
    updateButtonExtendState() {
        if (!this._lastScrollPosition) this._lastScrollPosition = window.scrollY;
        this._setExtended();
    }
    _setExtended = (0, $e8126b7100a99238$exports.debounce)(()=>{
        const threshold = 24;
        const distance = Math.abs(window.scrollY - this._lastScrollPosition);
        if (distance > threshold) {
            const isExtended = this._lastScrollPosition > window.scrollY;
            this.toggleAttribute("is-extended", isExtended);
        }
        this._lastScrollPosition = 0;
    }, 50);
}
var $d084b2636063bd3f$export$2e2bcd8739ae039 = $d084b2636063bd3f$var$MobileFiltersButton;




class $1a7a70252d44a5f7$var$FilterRemoveBtn extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "focus", this._handleButtonFocus);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "blur", this._handleButtonBlur);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "click", this._handleButtonClick);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "focus", this._handleButtonFocus);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "blur", this._handleButtonBlur);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "click", this._handleButtonClick);
    }
    _handleButtonClick = ()=>{
        this.update();
    };
    _handleButtonFocus = ()=>{
        this.addEventListener("keydown", this._handleKeyDown);
    };
    _handleButtonBlur = ()=>{
        this.removeEventListener("keydown", this._handleKeyDown);
    };
    _handleKeyDown = (event)=>{
        const isEnterKey = (0, $eceaf86a082c33f7$export$793b145c7f680179)(event.key || event.keyCode);
        if (isEnterKey) {
            event.preventDefault();
            this.update();
        }
    };
    update() {
        const shopActiveFilters = this.closest("shop-active-filters");
        const shop = this.closest("shop-component");
        const url = this.dataset.url;
        if (shopActiveFilters) {
            const isRemoveButton = this.hasAttribute("data-shop-active-filters-remove-btn");
            const isResetButton = this.hasAttribute("data-shop-active-filters-reset");
            if (isResetButton) shopActiveFilters.reset();
            if (isRemoveButton) {
                const withSingleActiveFilter = shopActiveFilters.buttons.length === 1;
                if (withSingleActiveFilter) shopActiveFilters.reset();
                else {
                    shopActiveFilters.setDisable();
                    this.remove();
                }
            }
        }
        if (url && shop) {
            const searchParams = url.indexOf("?") === -1 ? "" : url.slice(url.indexOf("?") + 1);
            shop.resetQueries();
            shop.updateBySearchParams(searchParams);
        }
    }
}
var $1a7a70252d44a5f7$export$2e2bcd8739ae039 = $1a7a70252d44a5f7$var$FilterRemoveBtn;





class $80308934d9447215$var$SortList extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.labelSelector = `[data-sort-list-label]`;
    }
    connectedCallback() {
        this.setListenersForLabels();
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._form, "input", this._handleFormSubmit);
    }
    disconnectedCallback() {
        this.removeListenersForLabels();
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._form, "input", this._handleFormSubmit);
    }
    _handleFormSubmit = (0, $e8126b7100a99238$exports.debounce)((event)=>{
        event.preventDefault();
        const shop = this.closest("shop-component");
        const sidebarParent = this.closest("sidebar-component");
        const input = event.target;
        if (sidebarParent) sidebarParent.hide();
        if (shop && input) {
            const sortQuery = this._getSortQuery(input);
            const searchParams = [
                shop.filterQuery,
                sortQuery
            ].join("&");
            shop.sortQuery = sortQuery;
            shop.updateBySearchParams(searchParams);
        }
    }, 250);
    _handleLabelKeyDown = (event)=>{
        const isEnterKey = (0, $eceaf86a082c33f7$export$793b145c7f680179)(event.key || event.keyCode);
        if (isEnterKey) {
            event.preventDefault();
            const target = event.target;
            const input = target.querySelector(`input`);
            if (input) {
                const inputEvent = new MouseEvent("click", {
                    button: 0,
                    which: 1
                });
                input.dispatchEvent(inputEvent);
            }
        }
    };
    _getSortQuery(input) {
        const form = input.closest("form");
        if (form) {
            const formData = new FormData(form);
            const sortQuery = new URLSearchParams(formData).toString();
            return sortQuery;
        } else return "";
    }
    setListenersForLabels() {
        const labels = [
            ...this.querySelectorAll(this.labelSelector)
        ];
        labels.forEach((label)=>{
            label.addEventListener("keydown", this._handleLabelKeyDown);
        });
    }
    removeListenersForLabels() {
        const labels = [
            ...this.querySelectorAll(this.labelSelector)
        ];
        labels.forEach((label)=>{
            label.removeEventListener("keydown", this._handleLabelKeyDown);
        });
    }
    get _form() {
        return this.querySelector("form");
    }
}
var $80308934d9447215$export$2e2bcd8739ae039 = $80308934d9447215$var$SortList;




class $9cfbdef480257594$var$PriceRange extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._minNumberInput = this.querySelector(`[data-price-min-range-number]`);
        this._maxNumberInput = this.querySelector(`[data-price-max-range-number]`);
        this._rangeWrapper = this.querySelector(`[data-price-range-inputs-wrapper]`);
        this._minRangeInput = this.querySelector(`[data-price-min-range-input]`);
        this._maxRangeInput = this.querySelector(`[data-price-max-range-input]`);
        this._progress = this.querySelector(`[data-price-range-progress]`);
    }
    connectedCallback() {
        if (this._minRangeInput) this._updateMinRangeInput(+this._minRangeInput.value);
        if (this._maxRangeInput) this._updateMaxRangeInput(+this._maxRangeInput.value);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._minNumberInput, "input", this._handleNumberChange);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._maxNumberInput, "input", this._handleNumberChange);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._minRangeInput, "input", this._handleRangeChange);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._maxRangeInput, "input", this._handleRangeChange);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._rangeWrapper, "mouseenter", this._handleRangeInput);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._rangeWrapper, "mousemove", this._handleRangeInput);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._minNumberInput, "input", this._handleNumberChange);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._maxNumberInput, "input", this._handleNumberChange);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._minRangeInput, "input", this._handleRangeChange);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._maxRangeInput, "input", this._handleRangeChange);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._rangeWrapper, "mouseenter", this._handleRangeInput);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._rangeWrapper, "mousemove", this._handleRangeInput);
    }
    _handleRangeInput = (event)=>{
        const maxInput = this.querySelector(`[data-price-range-max-input]`);
        const minInput = this.querySelector(`[data-price-range-min-input]`);
        if (this._progress && minInput && maxInput) {
            const middleOfProgress = this._progress.offsetLeft + this._progress.offsetWidth / 2;
            const isMinInputClosest = event.offsetX < middleOfProgress;
            minInput.toggleAttribute("targeted", isMinInputClosest);
            maxInput.toggleAttribute("targeted", !isMinInputClosest);
        }
    };
    _handleNumberChange = ()=>{
        if (this._minNumberInput && this._maxNumberInput) {
            const minPrice = parseInt(this._minNumberInput.value);
            const maxPrice = parseInt(this._maxNumberInput.value);
            this._updateMinRangeInput(minPrice);
            this._updateMaxRangeInput(maxPrice);
        }
    };
    _handleRangeChange = ()=>{
        if (this._minRangeInput && this._maxRangeInput) {
            const minVal = parseInt(this._minRangeInput.value);
            const maxVal = parseInt(this._maxRangeInput.value);
            this._updateMaxPriceInput(maxVal);
            this._updateMinPriceInput(minVal);
            this._updateMinRangeInput(minVal);
            this._updateMaxRangeInput(maxVal);
        }
    };
    _updateMaxRangeInput(value) {
        if (this._maxRangeInput && this._progress) {
            const rightPosition = 100 - value / +this._maxRangeInput.max * 100;
            this._maxRangeInput.value = `${value}`;
            this._progress.style.right = `${rightPosition}%`;
        }
    }
    _updateMinRangeInput(value) {
        if (this._minRangeInput && this._progress) {
            const leftPosition = value / +this._minRangeInput.max * 100;
            this._minRangeInput.value = `${value}`;
            this._progress.style.left = `${leftPosition}%`;
        }
    }
    _updateMaxPriceInput(value) {
        if (this._maxNumberInput) this._maxNumberInput.value = value.toFixed(2);
    }
    _updateMinPriceInput(value) {
        if (this._minNumberInput) this._minNumberInput.value = value.toFixed(2);
    }
}
var $9cfbdef480257594$export$2e2bcd8739ae039 = $9cfbdef480257594$var$PriceRange;




class $d071223971d7ce85$var$ColumnSwitcher extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.itemSelector = `[data-column-switcher-item]`;
        this.targetSelector = `[data-column-switcher-target]`;
        this.items = [
            ...this.querySelectorAll(this.itemSelector)
        ];
        this._cssVariable = this.dataset.columnSwitcherCssVariable || "";
    }
    connectedCallback() {
        this._init();
        this.items.forEach((item)=>{
            (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(item, "keydown", this._handleKeyDown);
            (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(item, "click", this._handleItemClick);
        });
        if (this._isEditorMode) this._editor.subscribe("SECTION_LOAD", this._handleSectionLoad);
    }
    disconnectedCallback() {
        this.items.forEach((item)=>{
            (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(item, "keydown", this._handleKeyDown);
            (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(item, "click", this._handleItemClick);
        });
        if (this._isEditorMode) this._editor.destroy();
    }
    _handleSectionLoad = (event)=>{
        if (this.dataset.sectionId === event.detail.sectionId) this.reset();
    };
    _handleItemClick = (event)=>{
        const eventTarget = event.target;
        const target = eventTarget.closest(this.itemSelector);
        if (target) {
            const columnCount = +(target.dataset.value || 1);
            this._switch(columnCount);
        }
    };
    _handleKeyDown = (event)=>{
        const isEnterKey = (0, $eceaf86a082c33f7$export$793b145c7f680179)(event.key || event.keyCode);
        if (isEnterKey) {
            event.preventDefault();
            const eventTarget = event.target;
            const target = eventTarget.closest(this.itemSelector);
            if (target) {
                const columnCount = +(target.dataset.value || 1);
                this._switch(columnCount);
            }
        }
    };
    updateByColumnCount(columnCount) {
        this._selectSwitch(columnCount);
        this._updateColumnCount(columnCount);
    }
    _selectSwitch(columnCount) {
        this.items.forEach((item)=>{
            const value = +(item.getAttribute("data-value") || 1);
            item.classList.toggle("selected", value === columnCount);
        });
    }
    _updateColumnCount(value) {
        const target = this.closest(this.targetSelector);
        if (target) {
            target.style.setProperty(`--gsc-${this._cssVariable}`, value.toString());
            localStorage.setItem(`products-${this._cssVariable}`, value.toString());
        }
    }
    _init() {
        const value = localStorage.getItem(`products-${this._cssVariable}`);
        if (!value || value === "null") return;
        const preparedValue = Number(value);
        if (preparedValue > 0) this.updateByColumnCount(preparedValue);
    }
    _switch(columnCount) {
        this.updateByColumnCount(columnCount);
    }
    reset() {
        if (!this.dataset.default) return;
        this._switch(Number(this.dataset.default));
    }
}
var $d071223971d7ce85$export$2e2bcd8739ae039 = $d071223971d7ce85$var$ColumnSwitcher;




class $b4867be617834799$var$FiltersSubmitBtn extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    connectedCallback() {
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "click", this._handleButtonClick);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "click", this._handleButtonClick);
    }
    _handleButtonClick = ()=>{
        const shop = this.closest("shop-component");
        const sidebar = this.closest("#SidebarFiltersMobile");
        if (shop) {
            const searchParams = [
                shop.filterQuery,
                shop.sortQuery
            ].join("&");
            shop.updateShopBySearchParams(searchParams);
        }
        if (sidebar) sidebar.hide();
    };
}
var $b4867be617834799$export$2e2bcd8739ae039 = $b4867be617834799$var$FiltersSubmitBtn;




class $28ad61296cbc00f2$var$BeforeAfterImages extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._btnSelector = `[data-before-after-images-button]`;
        this._btn = this.querySelector(this._btnSelector);
        this._isMoved = false;
        this._movingStep = 20;
    }
    connectedCallback() {
        this.setSeparatorPosition(Number(this.dataset.initialDragPosition));
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._btn, "keyup", this._handleButtonKeyUp);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._btn, "mousedown", this._handleButtonMouseDown);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(document, "mouseup", this._handleButtonMouseUp);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(document, "mousemove", this._handleMouseMove);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this._btn, "touchstart", this._handleTouchStart);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this, "touchmove", this._handleTouchMove);
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(document, "touchend", this._handleTouchEnd);
    }
    disconnectedCallback() {
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._btn, "keyup", this._handleButtonKeyUp);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._btn, "mousedown", this._handleButtonMouseDown);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(document, "mouseup", this._handleButtonMouseUp);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(document, "mousemove", this._handleMouseMove);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this._btn, "touchstart", this._handleTouchStart);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this, "touchmove", this._handleTouchMove);
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(document, "touchend", this._handleTouchEnd);
    }
    _handleButtonMouseDown = (event)=>{
        event.preventDefault();
        this.startMove();
    };
    _handleButtonMouseUp = ()=>{
        this.endMove();
    };
    _handleMouseMove = (event)=>{
        if (!this._isMoved) return;
        this.moveSeparator(event.pageX);
    };
    _handleButtonKeyUp = (event)=>{
        if (!this._btn) return;
        const currentKey = event.key || event.keyCode;
        const isLeftKey = (0, $eceaf86a082c33f7$export$703c582f38858004)(currentKey);
        const isRightKey = (0, $eceaf86a082c33f7$export$e2fe3643cb517b19)(currentKey);
        if (!isLeftKey && !isRightKey) return;
        const btnRect = this._btn.getBoundingClientRect();
        const btnCenterPoint = btnRect.right - btnRect.width / 2;
        const newPosition = isLeftKey ? btnCenterPoint - this._movingStep : btnCenterPoint + this._movingStep;
        this.moveSeparator(newPosition);
    };
    _handleTouchStart = ()=>{
        this.startMove();
    };
    _handleTouchEnd = ()=>{
        this.endMove();
    };
    _handleTouchMove = (event)=>{
        if (!this._isMoved) return;
        event.preventDefault();
        this.moveSeparator(event.targetTouches[0].clientX);
    };
    startMove() {
        this._isMoved = true;
    }
    endMove() {
        this._isMoved = false;
    }
    setSeparatorPosition(position) {
        this.style.setProperty("--gsc-drag-position", `${position}%`);
    }
    moveSeparator(newPosition) {
        const rect = this.getBoundingClientRect();
        if (newPosition <= rect.left) this.setSeparatorPosition(0);
        else if (newPosition >= rect.right) this.setSeparatorPosition(100);
        else {
            const positionPercent = Math.floor((newPosition - rect.left) / this.offsetWidth * 1000) / 10;
            this.setSeparatorPosition(positionPercent);
        }
    }
}
var $28ad61296cbc00f2$export$2e2bcd8739ae039 = $28ad61296cbc00f2$var$BeforeAfterImages;




class $46be2175d2891e0e$var$ProductInformationDrawer extends (0, $cc5469d7bf7c0ec5$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.viewport = this.element.querySelector("[data-product-information-drawer-viewport]");
    }
    connectedCallback() {
        super.connectedCallback();
        (0, $eceaf86a082c33f7$export$72de9d21dee7d369)(this.viewport, "scroll", this._handleFormScroll);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        (0, $eceaf86a082c33f7$export$ff0ecb8d3a93845b)(this.viewport, "scroll", this._handleFormScroll);
    }
    _handleFormScroll = ()=>{
        if (!this.viewport) return;
        const isScrolled = this.viewport.scrollTop > 0;
        this.toggleAttribute("header-shadow-visible", isScrolled);
    };
}
var $46be2175d2891e0e$export$2e2bcd8739ae039 = $46be2175d2891e0e$var$ProductInformationDrawer;





class $c872d14dabbea55d$var$Tab extends (0, $56a37f05924a778e$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.content = this.querySelector("[data-tabs-element-content]");
        this.transitionDuration = (0, $e6a5d8115fb64fe3$export$5faba83c1624a4ba)(this);
    }
    connectedCallback() {
        this.updateMaxHeight(this.isVisible);
    }
    show() {
        this.setVisible(true);
        return (0, $eceaf86a082c33f7$export$1391212d75b2ee65)(this.transitionDuration);
    }
    hide() {
        this.setVisible(false);
        return (0, $eceaf86a082c33f7$export$1391212d75b2ee65)(this.transitionDuration);
    }
    setVisible(isVisible) {
        this.setAttribute("aria-hidden", isVisible ? "false" : "true");
        this.updateMaxHeight(isVisible);
    }
    updateMaxHeight(isVisible) {
        if (!this.content) return;
        const height = isVisible ? this.content.offsetHeight : 0;
        this.style.maxHeight = `${height}px`;
    }
    get isVisible() {
        return this.getAttribute("aria-hidden") === "false";
    }
}
var $c872d14dabbea55d$export$2e2bcd8739ae039 = $c872d14dabbea55d$var$Tab;


const $1bbb8f0bbe4a0b11$var$components = [
    {
        tag: "login-component",
        component: (0, $0f9b1fcd199567c9$export$2e2bcd8739ae039)
    },
    {
        tag: "back-to-top-button",
        component: (0, $85cf8343cce054a2$export$2e2bcd8739ae039)
    },
    {
        tag: "sticky-cart-button",
        component: (0, $9ee712e29f909c34$export$2e2bcd8739ae039)
    },
    {
        tag: "quantity-component",
        component: (0, $7dd54ea48ed33822$export$2e2bcd8739ae039)
    },
    {
        tag: "quantity-btn",
        component: (0, $affdda50ca21c279$export$2e2bcd8739ae039)
    },
    {
        tag: "localization-selector",
        component: (0, $3645ec850829a73e$export$2e2bcd8739ae039)
    },
    {
        tag: "notification-component",
        component: (0, $cde8b389b4aed8f8$export$2e2bcd8739ae039)
    },
    {
        tag: "tabs-component",
        component: (0, $462d590f11548f00$export$2e2bcd8739ae039)
    },
    {
        tag: "tab-component",
        component: (0, $c872d14dabbea55d$export$2e2bcd8739ae039)
    },
    {
        tag: "list-component",
        component: (0, $0b10a99bea71d582$export$2e2bcd8739ae039)
    },
    {
        tag: "list-btn",
        component: (0, $08381371989a9898$export$2e2bcd8739ae039)
    },
    {
        tag: "float-element",
        component: (0, $d0cc054671c594bc$export$2e2bcd8739ae039)
    },
    {
        tag: "float-element-btn",
        component: (0, $bd45563d04ffcec6$export$2e2bcd8739ae039)
    },
    {
        tag: "dropdown-opener",
        component: (0, $a09efbdcaecab19d$export$2e2bcd8739ae039)
    },
    {
        tag: "tooltip-trigger",
        component: (0, $28393f9f207c46ab$export$2e2bcd8739ae039)
    },
    {
        tag: "accordeon-component",
        component: (0, $4915e32b2b8f0299$export$2e2bcd8739ae039)
    },
    {
        tag: "accordeon-btn",
        component: (0, $8f736ebc63d86dda$export$2e2bcd8739ae039)
    },
    {
        tag: "product-media-tabs",
        component: (0, $ba27785fb9cb3ab9$export$2e2bcd8739ae039)
    },
    {
        tag: "color-swatches",
        component: (0, $a249bc13f11faca0$export$2e2bcd8739ae039)
    },
    {
        tag: "modal-component",
        component: (0, $ec846921809d9add$export$2e2bcd8739ae039)
    },
    {
        tag: "password-modal",
        component: (0, $335ac12974ab4752$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-notification-popup",
        component: (0, $c6fe2e6e54c0399a$export$2e2bcd8739ae039)
    },
    {
        tag: "modal-opener",
        component: (0, $baa3d328c6b64361$export$2e2bcd8739ae039)
    },
    {
        tag: "password-modal-opener",
        component: (0, $e158d692ac96ed15$export$2e2bcd8739ae039)
    },
    {
        tag: "modal-close-btn",
        component: (0, $11698316884f01b7$export$2e2bcd8739ae039)
    },
    {
        tag: "sidebar-button",
        component: (0, $19960a3413ca07cd$export$2e2bcd8739ae039)
    },
    {
        tag: "sidebar-component",
        component: (0, $cc5469d7bf7c0ec5$export$2e2bcd8739ae039)
    },
    {
        tag: "search-sidebar",
        component: (0, $80d19487f0c5c1d0$export$2e2bcd8739ae039)
    },
    {
        tag: "quick-view",
        component: (0, $24d4ac9481bec18a$export$2e2bcd8739ae039)
    },
    {
        tag: "carousel-component",
        component: (0, $1fbcf34fe6e6f853$export$2e2bcd8739ae039)
    },
    {
        tag: "carousel-play-button",
        component: (0, $4328a7aafc445600$export$2e2bcd8739ae039)
    },
    {
        tag: "carousel-dots",
        component: (0, $1c33733b85ca7469$export$2e2bcd8739ae039)
    },
    {
        tag: "carousel-dot",
        component: (0, $7843b352e3449695$export$2e2bcd8739ae039)
    },
    {
        tag: "carousel-btn",
        component: (0, $cbc43b5cf3f16955$export$2e2bcd8739ae039)
    },
    {
        tag: "carousel-progress",
        component: (0, $03c7a98d4300db99$export$2e2bcd8739ae039)
    },
    {
        tag: "header-component",
        component: (0, $7752be30cbaa0b4a$export$2e2bcd8739ae039)
    },
    {
        tag: "drawer-menu",
        component: (0, $175e16ebc295b679$export$2e2bcd8739ae039)
    },
    {
        tag: "drawer-menu-page",
        component: (0, $852602e034d5db4d$export$2e2bcd8739ae039)
    },
    {
        tag: "drawer-menu-page-link",
        component: (0, $a03bb2dc4ff90b66$export$2e2bcd8739ae039)
    },
    {
        tag: "pagination-component",
        component: (0, $8b14e97d6a2de558$export$2e2bcd8739ae039)
    },
    {
        tag: "pagination-load-button",
        component: (0, $439f73167559ba78$export$2e2bcd8739ae039)
    },
    {
        tag: "pagination-link",
        component: (0, $a4b2f5820c603abd$export$2e2bcd8739ae039)
    },
    {
        tag: "pagination-infinite-scroll",
        component: (0, $ca9aa4a2ecd080ca$export$2e2bcd8739ae039)
    },
    {
        tag: "deferred-media",
        component: (0, $ab56719770e828e6$export$2e2bcd8739ae039)
    },
    {
        tag: "pickup-availability",
        component: (0, $56412a68e1de6aa4$export$2e2bcd8739ae039)
    },
    {
        tag: "product-form",
        component: (0, $c983ea34406e93d3$export$2e2bcd8739ae039)
    },
    {
        tag: "product-form-button",
        component: (0, $960285004fafbb25$export$2e2bcd8739ae039)
    },
    {
        tag: "product-block",
        component: (0, $803a7920da112a4a$export$2e2bcd8739ae039)
    },
    {
        tag: "product-model",
        component: (0, $ff1cc270be8c5975$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-item",
        component: (0, $58b56a50cb604a43$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-component",
        component: (0, $cfda6728b6268b3d$export$2e2bcd8739ae039)
    },
    {
        tag: "sidebar-cart",
        component: (0, $0e7c3d37876a0df5$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-free-shipping-bar",
        component: (0, $dccc758ca64395c2$export$2e2bcd8739ae039)
    },
    {
        tag: "product-media",
        component: (0, $1a08cd2f8a220c49$export$2e2bcd8739ae039)
    },
    {
        tag: "product-media-carousel",
        component: (0, $12601885a80a3c0b$export$2e2bcd8739ae039)
    },
    {
        tag: "variant-picker",
        component: (0, $fa06fe8830349112$export$2e2bcd8739ae039)
    },
    {
        tag: "color-swatches-picker",
        component: (0, $c54f7118f91dafe6$export$2e2bcd8739ae039)
    },
    {
        tag: "product-modal",
        component: (0, $57f3cd3e7e93b527$export$2e2bcd8739ae039)
    },
    {
        tag: "product-modal-image-wrap",
        component: (0, $ca49e36245c31056$export$2e2bcd8739ae039)
    },
    {
        tag: "product-modal-opener",
        component: (0, $5b5aa89713cb7074$export$2e2bcd8739ae039)
    },
    {
        tag: "product-recommendations",
        component: (0, $8fc4aeb5718116b8$export$2e2bcd8739ae039)
    },
    {
        tag: "search-sidebar-form-wrapper",
        component: (0, $56b1f5edcb7cb412$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-remove-button",
        component: (0, $387c0d5d6691d2fe$export$2e2bcd8739ae039)
    },
    {
        tag: "clipboard-button",
        component: (0, $b37a9897533b25a7$export$2e2bcd8739ae039)
    },
    {
        tag: "clipboard-button-tooltip",
        component: (0, $a1893a91fba3125e$export$2e2bcd8739ae039)
    },
    {
        tag: "product-card",
        component: (0, $e018bc5cacae9238$export$2e2bcd8739ae039)
    },
    {
        tag: "max-lines-component",
        component: (0, $d29031730d5d0f2b$export$2e2bcd8739ae039)
    },
    {
        tag: "country-selector",
        component: (0, $b13b72248522e8df$export$2e2bcd8739ae039)
    },
    {
        tag: "search-field",
        component: (0, $e9aeff4d9b646381$export$2e2bcd8739ae039)
    },
    {
        tag: "password-field",
        component: (0, $9fd764f29eaa8c8e$export$2e2bcd8739ae039)
    },
    {
        tag: "zoom-cursor",
        component: (0, $153b9a55408e9d60$export$2e2bcd8739ae039)
    },
    {
        tag: "shop-component",
        component: (0, $ecd8a9de0e45f730$export$2e2bcd8739ae039)
    },
    {
        tag: "shop-active-filters",
        component: (0, $67917ca7a79c9799$export$2e2bcd8739ae039)
    },
    {
        tag: "sidebar-filters-desktop",
        component: (0, $2b77ef3fe1ae89fb$export$2e2bcd8739ae039)
    },
    {
        tag: "filters-button-desktop",
        component: (0, $7dfa4d358287d221$export$2e2bcd8739ae039)
    },
    {
        tag: "sidebar-filters-mobile",
        component: (0, $1214535009ee2c26$export$2e2bcd8739ae039)
    },
    {
        tag: "filters-button-mobile",
        component: (0, $d084b2636063bd3f$export$2e2bcd8739ae039)
    },
    {
        tag: "filter-remove-btn",
        component: (0, $1a7a70252d44a5f7$export$2e2bcd8739ae039)
    },
    {
        tag: "sort-list",
        component: (0, $80308934d9447215$export$2e2bcd8739ae039)
    },
    {
        tag: "price-range",
        component: (0, $9cfbdef480257594$export$2e2bcd8739ae039)
    },
    {
        tag: "column-switcher",
        component: (0, $d071223971d7ce85$export$2e2bcd8739ae039)
    },
    {
        tag: "filters-submit-btn",
        component: (0, $b4867be617834799$export$2e2bcd8739ae039)
    },
    {
        tag: "before-after-images",
        component: (0, $28ad61296cbc00f2$export$2e2bcd8739ae039)
    },
    {
        tag: "product-information-drawer",
        component: (0, $46be2175d2891e0e$export$2e2bcd8739ae039)
    }
];
const $1bbb8f0bbe4a0b11$var$defineComponents = ()=>{
    $1bbb8f0bbe4a0b11$var$components.forEach(({ tag: tag , component: component  })=>{
        customElements.define(tag, component);
    });
};
var $1bbb8f0bbe4a0b11$export$2e2bcd8739ae039 = $1bbb8f0bbe4a0b11$var$defineComponents;


(0, $1bbb8f0bbe4a0b11$export$2e2bcd8739ae039)();
window.bodyElement = (0, $0958b1945ad703ab$export$e1122b4c4bd5b838);
(0, $4a662e3b1537df09$export$80e34e3edbb862ab)({
    lazyClass: "yall-video-lazy",
    threshold: 400
});

})();
